@file:OptIn(ExperimentalMaterial3Api::class, ExperimentalFoundationApi::class, ExperimentalLayoutApi::class)

package com.example.monetix.ui.screens

import androidx.compose.animation.*
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsFocusedAsState
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.*
import androidx.compose.material.icons.outlined.Delete
import androidx.compose.material.icons.outlined.Edit
import androidx.compose.material.icons.outlined.VisibilityOff
import androidx.compose.material.icons.outlined.PictureAsPdf
import androidx.compose.material.icons.rounded.Search
import androidx.compose.material3.*
import com.example.monetix.ui.components.MonetixTextField as OutlinedTextField
import androidx.compose.runtime.*
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.blur
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.material3.LocalContentColor
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.zIndex
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.platform.LocalHapticFeedback
import com.example.monetix.TYPE_EXPENSE
import com.example.monetix.TYPE_INCOME
import com.example.monetix.TYPE_TRANSFER
import com.example.monetix.db.AccountEntity
import com.example.monetix.db.CategoryEntity
import com.example.monetix.db.FinancingEntity
import com.example.monetix.db.MonetixDatabase
import com.example.monetix.db.RecurringExpenseEntity
import com.example.monetix.db.SavingsGoalEntity
import com.example.monetix.db.TransactionEntity
import com.example.monetix.normalizeKey
import com.example.monetix.stripSystemMarker
import com.example.monetix.ui.components.TransactionRow
import com.example.monetix.formatEuroFromCents
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.datetime.*
import app.cash.sqldelight.async.coroutines.awaitAsList
import com.example.monetix.utils.autoFaviconUrlForName
import androidx.compose.foundation.basicMarquee
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.outlined.Visibility
import androidx.compose.material.icons.rounded.Add
import androidx.compose.material.icons.rounded.Remove
import androidx.compose.material.icons.rounded.SwapHoriz
import androidx.compose.material.icons.rounded.Savings
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import com.example.monetix.ui.components.TxLogo
import com.example.monetix.utils.FileExporter
import com.example.monetix.ui.dialogs.ExportPdfDialog
import com.example.monetix.ui.dialogs.WebLogoSearchDialog
import com.example.monetix.ui.dialogs.parseDayMonthYearSafe
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.window.Popup
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material.icons.outlined.Info
import androidx.compose.material.icons.rounded.CheckCircle
import androidx.compose.material.icons.rounded.AccountBalance
import androidx.compose.material.icons.rounded.AccountBalanceWallet
import androidx.compose.material.icons.rounded.ArrowDownward
import androidx.compose.material.icons.rounded.ArrowUpward
import androidx.compose.material.icons.rounded.ChevronLeft
import androidx.compose.material.icons.rounded.ChevronRight
import androidx.compose.material.icons.rounded.DeleteForever
import androidx.compose.material.icons.rounded.PendingActions
import androidx.compose.material.icons.rounded.WarningAmber
import com.example.monetix.ui.components.ModernMoneyText
import kotlin.collections.get
import kotlin.random.Random
import com.russhwolf.settings.Settings
import androidx.lifecycle.Lifecycle
import androidx.lifecycle.LifecycleEventObserver
import androidx.lifecycle.compose.LocalLifecycleOwner
import androidx.compose.ui.text.input.PasswordVisualTransformation
import com.example.monetix.db.PiggyBankEntity
import com.example.monetix.ui.theme.getDynamicBalanceColor
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.auth.auth
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.vector.ImageVector
import com.example.monetix.utils.triggerHapticTick
import kotlin.math.abs


// ==========================================
// 🚀 DATABASE SEMANTICO INVISIBILE PER I LOGHI
// ==========================================
private data class TxSmartData(
    val matchKeys: List<String>,
    val domain: String? = null,
    val emoji: String? = null,
    val customUrl: String? = null
)

private val txSmartMerchantsDB = listOf(
    TxSmartData(listOf("lidl", "eurospin", "conad", "coop", "esselunga", "pam", "carrefour", "md", "aldi", "crai", "despar", "famila", "iper", "tigros"), emoji = "🛒"),
    TxSmartData(listOf("macelleria", "panificio", "fruttivendolo", "pescheria"), emoji = "🥩"),
    TxSmartData(listOf("acqua e sapone", "tigota", "tigotà", "cad", "risparmio casa"), emoji = "🧼"),
    TxSmartData(listOf("ikea", "leroy merlin", "brico", "obi", "tecnomat", "maisons du monde"), emoji = "🛋️"),
    TxSmartData(listOf("enel", "eni", "a2a", "iren", "hera", "edison", "sorgenia", "illumia", "plenitude", "nenn", "octopus"), emoji = "⚡"),
    TxSmartData(listOf("tim", "vodafone", "wind", "iliad", "fastweb", "ho mobile", "very mobile", "kena"), emoji = "📱"),
    TxSmartData(listOf("tari", "tasi", "imu", "f24", "agenzia entrate", "pago pa", "pagopa", "bollo"), emoji = "🏛️"),
    TxSmartData(listOf("q8", "eni station", "ip", "tamoil", "esso", "distributore", "benzina", "carburante", "rifornimento"), emoji = "⛽"),
    TxSmartData(listOf("telepass", "unipolmove", "autostrade", "pedaggio"), emoji = "🛣️"),
    TxSmartData(listOf("trenitalia", "italo", "atm", "atac", "cotral", "ryanair", "easyjet", "wizzair", "ita airways", "biglietto"), emoji = "🚆"),
    TxSmartData(listOf("uber", "bolt", "freenow", "taxi"), emoji = "🚕"),
    TxSmartData(listOf("amazon", "amzn", "prime"), domain = "amazon.it"),
    TxSmartData(listOf("shein", "temu", "aliexpress", "ebay"), emoji = "📦"),
    TxSmartData(listOf("zara", "vinted", "asos", "h&m", "nike", "adidas", "primark", "ovs", "intimissimi", "calzedonia"), emoji = "👕"),
    TxSmartData(listOf("netflix", "disney", "prime video", "now tv", "dazn", "infinity"), domain = "netflix.com"),
    TxSmartData(listOf("spotify", "apple music", "youtube premium"), emoji = "🎵"),
    TxSmartData(listOf("playstation", "xbox", "nintendo", "steam", "epic games", "videogioco"), emoji = "🎮"),
    TxSmartData(listOf("mcdonalds", "mc donald", "burger king", "kfc", "roadhouse", "old wild west", "dominos"), emoji = "🍔"),
    TxSmartData(listOf("deliveroo", "just eat", "glovo", "uber eats"), emoji = "🛵"),
    TxSmartData(listOf("bar", "pasticceria", "caffetteria", "starbucks", "colazione", "caffè", "cornetto"), emoji = "☕"),
    TxSmartData(listOf("pizzeria", "ristorante", "trattoria", "osteria", "cena", "pranzo", "sushi", "pokè"), emoji = "🍽️"),
    TxSmartData(listOf("farmacia", "parafarmacia", "farmacosmo"), emoji = "💊"),
    TxSmartData(listOf("dentista", "medico", "visita", "ospedale", "asl", "ticket", "esami"), emoji = "⚕️"),
    TxSmartData(listOf("stipendio", "busta paga", "salario"), emoji = "💶"),
    TxSmartData(listOf("bonifico", "giroconto"), emoji = "📥"),
    TxSmartData(listOf("rimborso", "cashback", "reso"), emoji = "🔄"),
    TxSmartData(listOf("regalo", "mancia"), emoji = "🎁")
)

private val txDefaultCreditors = listOf(
    TxSmartData(listOf("findomestic"), "findomestic.it"),
    TxSmartData(listOf("compass"), "compass.it"),
    TxSmartData(listOf("agos"), "agos.it"),
    TxSmartData(listOf("younited"), "younited-credit.com"),
    TxSmartData(listOf("cofidis"), "cofidis.it"),
    TxSmartData(listOf("santander"), "santanderconsumer.it"),
    TxSmartData(listOf("fiditalia"), "fiditalia.it"),
    TxSmartData(listOf("prestipay"), "prestipay.it"),
    TxSmartData(listOf("ca auto bank"), "ca-autobank.it"),
    TxSmartData(listOf("sella personal credit"), "sellapersonalcredit.it"),
    TxSmartData(listOf("intesa sanpaolo"), "intesasanpaolo.com"),
    TxSmartData(listOf("unicredit"), "unicredit.it"),
    TxSmartData(listOf("bnl"), "bnl.it"),
    TxSmartData(listOf("poste italiane", "libretto postale", "postepay"), "poste.it"),
    TxSmartData(listOf("paypal"), customUrl = "https://logo.clearbit.com/paypal.com"),
    TxSmartData(listOf("klarna"), customUrl = "https://logo.clearbit.com/klarna.com"),
    TxSmartData(listOf("scalapay"), "scalapay.com"),
    TxSmartData(listOf("clearpay"), "clearpay.com"),
    TxSmartData(listOf("volkswagen"), "vwfs.it")
)

// --- HELPER PER DATE IN ITALIANO ---
private val mesi = listOf("Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre")
private val mesiShort = listOf("Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic")

private fun formatMonthYear(date: LocalDate): String = "${mesi[date.monthNumber - 1]} ${date.year}"
private fun formatShortMonthYear(date: LocalDate): String = "${mesiShort[date.monthNumber - 1]} ${date.year}"
private fun formatFullDate(date: LocalDate): String = "${date.dayOfMonth} ${mesi[date.monthNumber - 1]} ${date.year}"
private fun formatDayMonth(date: LocalDate): String = "${date.dayOfMonth.toString().padStart(2, '0')} ${mesiShort[date.monthNumber - 1]}"

private fun shiftMonth(date: LocalDate, months: Int): LocalDate {
    var newMonth = date.monthNumber + months
    var newYear = date.year
    while (newMonth > 12) { newMonth -= 12; newYear++ }
    while (newMonth < 1) { newMonth += 12; newYear-- }
    return LocalDate(newYear, newMonth, 1)
}

@OptIn(ExperimentalFoundationApi::class, ExperimentalMaterial3Api::class)
@Composable
fun TransactionsScreen(
    db: MonetixDatabase,
    allTransactions: List<TransactionEntity>,
    modifier: Modifier = Modifier,
    availableBalanceCents: Long,
    hideBalances: Boolean = false,
    hiddenAccountIds: Set<String> = emptySet(),
    latest: List<TransactionEntity>,
    payPeriodStart: LocalDate,
    payPeriodEnd: LocalDate,
    onEdit: (TransactionEntity) -> Unit,
    onDelete: (TransactionEntity) -> Unit,
    onDeleteMultiple: (List<TransactionEntity>) -> Unit,
    onAddMovement: (String) -> Unit,
    onAddFavorite: (TransactionEntity) -> Unit,
    onHide: (TransactionEntity) -> Unit,
    onUnhide: (TransactionEntity) -> Unit,
    onSaveTransaction: (TransactionEntity) -> Unit,
    accounts: List<AccountEntity>,
    accountBalancesById: Map<String, Long>,
    categories: List<CategoryEntity>,
    activeAccountId: String?,
    financings: List<FinancingEntity> = emptyList(),
    recurringItems: List<RecurringExpenseEntity> = emptyList(),
    savingsGoals: List<SavingsGoalEntity> = emptyList(),
    piggyBanks: List<PiggyBankEntity> = emptyList(),
    savingsAccountIds: Set<String> = emptySet(),
    globalSearchQuery: String = "",
    targetTxId: String? = null,
    onTargetTxConsumed: () -> Unit = {},
    hiddenJumpRequest: Int = 0,
    hiddenJumpActive: Boolean = false,
    onToggleHideBalances: () -> Unit,
    fileExporter: FileExporter? = null,
    onPopupStateChanged: (Boolean) -> Unit = {},
    onBack: () -> Unit = {},
    onLogoutRequest: () -> Unit = {}
) {
    val listState = rememberLazyListState()
    val scope = rememberCoroutineScope()
    var localHideBalances by remember(hideBalances) { mutableStateOf(hideBalances) }

    val brandPrimary = MaterialTheme.colorScheme.primary

    // 🚀 MOTORE DELLA COLLAPSING TOOLBAR E FEEDBACK TATTILI
    val isCollapsed by remember { derivedStateOf { listState.firstVisibleItemIndex > 0 || listState.firstVisibleItemScrollOffset > 50 } }
    val haptic = LocalHapticFeedback.current

    val getSavingsForBank = { bankId: String ->
        latest.filter { it.merchantKey?.contains(bankId) == true }
    }

    val today = Clock.System.todayIn(TimeZone.currentSystemDefault())
    val todayEpoch = today.toEpochDays().toLong()
    var selectedFilterAccountId by remember(activeAccountId) { mutableStateOf(activeAccountId) }


    // 🚀 GESTIONE RISPARMI E SALVADANAI E CONTANTI (Filtro e Conteggio)
    var showSavingsSheet by rememberSaveable { mutableStateOf(false) }
    var showAddGenericSavings by rememberSaveable { mutableStateOf(false) }
    var showHiddenSheet by rememberSaveable { mutableStateOf(false) }
    var showCashExceededWarning by remember { mutableStateOf(false) }

    // 🚀 NUOVI STATI PER LA GESTIONE CONTANTI ISOLATA
    var showCashSheet by rememberSaveable { mutableStateOf(false) }
    var showAddGenericCash by rememberSaveable { mutableStateOf(false) }
    var txToVaporize by remember { mutableStateOf<TransactionEntity?>(null) }
    val snackbarHostState = remember { SnackbarHostState() }

    // 🚀 REGOLA UNIVERSALE PER RICONOSCERE I CONTANTI (A prova di bomba)
    fun isCashSubTx(tx: TransactionEntity): Boolean {
        val key = (tx.merchantKey ?: "").lowercase()
        val desc = (tx.description ?: "").lowercase()
        return tx.id.startsWith("tx_cash_") ||
                tx.accountId?.startsWith("sys_cash_") == true ||
                key.contains("[cash:") ||
                desc.contains("[cash:")
    }

// 🚀 MOVIMENTI RISPARMIO: GIA' AVVENUTI (Oggi e Passato)
    val savingsFilteredPast = remember(latest, selectedFilterAccountId, todayEpoch) {
        latest.filter { tx ->
            !tx.isDeleted && !tx.isHidden && tx.categoryId != "sys_vaporized" &&
                    isSavingsTx(tx) &&
                    tx.dateEpochDay <= todayEpoch &&
                    (selectedFilterAccountId == null || tx.accountId == selectedFilterAccountId || tx.fromAccountId == selectedFilterAccountId)
        }.sortedByDescending { it.dateEpochDay }
    }

    // 🚀 MOVIMENTI RISPARMIO: IN ARRIVO (Futuro)
    val savingsFilteredFuture = remember(latest, selectedFilterAccountId, todayEpoch) {
        latest.filter { tx ->
            !tx.isDeleted && !tx.isHidden && tx.categoryId != "sys_vaporized" &&
                    isSavingsTx(tx) &&
                    tx.dateEpochDay > todayEpoch &&
                    (selectedFilterAccountId == null || tx.accountId == selectedFilterAccountId || tx.fromAccountId == selectedFilterAccountId)
        }.sortedBy { it.dateEpochDay } // 👈 Nota: ordinati in modo crescente per il futuro
    }

    // 🚀 CALCOLO SALDO SALVADANAI E PAC (Totalmente allineato e corretto con gli sblocchi e le basi di partenza)
    val totalSavingsCents = remember(latest, savingsGoals, piggyBanks, selectedFilterAccountId, todayEpoch) {
        val totalSogni = savingsGoals.filter { !it.isDeleted && !it.isCompleted }.sumOf { goal ->
            latest.filter { tx ->
                !tx.isDeleted &&
                        tx.dateEpochDay <= todayEpoch &&
                        (tx.merchantKey?.contains("[goal:${goal.id}]") == true ||
                                tx.merchantKey?.contains("[sav:${goal.id}]") == true ||
                                tx.merchantKey?.contains("[pac_sav:${goal.id}]") == true) &&
                        (selectedFilterAccountId == null || tx.accountId == selectedFilterAccountId || tx.fromAccountId == selectedFilterAccountId || tx.accountId == "salvadanaio_virtuale" || tx.fromAccountId == "salvadanaio_virtuale" || tx.accountId == "sys_ghost") // 🚀 FIX: ORA CONTEGGIA ANCHE LA BASE DI PARTENZA
            }.fold(0L) { acc, tx ->
                val isDeposit = (tx.type == "EXPENSE" && tx.amountCents > 0) || (tx.type == "TRANSFER" && tx.fromAccountId != "salvadanaio_virtuale")
                val isWithdrawal = tx.type == "EXPENSE" && tx.amountCents < 0
                val isTransferOut = tx.type == "TRANSFER" && tx.fromAccountId == "salvadanaio_virtuale"
                val isIncomeUnlock = tx.type == "INCOME"

                acc + when {
                    isDeposit -> tx.amountCents
                    isWithdrawal -> tx.amountCents
                    isTransferOut -> -tx.amountCents
                    isIncomeUnlock -> -tx.amountCents
                    else -> 0L
                }
            }.coerceAtLeast(0L)
        }

        val totalSalva = piggyBanks.filter { !it.isDeleted }.sumOf { bank ->
            latest.filter { tx ->
                !tx.isDeleted &&
                        tx.dateEpochDay <= todayEpoch &&
                        tx.merchantKey?.contains("[pb:${bank.id}]") == true &&
                        (selectedFilterAccountId == null || tx.accountId == selectedFilterAccountId || tx.fromAccountId == selectedFilterAccountId || tx.accountId == "salvadanaio_virtuale" || tx.fromAccountId == "salvadanaio_virtuale" || tx.accountId == "sys_ghost") // 🚀 FIX: ORA CONTEGGIA ANCHE LA BASE DI PARTENZA
            }.fold(0L) { acc, tx ->
                val isDeposit = (tx.type == "EXPENSE" && tx.amountCents > 0) || (tx.type == "TRANSFER" && tx.fromAccountId != "salvadanaio_virtuale")
                val isWithdrawal = tx.type == "EXPENSE" && tx.amountCents < 0
                val isTransferOut = tx.type == "TRANSFER" && tx.fromAccountId == "salvadanaio_virtuale"
                val isIncomeUnlock = tx.type == "INCOME"

                acc + when {
                    isDeposit -> tx.amountCents
                    isWithdrawal -> tx.amountCents
                    isTransferOut -> -tx.amountCents
                    isIncomeUnlock -> -tx.amountCents
                    else -> 0L
                }
            }.coerceAtLeast(0L)
        }

        totalSogni + totalSalva
    }
    // 🚀 GESTIONE NUOVO PORTAFOGLIO CONTANTI (Totalmente Sicuro per KMP)
    val allCashTxs = remember(latest) {
        // 🚀 FIX 2: Scudo anti-vaporizzati nella lista della card Verde!
        latest.filter { !it.isDeleted && !it.isHidden && it.categoryId != "sys_vaporized" && isCashSubTx(it) }.sortedByDescending { it.dateEpochDay }
    }

    val netCashInPocket = remember(latest, todayEpoch) {
        latest.filter { !it.isDeleted && isCashSubTx(it) && it.dateEpochDay <= todayEpoch }
            .fold(0L) { acc, tx ->
                val amt = if (tx.amountCents < 0L) -tx.amountCents else tx.amountCents
                when (tx.type) {
                    "INCOME" -> acc + amt
                    "EXPENSE" -> acc - amt
                    "TRANSFER" -> {
                        if (tx.fromAccountId?.startsWith("sys_cash_") == true) acc - amt
                        else acc + amt
                    }
                    else -> acc - amt
                }
            }.coerceAtLeast(0L)
    }


// 🚀 NUOVA MAPPA PER I DI CUI IN CONTANTI (Ignora maiuscole/minuscole)
    val subExpensesMap = remember(allTransactions) {
        val map = mutableMapOf<String, MutableList<TransactionEntity>>()
        val cashRegex = Regex("\\[cash:([^\\]]+)\\]", RegexOption.IGNORE_CASE)
        allTransactions.forEach { subTx ->
            // 🚀 FIX 1: Escludiamo categoricamente i vaporizzati e i nascosti dai "di cui"!
            if (!subTx.isDeleted && !subTx.isHidden && subTx.categoryId != "sys_vaporized") {
                val match = cashRegex.find(subTx.description ?: "") ?: cashRegex.find(subTx.merchantKey ?: "")
                if (match != null) {
                    val parentId = match.groupValues[1]
                    map.getOrPut(parentId) { mutableListOf() }.add(subTx)
                }
            }
        }
        map.forEach { (_, list) -> list.sortByDescending { it.createdAtEpochMs } }
        map
    }

    var quickSubTransactionsTx by remember { mutableStateOf<TransactionEntity?>(null) }

    // =======================================================
    // 🚀 STATI PER LA SELEZIONE MULTIPLA E CONTANTI
    // =======================================================
    var selectionMode by rememberSaveable { mutableStateOf(false) }
    val selectedTxIds = remember { mutableStateListOf<String>() }

    // 🚀 STATI PER FANTASMI E CAMBIO CONTO RAPIDO
    var showGhostSheet by rememberSaveable { mutableStateOf(false) }
    var targetChangeAccountTxIds by remember { mutableStateOf<List<String>?>(null) }
    var txToHide by remember { mutableStateOf<TransactionEntity?>(null) }
    var txToShow by remember { mutableStateOf<TransactionEntity?>(null) }
    var showMultiDeleteConfirm by rememberSaveable { mutableStateOf(false) }
    var showMultiVaporizeConfirm by rememberSaveable { mutableStateOf(false) }
    var showMultiHideConfirm by rememberSaveable { mutableStateOf(false) }
    var showMultiExportDialog by rememberSaveable { mutableStateOf(false) }
    var targetCashTxId by rememberSaveable { mutableStateOf<String?>(null) }

    val toggleSelection: (String) -> Unit = { id ->
        if (selectedTxIds.contains(id)) {
            selectedTxIds.remove(id)
            if (selectedTxIds.isEmpty()) selectionMode = false
        } else {
            selectedTxIds.add(id)
        }
    }

    val clearSelection = {
        selectedTxIds.clear()
        selectionMode = false
    }

    var loadedFinancings by remember(financings) { mutableStateOf(financings) }
    var loadedRecurring by remember(recurringItems) { mutableStateOf(recurringItems) }

    LaunchedEffect(Unit) {
        if (loadedFinancings.isEmpty()) {
            try { loadedFinancings = db.financingQueries.all().awaitAsList() } catch (e: Exception) {}
        }
        if (loadedRecurring.isEmpty()) {
            try { loadedRecurring = db.recurringExpenseQueries.all().awaitAsList() } catch (e: Exception) {}
        }
    }

    var isHeaderExpanded by rememberSaveable { mutableStateOf(false) }
    var isSearchActive by rememberSaveable { mutableStateOf(false) }
    var showExportDialog by rememberSaveable { mutableStateOf(false) }
    var includeHiddenInExport by rememberSaveable { mutableStateOf(false) }

    var localSearchQueryValue by rememberSaveable(stateSaver = TextFieldValue.Saver) { mutableStateOf(TextFieldValue(globalSearchQuery)) }
    val searchInteractionSource = remember { MutableInteractionSource() }
    val isSearchFocused by searchInteractionSource.collectIsFocusedAsState()

    LaunchedEffect(isSearchFocused) {
        if (isSearchFocused) localSearchQueryValue = TextFieldValue("", TextRange.Zero)
    }

    // 🚀 STATI PER IL PIN PAD E AUTO-LOCK
    val settings = remember { Settings() }
    var savedPin by remember { mutableStateOf(settings.getString("vault_pin", "")) }
    var isVaultUnlocked by rememberSaveable { mutableStateOf(false) }

    // 🚀 SCARICA IL PIN DA FIREBASE IN TEMPO REALE USANDO L'HELPER
    LaunchedEffect(Unit) {
        println("🕵️ SPIA UI: Avvio ascolto in tempo reale del PIN da Firebase...")
        val helper = com.example.monetix.db.FirestoreHelper()

        helper.getPreferenze().collect { prefs ->
            if (prefs != null) {
                val cloudPin = prefs.vaultPin ?: ""
                println("🕵️ SPIA UI: Ricevuto aggiornamento! PIN Cloud: '$cloudPin' | PIN Locale Attuale: '$savedPin'")

                if (cloudPin.isNotEmpty() && cloudPin != savedPin) {
                    println("🕵️ SPIA UI: SINCRONIZZO! Salvo il PIN cloud nel dispositivo locale.")
                    settings.putString("vault_pin", cloudPin)
                    savedPin = cloudPin // Si auto-sblocca/imposta sul nuovo dispositivo!
                } else if (cloudPin.isEmpty() && savedPin.isNotEmpty()) {
                    println("🕵️ SPIA UI: RESET! Il cloud è vuoto, rimuovo il PIN locale.")
                    settings.remove("vault_pin")
                    savedPin = "" // Se lo resetti altrove, sparisce anche qui
                }
            } else {
                println("🕵️ SPIA UI: ATTENZIONE, le preferenze ricevute sono NULLE!")
            }
        }
    }

    var showPinDialog by rememberSaveable { mutableStateOf(false) }
    var pinFlowMode by remember { mutableStateOf("ENTER") }
    var tempPin by remember { mutableStateOf("") }
    var pinInput by remember { mutableStateOf("") }
    var pinError by remember { mutableStateOf("") }
    var showForgotPinDialog by rememberSaveable { mutableStateOf(false) }

    val lifecycleOwner = LocalLifecycleOwner.current
    DisposableEffect(lifecycleOwner) {
        val observer = LifecycleEventObserver { _, event ->
            if (event == Lifecycle.Event.ON_PAUSE || event == Lifecycle.Event.ON_STOP) {
                isVaultUnlocked = false // Sigilla il vault in background
                showPinDialog = false
            }
        }
        lifecycleOwner.lifecycle.addObserver(observer)
        onDispose { lifecycleOwner.lifecycle.removeObserver(observer) }
    }

    if (showPinDialog) {
        AlertDialog(
            onDismissRequest = {
                showPinDialog = false
                pinInput = ""
                pinError = ""
            },
            title = {
                Text(
                    when (pinFlowMode) {
                        "ENTER" -> "Sincronizzazione Archivi"
                        "SETUP1" -> "Crea Codice Operatore"
                        "SETUP2" -> "Conferma Codice"
                        "CHANGE_OLD" -> "Cambio Codice: Vecchio PIN"
                        "CHANGE_NEW1" -> "Cambio Codice: Nuovo PIN"
                        "CHANGE_NEW2" -> "Cambio Codice: Conferma"
                        else -> "Sicurezza"
                    },
                    fontWeight = FontWeight.Bold
                )
            },
            text = {
                Column {
                    Text(
                        when (pinFlowMode) {
                            "ENTER" -> "Inserisci il codice operatore a 4 cifre per accedere."
                            "SETUP1", "CHANGE_NEW1" -> "Scegli un nuovo PIN di 4 cifre. Non dimenticarlo!"
                            "SETUP2", "CHANGE_NEW2" -> "Reinserisci il nuovo PIN per confermare."
                            "CHANGE_OLD" -> "Inserisci il tuo PIN attuale per autorizzare il cambio."
                            else -> ""
                        },
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                    Spacer(Modifier.height(16.dp))
                    OutlinedTextField(
                        value = pinInput,
                        onValueChange = {
                            if (it.length <= 4 && it.all { c -> c.isDigit() }) {
                                pinInput = it
                                pinError = ""
                                if (it.length == 4) {
                                    when (pinFlowMode) {
                                        "ENTER" -> {
                                            if (it == savedPin || (savedPin.isEmpty() && it == "0000")) {
                                                isVaultUnlocked = true
                                                showPinDialog = false
                                                pinInput = ""
                                            } else {
                                                pinError = "Codice errato."
                                                pinInput = ""
                                                haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                                            }
                                        }
                                        "SETUP1", "CHANGE_NEW1" -> {
                                            tempPin = it
                                            pinInput = ""
                                            pinFlowMode = if (pinFlowMode == "SETUP1") "SETUP2" else "CHANGE_NEW2"
                                        }
                                        "SETUP2", "CHANGE_NEW2" -> {
                                            if (it == tempPin) {
                                                settings.putString("vault_pin", it)
                                                savedPin = it
                                                isVaultUnlocked = true
                                                showPinDialog = false
                                                pinInput = ""

                                                // 🚀 SALVA IL PIN SU FIREBASE PER LA SINCRONIZZAZIONE GLOBALE
                                                scope.launch(Dispatchers.Default) {
                                                    com.example.monetix.db.FirestoreHelper().salvaPinVault(it)
                                                }
                                            } else {
                                                pinError = "I PIN non corrispondono. Riprova."
                                                pinInput = ""
                                                pinFlowMode = if (pinFlowMode == "SETUP2") "SETUP1" else "CHANGE_NEW1"
                                                haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                                            }
                                        }
                                        "CHANGE_OLD" -> {
                                            if (it == savedPin || (savedPin.isEmpty() && it == "0000")) {
                                                pinInput = ""
                                                pinFlowMode = "CHANGE_NEW1"
                                            } else {
                                                pinError = "PIN attuale errato."
                                                pinInput = ""
                                                haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        visualTransformation = PasswordVisualTransformation(),
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.NumberPassword),
                        isError = pinError.isNotEmpty(),
                        singleLine = true,
                        shape = RoundedCornerShape(12.dp),
                        label = { Text("Codice a 4 cifre") }
                    )
                    if (pinError.isNotEmpty()) {
                        Text(pinError, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.labelSmall, modifier = Modifier.padding(top = 4.dp))
                    }

                    if (pinFlowMode == "ENTER" && savedPin.isNotEmpty()) {
                        Column(
                            modifier = Modifier.fillMaxWidth().padding(top = 16.dp),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            TextButton(
                                onClick = {
                                    pinInput = ""
                                    pinError = ""
                                    pinFlowMode = "CHANGE_OLD"
                                }
                            ) {
                                Text("Cambia Codice", fontSize = 12.sp)
                            }

                            TextButton(
                                onClick = { showForgotPinDialog = true }
                            ) {
                                Text("Codice dimenticato?", fontSize = 12.sp, color = MaterialTheme.colorScheme.error)
                            }
                        }
                    }
                }
            },
            confirmButton = {},
            dismissButton = {
                TextButton(onClick = {
                    showPinDialog = false
                    pinInput = ""
                    pinError = ""
                }) { Text("ANNULLA", color = MaterialTheme.colorScheme.onSurfaceVariant) }
            },
            containerColor = MaterialTheme.colorScheme.surface,
            shape = RoundedCornerShape(24.dp)
        )
    }
    // 🚀 POPUP MASTER RESET
    if (showForgotPinDialog) {
        AlertDialog(
            onDismissRequest = { showForgotPinDialog = false },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Default.Warning, contentDescription = null, tint = Color(0xFFEF4444), modifier = Modifier.size(24.dp))
                    Spacer(Modifier.width(8.dp))
                    Text("Reset di Sicurezza", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color(0xFFEF4444))
                }
            },
            text = { Text("Per proteggere i tuoi dati, resettare il codice segreto richiede la disconnessione (Logout) dal tuo account.\n\nVuoi uscire dall'app ora? Al prossimo accesso potrai impostare un nuovo PIN.", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0)) },
            confirmButton = {
                Button(
                    onClick = {
                        showForgotPinDialog = false
                        showPinDialog = false
                        settings.remove("vault_pin") // 🚀 CANCELLA IL PIN LOCALMENTE

                        // 🚀 RIMUOVE IL PIN DA FIREBASE TRAMITE L'HELPER
                        scope.launch(Dispatchers.Default) {
                            com.example.monetix.db.FirestoreHelper().salvaPinVault("")
                        }

                        onLogoutRequest() // 🚀 FORZA L'USCITA DALL'APP
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFEF4444), contentColor = Color.White)
                ) {
                    Text("ESCI E RESETTA", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = {
                TextButton(onClick = { showForgotPinDialog = false }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) }
            }
        )
    }

    var selectedMonth by remember { mutableStateOf(LocalDate(today.year, today.monthNumber, 1)) }

    // 🚀 CALCOLO MOVIMENTI FANTASMA IN SOSPESO (Nascosti o <= Oggi)
    val actionableGhostsCount = remember(latest, todayEpoch, selectedFilterAccountId) {
        latest.count { tx ->
            if (tx.isDeleted) return@count false

            // 1. Escludiamo i sotto-movimenti in contanti e i salvadanai
            val isCash = tx.description?.contains("[cash:") == true || tx.merchantKey?.contains("[cash:") == true
            if (isCash || isSavingsTx(tx)) return@count false

            // 2. Rispettiamo il filtro del conto (selezionato in alto)
            val matchesAccount = selectedFilterAccountId == null ||
                    tx.accountId == selectedFilterAccountId || tx.accountId == "sys_ghost_$selectedFilterAccountId" || tx.accountId == "sys_ghost_tracker_account" ||
                    tx.fromAccountId == selectedFilterAccountId || tx.fromAccountId == "sys_ghost_$selectedFilterAccountId" || tx.fromAccountId == "sys_ghost_tracker_account" ||
                    tx.toAccountId == selectedFilterAccountId || tx.toAccountId == "sys_ghost_$selectedFilterAccountId" || tx.toAccountId == "sys_ghost_tracker_account"

            if (!matchesAccount) return@count false

            // 3. Verifichiamo se è un vero fantasma
            val isGhostTx = tx.accountId?.startsWith("sys_ghost_") == true ||
                    tx.fromAccountId?.startsWith("sys_ghost_") == true ||
                    tx.toAccountId?.startsWith("sys_ghost_") == true ||
                    tx.accountId == "sys_ghost_tracker_account"

            // È "in sospeso" se è fantasma e: o è nascosto, o la sua data è arrivata (oggi o passato)
            isGhostTx && (tx.isHidden || tx.dateEpochDay <= todayEpoch)
        }
    }
    var detailsTransaction by remember { mutableStateOf<TransactionEntity?>(null) }
    // 🚀 AGGIUNGI QUESTA RIGA PER LA MEMORIA DEL TELETRASPORTO:
    var previousDetailsTransaction by remember { mutableStateOf<TransactionEntity?>(null) }
    var transactionToDelete by remember { mutableStateOf<TransactionEntity?>(null) }
    var groupDetailsTransactions by remember { mutableStateOf<List<TransactionEntity>?>(null) }
    var dayTransactionsToDelete by remember { mutableStateOf<List<TransactionEntity>?>(null) }
    var dayDateToDelete by remember { mutableStateOf<LocalDate?>(null) }

    // 🚀 STATI PER IL RIEPILOGO GIORNALIERO
    var daySummaryDate by remember { mutableStateOf<LocalDate?>(null) }
    var daySummaryItems by remember { mutableStateOf<List<TransactionEntity>?>(null) }
    val categoryNameById = remember(categories) { categories.associate { it.id to it.name } }

    val accountNameById = remember(accounts) {
        val map = mutableMapOf<String, String>()
        accounts.forEach {
            val cleanName = stripSystemMarker(it.name) ?: it.name
            map[it.id] = cleanName
            map["sys_ghost_${it.id}"] = cleanName
            map["sys_ghost_tracker_account"] = "Promemoria"
        }
        map
    }

    val handleHideToggle: (TransactionEntity, Boolean) -> Unit = { tx, hide ->
        val originalTx = latest.find { it.id == tx.id } ?: tx
        val updatedTx = originalTx.copy(isHidden = hide, updatedAtEpochMs = Clock.System.now().toEpochMilliseconds())

        scope.launch(Dispatchers.Default) {
            db.transactionQueries.upsert(
                id = updatedTx.id, accountId = updatedTx.accountId, toAccountId = updatedTx.toAccountId, fromAccountId = updatedTx.fromAccountId,
                amountCents = updatedTx.amountCents, type = updatedTx.type, dateEpochDay = updatedTx.dateEpochDay, categoryId = updatedTx.categoryId,
                description = updatedTx.description, merchantKey = updatedTx.merchantKey, subcategoryText = updatedTx.subcategoryText,
                logoEmoji = updatedTx.logoEmoji, logoUri = updatedTx.logoUri, isHidden = updatedTx.isHidden, isDeleted = updatedTx.isDeleted, reminderDays = updatedTx.reminderDays,
                createdAtEpochMs = updatedTx.createdAtEpochMs, updatedAtEpochMs = updatedTx.updatedAtEpochMs
            )
        }

        if (hide) {
            onHide(updatedTx)
        } else {
            onUnhide(updatedTx)
        }
    }

    fun matchesQuery(tx: TransactionEntity, qRaw: String): Boolean {
        val queryStr = qRaw.replace(",", ".").trim()
        val qTokens = queryStr.lowercase().split(" ").filter { it.isNotBlank() }
        if (qTokens.isEmpty()) return true

        val absCents = if (tx.amountCents < 0) -tx.amountCents else tx.amountCents
        val formattedAmount = "${absCents / 100}.${(absCents % 100).toString().padStart(2, '0')}"
        val catName = categoryNameById[tx.categoryId] ?: ""

        val hay = listOf(
            tx.description ?: "",
            tx.merchantKey ?: "",
            catName,
            tx.subcategoryText ?: "",
            formattedAmount
        ).joinToString(" ").lowercase()

        return qTokens.all { token -> hay.contains(token) }
    }

    fun getSmartLogo(name: String): Pair<String?, String?> {
        val cleanName = " ${name.lowercase()} ".replace(Regex("[^a-z0-9]"), " ")

        val smartMatch = txSmartMerchantsDB.firstOrNull { m -> m.matchKeys.any { key -> cleanName.contains(" $key ") } }
            ?: txDefaultCreditors.firstOrNull { m -> m.matchKeys.any { key -> cleanName.contains(" $key ") } }

        val emojiOut = smartMatch?.emoji
        val uriOut = smartMatch?.customUrl
            ?: smartMatch?.domain?.let { "https://icon.horse/icon/$it" }
            ?: if (emojiOut == null) autoFaviconUrlForName(name) else null

        return Pair(emojiOut, uriOut)
    }

    fun enhanceTransaction(tx: TransactionEntity): TransactionEntity {
        val desc = tx.description ?: ""
        val merchant = tx.merchantKey ?: ""

        val recId = Regex("\\[rec:([^\\]]+)\\]").find(desc)?.groupValues?.get(1)
            ?: Regex("\\[rec:([^\\]]+)\\]").find(merchant)?.groupValues?.get(1)

        val finId = Regex("\\[fin:([^\\]]+)\\]").find(desc)?.groupValues?.get(1)
            ?: Regex("\\[fin:([^\\]]+)\\]").find(merchant)?.groupValues?.get(1)

        // 1. TROVA L'ID DEL MOVIMENTO PADRE
        val parentId = Regex("\\[p:([^\\]]+)\\]").find(desc)?.groupValues?.get(1)
            ?: Regex("\\[p:([^\\]]+)\\]").find(merchant)?.groupValues?.get(1)

        // Entrambi 'var' per poterli manipolare a nostro piacimento
        var cleanDesc = desc.replace(Regex("\\[.*?\\]"), "").trim()
        var cleanMerchant = merchant.replace(Regex("\\[.*?\\]"), "").trim()

        // 🚀 2. CAPIAMO SUBITO SE È UN SALVADANAIO O UN SOGNO (A prescindere se c'è un padre o no)
        val isPiggyBank = merchant.contains("[pb:", ignoreCase = true) || desc.contains("[pb:", ignoreCase = true) ||
                merchant.contains("Salvadanaio", ignoreCase = true) || desc.contains("Arrotondamento", ignoreCase = true)

        if (isPiggyBank) {
            // Cerchiamo di capire chi è l'esercente
            var parentName: String? = null

            if (parentId != null) {
                val parentTx = allTransactions.find { it.id == parentId }
                if (parentTx != null) {
                    parentName = parentTx.merchantKey?.replace(Regex("\\[.*?\\]"), "")?.replace(" 👻 (Promemoria)", "")?.trim()?.takeIf { it.isNotBlank() }
                        ?: parentTx.description?.replace(Regex("\\[.*?\\]"), "")?.replace(" 👻 (Promemoria)", "")?.trim()
                }
            }

            // 🚀 LA MAGIA MINIMALISTA: Applichiamo le scritte pulite!
            if (parentName != null && parentName.isNotBlank() && parentName.uppercase() != "SPESA") {
                cleanMerchant = "Arrotondamento: $parentName"
            } else {
                cleanMerchant = "Arrotondamento Automatico" // 👈 Ecco cosa scriviamo se manca l'esercente!
            }
            cleanDesc = "" // 👈 CANCELLIAMO IL SOTTOTITOLO (via "Salvadanaio: Conserviamo")

        } else if (parentId != null) {
            // 3. COMPORTAMENTO NORMALE PER FIGLI NON-SALVADANAIO (Es. Rimborsi o storni su altre spese)
            val parentTx = allTransactions.find { it.id == parentId }
            if (parentTx != null) {
                val parentName = parentTx.merchantKey?.replace(Regex("\\[.*?\\]"), "")?.replace(" 👻 (Promemoria)", "")?.trim()?.takeIf { it.isNotBlank() }
                    ?: parentTx.description?.replace(Regex("\\[.*?\\]"), "")?.replace(" 👻 (Promemoria)", "")?.trim() ?: "Spesa"
                cleanDesc = "$cleanDesc (su: $parentName)"
            }
        }

        val nameToSearch = cleanMerchant.takeIf { it.isNotBlank() } ?: cleanDesc

        var finalEmoji = tx.logoEmoji?.takeIf { it.isNotBlank() }
        var finalUri = tx.logoUri?.takeIf { it.isNotBlank() }

        if (tx.type == TYPE_TRANSFER && tx.toAccountId != null) {
            val toAcc = accounts.find { it.id == tx.toAccountId }
            if (toAcc != null) {
                finalEmoji = toAcc.logoEmoji?.takeIf { it.isNotBlank() } ?: finalEmoji
                finalUri = toAcc.logoUri?.takeIf { it.isNotBlank() } ?: finalUri
            }
        } else {
            if (recId != null) {
                val rec = loadedRecurring.find { it.id == recId }
                if (rec != null) {
                    finalEmoji = rec.logoEmoji?.takeIf { it.isNotBlank() } ?: finalEmoji
                    finalUri = rec.logoUri?.takeIf { it.isNotBlank() } ?: finalUri
                }
            } else if (finId != null) {
                val fin = loadedFinancings.find { it.id == finId }
                if (fin != null) {
                    finalEmoji = fin.logoEmoji?.takeIf { it.isNotBlank() } ?: finalEmoji
                    finalUri = fin.logoUri?.takeIf { it.isNotBlank() } ?: finalUri
                }
            }
        }

        if (finalUri.isNullOrBlank() && finalEmoji.isNullOrBlank()) {
            val (fallbackEmoji, fallbackUri) = getSmartLogo(nameToSearch)
            finalEmoji = fallbackEmoji
            finalUri = fallbackUri
        }

        val badge = " \uD83D\uDC7B (Promemoria)"
        val safeMerchant = cleanMerchant.replace(badge, "").trim()
        val safeDesc = cleanDesc.replace(badge, "").trim()

        val isGhost = tx.accountId?.startsWith("sys_ghost_") == true || tx.fromAccountId?.startsWith("sys_ghost_") == true || tx.toAccountId?.startsWith("sys_ghost_") == true || tx.accountId == "sys_ghost_tracker_account"
        val ghostBadge = if (isGhost) badge else ""

        val finalMerchant = if (safeMerchant.isNotBlank()) safeMerchant + ghostBadge else ""
        val finalDesc = if (safeMerchant.isBlank()) safeDesc + ghostBadge else safeDesc

        return tx.copy(
            description = finalDesc,
            merchantKey = finalMerchant.takeIf { it.isNotBlank() },
            logoEmoji = finalEmoji,
            logoUri = finalUri
        )
    }

    val enhancedGhostTxs = remember(latest, categories) {
        latest.asSequence()
            .filter { !it.isDeleted && !it.isHidden && it.categoryId != "sys_vaporized" && (it.accountId?.startsWith("sys_ghost_") == true || it.fromAccountId?.startsWith("sys_ghost_") == true || it.toAccountId?.startsWith("sys_ghost_") == true || it.accountId == "sys_ghost_tracker_account") }
            .filter { !isCashSubTx(it) } // Via i contanti dai fantasmi
            .filter { !isSavingsTx(it) } // 🚀 FIX: VIA I RISPARMI DAI FANTASMI
            .map { enhanceTransaction(it) }
            .sortedByDescending { it.dateEpochDay }
            .toList()
    }

    fun calculateBalanceFromLatest(targetAccountId: String?, maxEpochDay: Long, limitIncomesToToday: Boolean = true): Long {
        var sum = 0L
        val activeAccountIds = accounts.filter { !it.isDeleted }.map { it.id }.toSet()

        for (tx in latest) {
            if (tx.isDeleted || tx.dateEpochDay > maxEpochDay) continue
            if (isCashSubTx(tx)) continue // 🚀 FIX: IGNORA I CONTANTI NEL SALDO GLOBALE!

            val isToSavingsAcc = tx.type == "TRANSFER" && tx.toAccountId != null && accounts.any { it.id == tx.toAccountId && it.isSavings }
            val isFutureSavings = tx.dateEpochDay > todayEpoch && (
                    tx.merchantKey?.contains("[pb:", ignoreCase = true) == true ||
                            tx.merchantKey?.contains("[sav:", ignoreCase = true) == true ||
                            tx.merchantKey?.contains("[goal:", ignoreCase = true) == true ||
                            tx.merchantKey?.contains("[pac_sav:", ignoreCase = true) == true ||
                            tx.merchantKey?.contains("salvadanaio", ignoreCase = true) == true ||
                            tx.description?.contains("[pb:", ignoreCase = true) == true ||
                            tx.description?.contains("[sav:", ignoreCase = true) == true ||
                            tx.description?.contains("[goal:", ignoreCase = true) == true ||
                            tx.description?.contains("[pac_sav:", ignoreCase = true) == true ||
                            tx.description?.contains("salvadanaio", ignoreCase = true) == true ||
                            isToSavingsAcc
                    )
            if (isFutureSavings) continue

            val incomeThreshold = if (limitIncomesToToday) todayEpoch else maxEpochDay

            if (targetAccountId == null) {
                val isMainActive = tx.accountId in activeAccountIds
                val isFromActive = tx.fromAccountId in activeAccountIds
                val isToActive = tx.toAccountId in activeAccountIds

                when (tx.type) {
                    "INCOME" -> if (isMainActive && tx.dateEpochDay <= incomeThreshold) sum += tx.amountCents
                    "EXPENSE" -> if (isMainActive) sum -= tx.amountCents
                    "TRANSFER" -> {
                        if (isFromActive && !isToActive) sum -= tx.amountCents
                        else if (!isFromActive && isToActive && tx.dateEpochDay <= incomeThreshold) sum += tx.amountCents
                    }
                }
            } else {
                when (tx.type) {
                    "INCOME" -> if (tx.accountId == targetAccountId && tx.dateEpochDay <= incomeThreshold) sum += tx.amountCents
                    "EXPENSE" -> if (tx.accountId == targetAccountId) sum -= tx.amountCents
                    "TRANSFER" -> {
                        if (tx.fromAccountId == targetAccountId) sum -= tx.amountCents
                        if (tx.toAccountId == targetAccountId && tx.dateEpochDay <= incomeThreshold) sum += tx.amountCents
                    }
                }
            }
        }
        return sum
    }

    val periodEndEpoch = payPeriodEnd.toEpochDays().toLong()

    val baseAvailable = calculateBalanceFromLatest(selectedFilterAccountId, periodEndEpoch, limitIncomesToToday = true)

    val stats = remember(latest, payPeriodStart, payPeriodEnd, selectedFilterAccountId, loadedRecurring, loadedFinancings, categories) {
        com.example.monetix.utils.StatsEngine.calculateMonthlyStats(
            startDate = payPeriodStart,
            endDate = payPeriodEnd,
            latestTx = latest,
            categories = categories,
            recurringItems = loadedRecurring,
            financingItems = loadedFinancings,
            activeAccountId = selectedFilterAccountId,
            availableBalanceCents = baseAvailable
        )
    }

    val unpaidRecurringExpenses = remember(loadedRecurring, latest, selectedFilterAccountId, periodEndEpoch, payPeriodStart, accounts) {
        loadedRecurring.filter {
            val isCartella = it.notes?.contains("[CART:", ignoreCase = true) == true || it.notes?.contains("[TAX:", ignoreCase = true) == true || it.id.startsWith("cart_") || it.id.startsWith("tax_")

            !it.isDeleted && it.isEnabled && it.type != "INCOME" && it.nextEpochDay <= periodEndEpoch &&
                    (selectedFilterAccountId == null || it.accountId == selectedFilterAccountId) &&
                    !isCartella
        }.mapNotNull { rec ->
            // 🚀 FIX: Eseguiamo il controllo come in HomeScreen/BalanceCalculator!
            val pStartEpoch = payPeriodStart.toEpochDays().toLong()
            val hasPaidThisMonth = latest.any { tx ->
                !tx.isDeleted && tx.dateEpochDay >= pStartEpoch &&
                        (tx.description?.contains("[rec:${rec.id}]", ignoreCase = true) == true || tx.merchantKey?.contains("[rec:${rec.id}]", ignoreCase = true) == true)
            }
            if (hasPaidThisMonth) return@mapNotNull null
            rec.amountCents
        }.sum()
    }

    val activeCartelleList = remember(loadedRecurring, latest, selectedFilterAccountId, payPeriodStart.toEpochDays().toLong(), periodEndEpoch) {
        loadedRecurring.filter { rec ->
            val isCartella = rec.notes?.contains("[CART:", ignoreCase = true) == true || rec.notes?.contains("[TAX:", ignoreCase = true) == true || rec.id.startsWith("cart_") || rec.id.startsWith("tax_")
            val matchesAccount = selectedFilterAccountId == null || rec.accountId == selectedFilterAccountId || rec.accountId == "NEW_TAX_MODE" || rec.accountId.isBlank()
            !rec.isDeleted && isCartella && matchesAccount
        }.mapNotNull { rec ->
            val hasPaidThisMonth = latest.any { tx ->
                !tx.isDeleted && tx.dateEpochDay in payPeriodStart.toEpochDays().toLong()..periodEndEpoch &&
                        (tx.description?.contains("[rec:${rec.id}]", ignoreCase = true) == true || tx.merchantKey?.contains("[rec:${rec.id}]", ignoreCase = true) == true)
            }
            if (hasPaidThisMonth) return@mapNotNull null

            val match = Regex("\\[(?:CART|TAX):([^\\]]*)\\]", RegexOption.IGNORE_CASE).find(rec.notes ?: "")
            val rates = match?.groupValues?.get(1)?.split(",")?.map { it.trim() }?.filter { it.isNotBlank() } ?: emptyList()
            val firstUnpaid = rates.firstOrNull { !it.endsWith(":P", ignoreCase = true) && !it.endsWith(":X", ignoreCase = true) }
            val baseAmtStr = firstUnpaid?.split("@")?.firstOrNull() ?: firstUnpaid
            val amt = baseAmtStr?.replace(Regex(":[PX]", RegexOption.IGNORE_CASE), "")?.toLongOrNull() ?: 0L
            val isPaidThisMonth2 = rec.nextEpochDay > periodEndEpoch
            if (amt > 0L && !isPaidThisMonth2) amt else null
        }
    }
    val totalCartelleMese = activeCartelleList.sum()

    val unpaidFinancingWithCommissions = remember(stats.unpaidFinancingList, selectedFilterAccountId) {
        stats.unpaidFinancingList.filter { selectedFilterAccountId == null || it.accountId == selectedFilterAccountId }.sumOf { it.installmentAmountCents + (it.commissionCents ?: 0L) }
    }
    
    val totalScadenzeMese = unpaidRecurringExpenses + totalCartelleMese + unpaidFinancingWithCommissions

    // 🚀 CALCOLO DISPONIBILE CORRETTO
    // Se c'è un filtro o no, in Monetix il Disponibile in alto è (BaseAvailable - TotaleScadenzeFisseNonPagateDelMese).
    // Questo allinea la schermata Movimenti esattamente a Home e Statistiche.
    val rawAvailable = baseAvailable - totalScadenzeMese

    // 🚀 LOGICA SCUDO DI EMERGENZA PER COMPENSARE DEFICIT (Come in Home)
    val emergencyBalanceCentsLocal = remember(latest, todayEpoch, selectedFilterAccountId) {
        var sum = 0L
        for (tx in latest) {
            if (tx.isDeleted || tx.dateEpochDay > todayEpoch) continue
            val isTarget = tx.accountId == "sys_emergency_fund" || tx.toAccountId == "sys_emergency_fund" || tx.fromAccountId == "sys_emergency_fund"
            if (!isTarget) continue

            if (selectedFilterAccountId == null) {
                when (tx.type) {
                    "INCOME" -> if (tx.accountId == "sys_emergency_fund") sum += tx.amountCents
                    "EXPENSE" -> if (tx.accountId == "sys_emergency_fund") sum -= tx.amountCents
                    "TRANSFER" -> {
                        if (tx.fromAccountId == "sys_emergency_fund") sum -= tx.amountCents
                        if (tx.toAccountId == "sys_emergency_fund") sum += tx.amountCents
                    }
                }
            } else {
                if (tx.type == "TRANSFER") {
                    if (tx.fromAccountId == selectedFilterAccountId && tx.toAccountId == "sys_emergency_fund") sum += tx.amountCents
                    else if (tx.fromAccountId == "sys_emergency_fund" && tx.toAccountId == selectedFilterAccountId) sum -= tx.amountCents
                }
            }
        }
        sum
    }
    val deficit = if (rawAvailable < 0L) abs(rawAvailable) else 0L
    val scudoIntervento = minOf(deficit, emergencyBalanceCentsLocal)
    
    val displayBalanceCents = rawAvailable + scudoIntervento
    val longTermBalanceCents = calculateBalanceFromLatest(selectedFilterAccountId, Long.MAX_VALUE, limitIncomesToToday = false)

    // 🚀 LOGICA SCORTA DI SICUREZZA
    val safetyBufferCents = 50000L
    val isIntaccandoScorta = displayBalanceCents < safetyBufferCents
    val scortaUsata = if (isIntaccandoScorta) (safetyBufferCents - displayBalanceCents).coerceAtLeast(0L) else 0L

    val futureTransactions = remember(latest, localSearchQueryValue.text, selectedFilterAccountId, selectedMonth, loadedFinancings, loadedRecurring, savingsGoals) {
        latest.asSequence()
            .filter { !it.isDeleted && !it.isHidden && it.dateEpochDay > todayEpoch }
            .filter { !isCashSubTx(it) } // 🚀 FIX: Via i contanti dal futuro
            .filter { !isSavingsTx(it) } // 🚀 FIX: VIA I RISPARMI DAL FUTURO E DALLA LISTA PRINCIPALE
            .filter { val d = LocalDate.fromEpochDays(it.dateEpochDay.toInt()); d.year == selectedMonth.year && d.monthNumber == selectedMonth.monthNumber }
            .filter { tx ->
                selectedFilterAccountId == null ||
                        (tx.accountId == selectedFilterAccountId || tx.accountId == "sys_ghost_$selectedFilterAccountId" || tx.accountId == "sys_ghost_tracker_account" ||
                                tx.fromAccountId == selectedFilterAccountId || tx.fromAccountId == "sys_ghost_$selectedFilterAccountId" || tx.fromAccountId == "sys_ghost_tracker_account" ||
                                tx.toAccountId == selectedFilterAccountId || tx.toAccountId == "sys_ghost_$selectedFilterAccountId" || tx.toAccountId == "sys_ghost_tracker_account")
            }
            .filter { matchesQuery(it, localSearchQueryValue.text) }
            .map { enhanceTransaction(it) }
            .sortedBy { it.dateEpochDay }.toList()
    }

    // =======================================================
    // 🚀 PREVENIAMO DOPPIONI E CRASH DELLA UI SUI FANTASMI
    // =======================================================
    val allProgrammati: List<TransactionEntity> = remember(enhancedGhostTxs, futureTransactions, periodEndEpoch, todayEpoch) {
        (enhancedGhostTxs + futureTransactions)
            // 1. I movimenti programmati sono SOLO per il futuro. Escludiamo i fantasmi passati!
            .filter { it.dateEpochDay > todayEpoch && it.dateEpochDay <= periodEndEpoch }
            // 2. Assicuriamoci che ogni ID sia unico, altrimenti LazyColumn crasha e i soldi si raddoppiano!
            .distinctBy { it.id }
            .sortedByDescending { it.dateEpochDay }
    }

    val visibleFiltered = remember(latest, localSearchQueryValue.text, selectedFilterAccountId, selectedMonth, loadedFinancings, loadedRecurring, savingsGoals) {
        latest.asSequence()
            .filter { !it.isDeleted && !it.isHidden && it.dateEpochDay <= todayEpoch }
            .filter { !isCashSubTx(it) } // 🚀 FIX: Via i contanti dalla lista principale e dal RESOCONTO SERALE!
            .filter { !isSavingsTx(it) }
            .filter { tx ->
                selectedFilterAccountId == null ||
                        (tx.accountId == selectedFilterAccountId || tx.accountId == "sys_ghost_$selectedFilterAccountId" || tx.accountId == "sys_ghost_tracker_account" ||
                                tx.fromAccountId == selectedFilterAccountId || tx.fromAccountId == "sys_ghost_$selectedFilterAccountId" || tx.fromAccountId == "sys_ghost_tracker_account" ||
                                tx.toAccountId == selectedFilterAccountId || tx.toAccountId == "sys_ghost_$selectedFilterAccountId" || tx.toAccountId == "sys_ghost_tracker_account")
            }
            .filter { val d = LocalDate.fromEpochDays(it.dateEpochDay.toInt()); d.year == selectedMonth.year && d.monthNumber == selectedMonth.monthNumber }
            .filter { matchesQuery(it, localSearchQueryValue.text) }
            .map { enhanceTransaction(it) }
            .sortedByDescending { it.dateEpochDay }.toList()
    }

    val grouped = remember(visibleFiltered) {
        visibleFiltered.groupBy { LocalDate.fromEpochDays(it.dateEpochDay.toInt()) }.entries.sortedByDescending { it.key.toEpochDays() }.map { it.key to it.value }
    }

    val hiddenFiltered = remember(latest, selectedFilterAccountId, loadedFinancings, loadedRecurring, savingsGoals) {
        latest.filter { tx ->
            tx.isHidden && !tx.isDeleted &&
                    tx.categoryId != "sys_vaporized" &&
                    !isCashSubTx(tx) && // 🚀 FIX: Via i contanti dai nascosti
                    !isSavingsTx(tx) &&
                    (selectedFilterAccountId == null ||
                            tx.accountId == selectedFilterAccountId || tx.accountId == "sys_ghost_$selectedFilterAccountId" || tx.accountId == "sys_ghost_tracker_account" ||
                            tx.fromAccountId == selectedFilterAccountId || tx.fromAccountId == "sys_ghost_$selectedFilterAccountId" || tx.fromAccountId == "sys_ghost_tracker_account" ||
                            tx.toAccountId == selectedFilterAccountId || tx.toAccountId == "sys_ghost_$selectedFilterAccountId" || tx.toAccountId == "sys_ghost_tracker_account"
                            )
        }.map { enhanceTransaction(it) }
    }

    LaunchedEffect(globalSearchQuery, targetTxId) {
        if (globalSearchQuery.isNotBlank()) {
            isSearchActive = true
            isHeaderExpanded = false
            localSearchQueryValue = TextFieldValue(globalSearchQuery, TextRange(globalSearchQuery.length))
        }
        if (targetTxId != null) {
            val targetTx = latest.find { it.id == targetTxId }
            if (targetTx != null) {
                val targetDate = LocalDate.fromEpochDays(targetTx.dateEpochDay.toInt())
                selectedMonth = LocalDate(targetDate.year, targetDate.monthNumber, 1)

                scope.launch {
                    delay(300)
                    detailsTransaction = enhanceTransaction(targetTx)
                    var targetIndex = 0
                    var found = false

                    if (futureTransactions.isNotEmpty()) {
                        targetIndex += 1
                        val idx = futureTransactions.indexOfFirst { it.id == targetTxId }
                        if (idx != -1) { targetIndex += idx; found = true } else targetIndex += futureTransactions.size + 1
                    }

                    if (!found && visibleFiltered.isEmpty() && futureTransactions.isEmpty() && !(isVaultUnlocked && hiddenFiltered.isNotEmpty())) targetIndex += 1

                    if (!found) {
                        for ((_, items) in grouped) {
                            targetIndex += 1
                            val idx = items.indexOfFirst { it.id == targetTxId }
                            if (idx != -1) { targetIndex += idx; found = true; break } else targetIndex += items.size
                        }
                    }
                    if (found) listState.animateScrollToItem(targetIndex)
                }
            }
            onTargetTxConsumed()
        }
    }

    LaunchedEffect(listState.isScrollInProgress) {
        if (listState.isScrollInProgress) { isHeaderExpanded = false }
    }

    val currentMonthStart = remember(today) { LocalDate(today.year, today.monthNumber, 1) }

    val allAvailableMonths = remember(latest, today) {
        latest.asSequence()
            .filter { !it.isDeleted }
            .map {
                val date = LocalDate.fromEpochDays(it.dateEpochDay.toInt())
                LocalDate(date.year, date.monthNumber, 1)
            }
            .plus(currentMonthStart)
            .distinct()
            .sorted()
            .toList()
    }

    val availableYears = remember(latest, today) {
        latest.asSequence()
            .filter { !it.isDeleted }
            .map { LocalDate.fromEpochDays(it.dateEpochDay.toInt()).year }
            .plus(today.year)
            .distinct()
            .sortedDescending()
            .toList()
    }
    var selectedYear by remember { mutableIntStateOf(selectedMonth.year) }

    val isTransactionsPopupOpen = detailsTransaction != null || groupDetailsTransactions != null ||
            showSavingsSheet || showCashSheet || showGhostSheet || showHiddenSheet ||
            targetChangeAccountTxIds != null || quickSubTransactionsTx != null ||
            daySummaryDate != null || txToHide != null || txToShow != null ||
            txToVaporize != null || transactionToDelete != null ||
            showAddGenericSavings || showAddGenericCash || targetCashTxId != null ||
            showMultiDeleteConfirm || showMultiExportDialog || showMultiVaporizeConfirm

    LaunchedEffect(isTransactionsPopupOpen) {
        onPopupStateChanged(isTransactionsPopupOpen)
    }

    Scaffold(containerColor = Color.Transparent) { paddingValues ->
        val backgroundBlur by animateDpAsState(
            targetValue = if (isTransactionsPopupOpen) 12.dp else 0.dp,
            animationSpec = tween(durationMillis = 300)
        )

        val hasCustomBg = com.example.monetix.LocalHasCustomBackground.current

        Box(
            modifier = Modifier
                .fillMaxSize()
                .then(
                    if (hasCustomBg) Modifier.background(Color.Transparent)
                    else Modifier.background(
                        Brush.verticalGradient(
                            colors = listOf(
                                Color(0xFF4F46E5).copy(alpha = 0.75f),
                                Color(0xFF1E1B4B),
                                Color(0xFF0F172A)
                            )
                        )
                    )
                )
                .blur(backgroundBlur)
                .padding(paddingValues)
        ) {
            Column(modifier = Modifier.fillMaxSize()) {

                // =========================================================================
                // 🚀 TOP BAR REVOLUT GRADIENT
                // =========================================================================
                Surface(
                    modifier = Modifier.fillMaxWidth().zIndex(1f),
                    color = Color.Transparent
                ) {
                    Column(modifier = Modifier.statusBarsPadding().padding(start = 16.dp, end = 16.dp, top = 20.dp, bottom = 12.dp)) {

                        // Top Row: Titolo al posto della freccia
                        Row(modifier = Modifier.fillMaxWidth().padding(bottom = 16.dp), verticalAlignment = Alignment.CenterVertically) {
                            Text("Tutti i Movimenti", style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Black), color = Color.White)
                        }

                        // Azioni Rapide Transazioni (Stile Statistiche)
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.spacedBy(10.dp)
                        ) {
                            Surface(
                                onClick = { onAddMovement(TYPE_EXPENSE) },
                                shape = RoundedCornerShape(14.dp),
                                color = Color.White.copy(alpha = 0.12f),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f)),
                                modifier = Modifier.weight(1f).height(44.dp)
                            ) {
                                Row(
                                    horizontalArrangement = Arrangement.Center,
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Icon(Icons.Rounded.ArrowUpward, contentDescription = "Spesa", tint = MaterialTheme.colorScheme.error, modifier = Modifier.size(18.dp))
                                    Spacer(Modifier.width(6.dp))
                                    Text("Spesa", style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                                }
                            }

                            Surface(
                                onClick = { onAddMovement(TYPE_INCOME) },
                                shape = RoundedCornerShape(14.dp),
                                color = Color.White.copy(alpha = 0.12f),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f)),
                                modifier = Modifier.weight(1f).height(44.dp)
                            ) {
                                Row(
                                    horizontalArrangement = Arrangement.Center,
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Icon(Icons.Rounded.ArrowDownward, contentDescription = "Entrata", tint = Color(0xFF10B981), modifier = Modifier.size(18.dp))
                                    Spacer(Modifier.width(6.dp))
                                    Text("Entrata", style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                                }
                            }

                            Surface(
                                onClick = { onAddMovement(TYPE_TRANSFER) },
                                shape = RoundedCornerShape(14.dp),
                                color = Color.White.copy(alpha = 0.12f),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f)),
                                modifier = Modifier.weight(1f).height(44.dp)
                            ) {
                                Row(
                                    horizontalArrangement = Arrangement.Center,
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Icon(Icons.Rounded.SwapHoriz, contentDescription = "Giroconto", tint = Color(0xFF60A5FA), modifier = Modifier.size(18.dp))
                                    Spacer(Modifier.width(6.dp))
                                    Text("Giroconto", style = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                                }
                            }
                        }

                        Spacer(Modifier.height(16.dp))

                        // Saldo Attuale grande e testo grigio
                        val balanceColor = getDynamicBalanceColor(displayBalanceCents, safetyBufferCents)
                        ModernMoneyText(
                            cents = displayBalanceCents,
                            hideBalances = hideBalances,
                            color = balanceColor,
                            integerFontSize = 36.sp,
                            decimalFontSize = 20.sp,
                            symbolFontSize = 20.sp
                        )
                        Text(
                            text = "Saldo attuale",
                            style = MaterialTheme.typography.bodySmall,
                            color = Color.White.copy(alpha = 0.7f)
                        )

                        Spacer(Modifier.height(16.dp))

                        // 🚀 RIGO ANNO + TASTI CERCA E FILTRO (All'estrema destra)
                        val sortedAvailableYears = remember(availableYears) { availableYears.sorted() }
                        val prevAvailableYear = remember(sortedAvailableYears, selectedYear) { sortedAvailableYears.lastOrNull { it < selectedYear } }
                        val nextAvailableYear = remember(sortedAvailableYears, selectedYear) { sortedAvailableYears.firstOrNull { it > selectedYear } }

                        Row(
                            modifier = Modifier.fillMaxWidth().padding(top = 8.dp),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            // Selettore Anno con Freccette In Vetro
                            Row(
                                verticalAlignment = Alignment.CenterVertically,
                                modifier = Modifier
                                    .clip(RoundedCornerShape(20.dp))
                                    .background(Color.White.copy(alpha = 0.08f))
                                    .border(1.dp, Color.White.copy(alpha = 0.15f), RoundedCornerShape(20.dp))
                                    .padding(horizontal = 4.dp, vertical = 2.dp)
                            ) {
                                IconButton(
                                    onClick = {
                                        prevAvailableYear?.let { yr ->
                                            selectedYear = yr
                                            val targetM = if (yr == today.year) today.monthNumber else selectedMonth.monthNumber
                                            selectedMonth = LocalDate(yr, targetM, 1)
                                        }
                                    },
                                    enabled = prevAvailableYear != null,
                                    modifier = Modifier.size(32.dp)
                                ) {
                                    Icon(
                                        Icons.Rounded.ChevronLeft,
                                        contentDescription = "Anno Precedente",
                                        tint = if (prevAvailableYear != null) Color(0xFF60A5FA) else Color.White.copy(alpha = 0.25f),
                                        modifier = Modifier.size(18.dp)
                                    )
                                }

                                Text(
                                    text = selectedYear.toString(),
                                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                                    color = Color.White,
                                    modifier = Modifier.padding(horizontal = 8.dp)
                                )

                                IconButton(
                                    onClick = {
                                        nextAvailableYear?.let { yr ->
                                            selectedYear = yr
                                            val targetM = if (yr == today.year) today.monthNumber else selectedMonth.monthNumber
                                            selectedMonth = LocalDate(yr, targetM, 1)
                                        }
                                    },
                                    enabled = nextAvailableYear != null,
                                    modifier = Modifier.size(32.dp)
                                ) {
                                    Icon(
                                        Icons.Rounded.ChevronRight,
                                        contentDescription = "Anno Successivo",
                                        tint = if (nextAvailableYear != null) Color(0xFF60A5FA) else Color.White.copy(alpha = 0.25f),
                                        modifier = Modifier.size(18.dp)
                                    )
                                }
                            }

                            // Bottoni OCCHIO, Cerca e Filtri all'estrema destra
                            Row(
                                horizontalArrangement = Arrangement.spacedBy(10.dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Box(
                                    contentAlignment = Alignment.Center,
                                    modifier = Modifier
                                        .size(36.dp)
                                        .clip(CircleShape)
                                        .background(if (localHideBalances) Color.White.copy(alpha = 0.22f) else Color.White.copy(alpha = 0.08f))
                                        .border(1.dp, Color.White.copy(alpha = 0.15f), CircleShape)
                                        .clickable {
                                            triggerHapticTick()
                                            localHideBalances = !localHideBalances
                                            onToggleHideBalances()
                                        }
                                ) {
                                    Icon(
                                        if (localHideBalances) Icons.Outlined.VisibilityOff else Icons.Outlined.Visibility,
                                        contentDescription = "Oscura importi",
                                        tint = Color.White,
                                        modifier = Modifier.size(18.dp)
                                    )
                                }

                                Box(
                                    contentAlignment = Alignment.Center,
                                    modifier = Modifier
                                        .size(36.dp)
                                        .clip(CircleShape)
                                        .background(if (isSearchActive) Color.White.copy(alpha = 0.22f) else Color.White.copy(alpha = 0.08f))
                                        .border(1.dp, Color.White.copy(alpha = 0.15f), CircleShape)
                                        .clickable {
                                            isSearchActive = !isSearchActive
                                            if (!isSearchActive) localSearchQueryValue = TextFieldValue("")
                                        }
                                ) {
                                    Icon(
                                        if (isSearchActive) Icons.Default.Close else Icons.Rounded.Search,
                                        contentDescription = "Cerca",
                                        tint = Color.White,
                                        modifier = Modifier.size(18.dp)
                                    )
                                }

                                Box(
                                    contentAlignment = Alignment.Center,
                                    modifier = Modifier
                                        .size(36.dp)
                                        .clip(CircleShape)
                                        .background(if (isHeaderExpanded) Color.White.copy(alpha = 0.22f) else Color.White.copy(alpha = 0.08f))
                                        .border(1.dp, Color.White.copy(alpha = 0.15f), CircleShape)
                                        .clickable { isHeaderExpanded = !isHeaderExpanded }
                                ) {
                                    Icon(
                                        Icons.Default.FilterList,
                                        contentDescription = "Filtra per conto",
                                        tint = Color.White,
                                        modifier = Modifier.size(18.dp)
                                    )
                                }
                            }
                        }

                        // BARRA DI RICERCA ESPANDIBILE CENTRATA ED ELEGANTE
                        AnimatedVisibility(
                            visible = isSearchActive,
                            enter = expandVertically() + fadeIn(),
                            exit = shrinkVertically() + fadeOut()
                        ) {
                            Surface(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(top = 10.dp)
                                    .height(46.dp),
                                shape = RoundedCornerShape(24.dp),
                                color = Color.White.copy(alpha = 0.12f),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.20f))
                            ) {
                                Row(
                                    modifier = Modifier
                                        .fillMaxSize()
                                        .padding(horizontal = 14.dp),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Icon(
                                        Icons.Rounded.Search,
                                        contentDescription = null,
                                        tint = Color.White.copy(alpha = 0.7f),
                                        modifier = Modifier.size(20.dp)
                                    )

                                    Spacer(Modifier.width(10.dp))

                                    Box(
                                        modifier = Modifier.weight(1f),
                                        contentAlignment = Alignment.CenterStart
                                    ) {
                                        if (localSearchQueryValue.text.isEmpty()) {
                                            Text(
                                                text = "Cerca...",
                                                style = MaterialTheme.typography.bodyMedium,
                                                color = Color.White.copy(alpha = 0.6f)
                                            )
                                        }

                                        BasicTextField(
                                            value = localSearchQueryValue,
                                            onValueChange = { localSearchQueryValue = it },
                                            singleLine = true,
                                            textStyle = MaterialTheme.typography.bodyMedium.copy(
                                                color = Color.White,
                                                fontWeight = FontWeight.Medium
                                            ),
                                            modifier = Modifier.fillMaxWidth()
                                        )
                                    }

                                    if (localSearchQueryValue.text.isNotEmpty()) {
                                        IconButton(
                                            onClick = { localSearchQueryValue = TextFieldValue("") },
                                            modifier = Modifier.size(28.dp)
                                        ) {
                                            Icon(
                                                Icons.Default.Close,
                                                contentDescription = "Cancella",
                                                tint = Color.White.copy(alpha = 0.7f),
                                                modifier = Modifier.size(16.dp)
                                            )
                                        }
                                    }
                                }
                            }
                        }

                        // 🚀 NAVIGATORE MESI CON FRECCETTE E PULSANTE "TORNA AD OGGI"
                        Spacer(Modifier.height(10.dp))
                        val selectedMonthStart = LocalDate(selectedMonth.year, selectedMonth.monthNumber, 1)
                        val prevAvailableMonth = allAvailableMonths.lastOrNull { it < selectedMonthStart }
                        val nextAvailableMonth = allAvailableMonths.firstOrNull { it > selectedMonthStart }
                        val isCurrentMonthSelected = selectedMonthStart == currentMonthStart

                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clip(RoundedCornerShape(16.dp))
                                .background(Color.White.copy(alpha = 0.08f))
                                .border(1.dp, Color.White.copy(alpha = 0.15f), RoundedCornerShape(16.dp))
                                .padding(horizontal = 12.dp, vertical = 6.dp),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            IconButton(
                                onClick = {
                                    prevAvailableMonth?.let {
                                        selectedMonth = it
                                        selectedYear = it.year
                                    }
                                },
                                enabled = prevAvailableMonth != null,
                                modifier = Modifier.size(36.dp)
                            ) {
                                Icon(
                                    Icons.Rounded.ChevronLeft,
                                    contentDescription = "Mese Precedente",
                                    tint = if (prevAvailableMonth != null) Color(0xFF60A5FA) else Color.White.copy(alpha = 0.25f)
                                )
                            }

                            val monthNamesItalian = listOf("Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre")
                            val currentMonthName = monthNamesItalian.getOrNull(selectedMonth.monthNumber - 1) ?: ""

                            Column(
                                horizontalAlignment = Alignment.CenterHorizontally,
                                modifier = Modifier
                                    .clickable {
                                        selectedMonth = currentMonthStart
                                        selectedYear = today.year
                                    }
                                    .padding(horizontal = 12.dp, vertical = 2.dp)
                            ) {
                                Text(
                                    text = currentMonthName,
                                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                                    color = Color.White
                                )
                                if (!isCurrentMonthSelected) {
                                    Spacer(Modifier.height(2.dp))
                                    Surface(
                                        shape = RoundedCornerShape(12.dp),
                                        color = Color(0xFF60A5FA).copy(alpha = 0.20f),
                                        border = BorderStroke(1.dp, Color(0xFF60A5FA).copy(alpha = 0.35f))
                                    ) {
                                        Text(
                                            text = "Torna ad oggi ↩",
                                            style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.Bold),
                                            color = Color(0xFF60A5FA),
                                            modifier = Modifier.padding(horizontal = 8.dp, vertical = 2.dp)
                                        )
                                    }
                                }
                            }

                            IconButton(
                                onClick = {
                                    nextAvailableMonth?.let {
                                        selectedMonth = it
                                        selectedYear = it.year
                                    }
                                },
                                enabled = nextAvailableMonth != null,
                                modifier = Modifier.size(36.dp)
                            ) {
                                Icon(
                                    Icons.Rounded.ChevronRight,
                                    contentDescription = "Mese Successivo",
                                    tint = if (nextAvailableMonth != null) Color(0xFF60A5FA) else Color.White.copy(alpha = 0.25f)
                                )
                            }
                        }

                        // Pannello Espandibile Filtro Conti (Se espanso)
                        AnimatedVisibility(visible = isHeaderExpanded, enter = expandVertically(), exit = shrinkVertically()) {
                            Column(modifier = Modifier.padding(top = 12.dp)) {
                                HorizontalDivider(color = Color.White.copy(alpha = 0.08f))
                                Text("Filtra per conto", style = MaterialTheme.typography.labelSmall, color = Color.White.copy(alpha = 0.7f), modifier = Modifier.padding(top = 8.dp, bottom = 8.dp))
                                TransactionAccountFilter(accounts, selectedFilterAccountId) { selectedFilterAccountId = it }
                            }
                        }
                    }
                }

                // =========================================================================
                // 🚀 LISTA MOVIMENTI (Scorrevole)
                // =========================================================================
                LazyColumn(state = listState, modifier = Modifier.weight(1f), contentPadding = PaddingValues(horizontal = 16.dp, vertical = 8.dp), verticalArrangement = Arrangement.Top) {

                    // 🚀 CARD RIEPILOGO SALVADANAI IN CIMA (Stile Glassmorphism)
                    if (totalSavingsCents > 0L || piggyBanks.isNotEmpty() || savingsGoals.isNotEmpty()) {
                        item {
                            Surface(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(top = 8.dp, bottom = 12.dp)
                                    .clickable { showSavingsSheet = true },
                                shape = RoundedCornerShape(16.dp),
                                color = Color.White.copy(alpha = 0.08f),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f))
                            ) {
                                Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
                                    Surface(shape = CircleShape, color = Color(0xFF60A5FA).copy(alpha = 0.2f), modifier = Modifier.size(44.dp)) {
                                        Icon(Icons.Rounded.Savings, contentDescription = null, tint = Color(0xFF60A5FA), modifier = Modifier.padding(10.dp))
                                    }
                                    Spacer(Modifier.width(14.dp))
                                    Column(modifier = Modifier.weight(1f)) {
                                        Text("PAC, Sogni & Salvadanai", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                                        Text("Archivio storico dei movimenti", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                                        ModernMoneyText(
                                            cents = totalSavingsCents,
                                            hideBalances = hideBalances,
                                            color = Color(0xFF60A5FA),
                                            integerFontSize = 18.sp,
                                            decimalFontSize = 12.sp,
                                            symbolFontSize = 12.sp
                                        )
                                    }
                                    IconButton(
                                        onClick = { showAddGenericSavings = true },
                                        modifier = Modifier.background(Color.White.copy(alpha = 0.12f), CircleShape)
                                    ) {
                                        Icon(Icons.Rounded.Add, contentDescription = "Versa o Preleva", tint = Color.White)
                                    }
                                }
                            }
                        }
                    }

                    // 🚀 CARD GESTIONE CONTANTI ISOLATA (Stile Glassmorphism)
                    item {
                        Surface(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(bottom = 12.dp)
                                .clickable { showCashSheet = true },
                            shape = RoundedCornerShape(16.dp),
                            color = Color.White.copy(alpha = 0.08f),
                            border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f))
                        ) {
                            Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
                                Surface(shape = CircleShape, color = Color(0xFF10B981).copy(alpha = 0.2f), modifier = Modifier.size(44.dp)) {
                                    Icon(Icons.Rounded.AccountBalanceWallet, contentDescription = null, tint = Color(0xFF10B981), modifier = Modifier.padding(10.dp))
                                }
                                Spacer(Modifier.width(14.dp))
                                Column(modifier = Modifier.weight(1f)) {
                                    Text("Gestione Contanti", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                                    Text("In tasca:", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                                    ModernMoneyText(
                                        cents = netCashInPocket,
                                        hideBalances = hideBalances,
                                        color = Color(0xFF10B981),
                                        integerFontSize = 18.sp,
                                        decimalFontSize = 12.sp,
                                        symbolFontSize = 12.sp
                                    )
                                }

                                IconButton(
                                    onClick = { showAddGenericCash = true },
                                    modifier = Modifier.background(Color.White.copy(alpha = 0.12f), CircleShape)
                                ) {
                                    Icon(Icons.Rounded.Add, contentDescription = "Nuovo Movimento Contanti", tint = Color.White)
                                }
                            }
                        }
                    }

                    // 🚀 CARD MOVIMENTI PROGRAMMATI (Stile Glassmorphism)
                    if (allProgrammati.isNotEmpty()) {
                        item {
                            val amberColor = Color(0xFFF59E0B)

                            val isGhost = { tx: TransactionEntity ->
                                tx.accountId?.startsWith("sys_ghost_") == true || tx.accountId == "sys_ghost_tracker_account"
                            }

                            val isFixed = { tx: TransactionEntity ->
                                val desc = (tx.description ?: "").lowercase()
                                val key = (tx.merchantKey ?: "").lowercase()
                                desc.contains("[rec:") || desc.contains("[fin:") || key.contains("[rec:") || key.contains("[fin:")
                            }

                            val impegnoDaSottrarre = allProgrammati.fold(0L) { acc, tx ->
                                acc + if (isGhost(tx) && !isFixed(tx)) {
                                    if (tx.type == "INCOME") 0L else if(tx.amountCents < 0L) -tx.amountCents else tx.amountCents
                                } else {
                                    0L
                                }
                            }

                            val saldoMenoImpegni = displayBalanceCents - impegnoDaSottrarre
                            val totaleListaCents = allProgrammati.fold(0L) { acc, it -> acc + if (it.type == "INCOME") 0L else if(it.amountCents < 0L) -it.amountCents else it.amountCents }

                            Surface(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(bottom = 12.dp)
                                    .clickable { showGhostSheet = true },
                                shape = RoundedCornerShape(16.dp),
                                color = Color.White.copy(alpha = 0.08f),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f))
                            ) {
                                Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
                                    Surface(shape = CircleShape, color = amberColor.copy(alpha = 0.2f), modifier = Modifier.size(44.dp)) {
                                        Icon(Icons.Rounded.PendingActions, contentDescription = null, tint = amberColor, modifier = Modifier.padding(10.dp))
                                    }
                                    Spacer(Modifier.width(14.dp))
                                    Column(modifier = Modifier.weight(1f)) {
                                        Text("Movimenti Programmati", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                                        ModernMoneyText(
                                            cents = totaleListaCents,
                                            hideBalances = hideBalances,
                                            sign = "-",
                                            color = amberColor,
                                            integerFontSize = 18.sp,
                                            decimalFontSize = 12.sp,
                                            symbolFontSize = 12.sp
                                        )
                                        Text(if (hideBalances) "Disp. Reale: •••• €" else "Disp. Reale: ${formatEuroFromCents(saldoMenoImpegni, false)}", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                                    }
                                    Icon(Icons.Default.ChevronRight, null, tint = amberColor)
                                }
                            }
                        }
                    }

                    // 🚀 CARD MOVIMENTI NASCOSTI (Stile Glassmorphism)
                    if (hiddenFiltered.isNotEmpty()) {
                        item {
                            val purpleColor = Color(0xFF8B5CF6)
                            Surface(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(bottom = 12.dp)
                                    .clickable {
                                        if (isVaultUnlocked) {
                                            showHiddenSheet = true
                                        } else {
                                            showPinDialog = true
                                        }
                                    },
                                shape = RoundedCornerShape(16.dp),
                                color = Color.White.copy(alpha = 0.08f),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f))
                            ) {
                                Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
                                    Surface(shape = CircleShape, color = purpleColor.copy(alpha = 0.2f), modifier = Modifier.size(44.dp)) {
                                        Icon(Icons.Outlined.VisibilityOff, contentDescription = null, tint = purpleColor, modifier = Modifier.padding(10.dp))
                                    }
                                    Spacer(Modifier.width(14.dp))
                                    Column(modifier = Modifier.weight(1f)) {
                                        Text("Movimenti Nascosti", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                                        Text("${hiddenFiltered.size} elementi archiviati nel Vault", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                                    }
                                    Icon(if (isVaultUnlocked) Icons.Default.ChevronRight else Icons.Default.Lock, null, tint = purpleColor)
                                }
                            }
                        }
                    }

                    if (futureTransactions.isNotEmpty()) {
                        item {
                            val futureTotalCents = remember(futureTransactions) {
                                futureTransactions.fold(0L) { acc, tx ->
                                    val amt = if (tx.amountCents < 0) -tx.amountCents else tx.amountCents
                                    acc + (if (tx.type == "INCOME") amt else -amt)
                                }
                            }
                            Row(
                                modifier = Modifier.fillMaxWidth().padding(start = 4.dp, end = 4.dp, top = 8.dp, bottom = 8.dp),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text("IN ARRIVO", style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.Bold), color = Color(0xFF60A5FA))
                                ModernMoneyText(
                                    cents = futureTotalCents,
                                    hideBalances = hideBalances,
                                    color = Color(0xFF60A5FA),
                                    integerFontSize = 13.sp,
                                    decimalFontSize = 10.sp,
                                    symbolFontSize = 10.sp,
                                    modifier = Modifier.padding(end = 8.dp)
                                )
                            }
                        }
                        items(futureTransactions, key = { "fut_${it.id}" }) { tx ->
                            TransactionItemFlat(
                                tx = tx, categoryNameById = categoryNameById, accountNameById = accountNameById, hideBalances = hideBalances, hiddenAccountIds = hiddenAccountIds,
                                onAddFavorite = onAddFavorite, onOpenDetails = { detailsTransaction = it },
                                selectionMode = selectionMode, isSelected = selectedTxIds.contains(tx.id), onToggleSelect = { toggleSelection(tx.id) }, onStartSelection = { selectionMode = true; selectedTxIds.add(tx.id) },
                                subExpenses = subExpensesMap[tx.id], onOpenSubExpenses = { quickSubTransactionsTx = tx }
                            )
                            HorizontalDivider(color = MaterialTheme.colorScheme.outline.copy(alpha = 0.05f))
                        }
                        item { Spacer(Modifier.height(16.dp)) }
                    }

                    if (visibleFiltered.isEmpty() && futureTransactions.isEmpty() && !(isVaultUnlocked && hiddenFiltered.isNotEmpty())) {
                        item { Box(Modifier.fillParentMaxSize(), contentAlignment = Alignment.Center) { Text("Nessun movimento", color = MaterialTheme.colorScheme.onSurfaceVariant.copy(alpha = 0.5f), style = MaterialTheme.typography.bodyLarge) } }
                    }

                    grouped.forEach { (day, items) ->
                        item {
                            val dayTotalCents = remember(items) {
                                items.fold(0L) { acc, tx ->
                                    val amt = if (tx.amountCents < 0) -tx.amountCents else tx.amountCents
                                    when (tx.type) {
                                        "INCOME" -> acc + amt
                                        "EXPENSE" -> acc - amt
                                        else -> acc
                                    }
                                }
                            }

                            val dateStr = when(day) {
                                today -> "Oggi"
                                today.minus(DatePeriod(days = 1)) -> "Ieri"
                                else -> "${day.dayOfMonth} ${formatDayMonth(day).substringAfter(" ")}"
                            }

                            Row(
                                modifier = Modifier.fillMaxWidth().padding(top = 20.dp, bottom = 8.dp, start = 4.dp, end = 4.dp),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text(
                                    text = dateStr,
                                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                                    color = Color.White
                                )

                                Row(verticalAlignment = Alignment.CenterVertically) {
                                    ModernMoneyText(
                                        cents = dayTotalCents,
                                        hideBalances = hideBalances,
                                        color = if (dayTotalCents > 0) Color(0xFF10B981) else Color(0xFFA0A0A0),
                                        integerFontSize = 13.sp,
                                        decimalFontSize = 10.sp,
                                        symbolFontSize = 10.sp,
                                        modifier = Modifier.padding(end = 8.dp)
                                    )

                                    IconButton(onClick = { dayTransactionsToDelete = items; dayDateToDelete = day }, modifier = Modifier.size(24.dp)) {
                                        Icon(Icons.Outlined.Delete, contentDescription = "Elimina giorno", tint = MaterialTheme.colorScheme.error.copy(alpha = 0.7f), modifier = Modifier.size(18.dp))
                                    }
                                }
                            }
                        }

                        item {
                            val subGrouped = items.groupBy { tx ->
                                val cleanM = tx.merchantKey?.let { stripSystemMarker(it) }
                                val cleanD = tx.description?.let { stripSystemMarker(it) }
                                val name = cleanM ?: cleanD ?: "MOVIMENTO"
                                "${tx.type}_${name.uppercase().trim()}"
                            }.values.toList()

                            Column(modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp)) {
                                subGrouped.forEachIndexed { index, groupList ->
                                    if (index > 0) {
                                        HorizontalDivider(color = Color.White.copy(alpha = 0.05f))
                                    }

                                    if (groupList.size == 1) {
                                        val tx = groupList.first()
                                        TransactionItemFlat(
                                            tx = tx, categoryNameById = categoryNameById, accountNameById = accountNameById, hideBalances = hideBalances, hiddenAccountIds = hiddenAccountIds,
                                            onAddFavorite = onAddFavorite, onOpenDetails = { detailsTransaction = it },
                                            selectionMode = selectionMode, isSelected = selectedTxIds.contains(tx.id), onToggleSelect = { toggleSelection(tx.id) }, onStartSelection = { selectionMode = true; selectedTxIds.add(tx.id) },
                                            subExpenses = subExpensesMap[tx.id], onOpenSubExpenses = { quickSubTransactionsTx = tx }
                                        )
                                    } else {
                                        val firstTx = groupList.first()
                                        val totalAmount = groupList.fold(0L) { acc, it -> acc + it.amountCents }
                                        val cleanM = firstTx.merchantKey?.let { stripSystemMarker(it) }
                                        val cleanD = firstTx.description?.let { stripSystemMarker(it) }
                                        val displayName = (cleanM ?: cleanD ?: "MOVIMENTO").uppercase()
                                        val isIncome = firstTx.type == "INCOME"
                                        val isTransfer = firstTx.type == "TRANSFER"
                                        val sign = if (isIncome) "+" else if (isTransfer) "" else "-"
                                        val amountColor = if (isTransfer) Color(0xFF60A5FA) else if (isIncome) Color(0xFF10B981) else Color.White

                                        val isGroupSelected = groupList.all { selectedTxIds.contains(it.id) }
                                        val groupBgColor by animateColorAsState(if (isGroupSelected) MaterialTheme.colorScheme.primaryContainer.copy(alpha = 0.5f) else Color.Transparent)

                                        Column(
                                            modifier = Modifier
                                                .fillMaxWidth()
                                                .clip(RoundedCornerShape(8.dp))
                                                .background(groupBgColor)
                                                .combinedClickable(
                                                    indication = null,
                                                    interactionSource = remember { MutableInteractionSource() },
                                                    onClick = {
                                                        haptic.performHapticFeedback(HapticFeedbackType.TextHandleMove)
                                                        if (selectionMode) {
                                                            if (isGroupSelected) {
                                                                groupList.forEach { selectedTxIds.remove(it.id) }
                                                                if (selectedTxIds.isEmpty()) selectionMode = false
                                                            } else {
                                                                groupList.forEach { if (!selectedTxIds.contains(it.id)) selectedTxIds.add(it.id) }
                                                            }
                                                        } else {
                                                            groupDetailsTransactions = groupList
                                                        }
                                                    },
                                                    onLongClick = {
                                                        haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                                                        if (!selectionMode) selectionMode = true
                                                        if (isGroupSelected) {
                                                            groupList.forEach { selectedTxIds.remove(it.id) }
                                                            if (selectedTxIds.isEmpty()) selectionMode = false
                                                        } else {
                                                            groupList.forEach { if (!selectedTxIds.contains(it.id)) selectedTxIds.add(it.id) }
                                                        }
                                                    }
                                                )
                                                .padding(vertical = 4.dp)
                                        ) {
                                            Row(modifier = Modifier.padding(vertical = 12.dp, horizontal = 12.dp), verticalAlignment = Alignment.CenterVertically) {
                                                Box(contentAlignment = Alignment.Center, modifier = Modifier.size(40.dp)) {
                                                    if (isGroupSelected) {
                                                        Icon(
                                                            imageVector = Icons.Rounded.CheckCircle,
                                                            contentDescription = "Selezionato",
                                                            tint = brandPrimary,
                                                            modifier = Modifier.size(32.dp)
                                                        )
                                                    } else {
                                                        TxLogo(firstTx.logoEmoji, firstTx.logoUri, displayName, Modifier.fillMaxSize())
                                                    }
                                                }

                                                Spacer(Modifier.width(16.dp))
                                                Column(Modifier.weight(1f)) {
                                                    Text(
                                                        text = "$displayName (${groupList.size})",
                                                        modifier = Modifier.basicMarquee(),
                                                        style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.SemiBold),
                                                        color = Color.White,
                                                        maxLines = 1
                                                    )
                                                    Text("Movimenti accorpati", style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0))
                                                }

                                                ModernMoneyText(
                                                    cents = if(totalAmount < 0L) -totalAmount else totalAmount,
                                                    hideBalances = hideBalances,
                                                    sign = sign,
                                                    color = amountColor,
                                                    integerFontSize = 18.sp,
                                                    decimalFontSize = 14.sp,
                                                    symbolFontSize = 14.sp,
                                                    modifier = Modifier.padding(end = 8.dp)
                                                )
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    item { Spacer(Modifier.height(120.dp)) }
                }
            }

            // Barra laterale per Selezione Multipla
            AnimatedVisibility(
                visible = selectionMode,
                enter = slideInVertically(initialOffsetY = { it }) + fadeIn(),
                exit = slideOutVertically(targetOffsetY = { it }) + fadeOut(),
                modifier = Modifier.align(Alignment.BottomCenter).padding(bottom = 110.dp, start = 16.dp, end = 16.dp)
            ) {
                Surface(
                    shape = RoundedCornerShape(28.dp),
                    color = Color(0xFF1E1E2E).copy(alpha = 0.85f),
                    border = BorderStroke(1.5.dp, Color.White.copy(alpha = 0.25f)),
                    contentColor = Color.White,
                    shadowElevation = 0.dp
                ) {
                    Row(
                        modifier = Modifier.padding(horizontal = 16.dp, vertical = 10.dp).fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        IconButton(onClick = clearSelection, modifier = Modifier.size(36.dp)) {
                            Icon(Icons.Default.Close, "Annulla", tint = Color.White)
                        }
                        Text(
                            "${selectedTxIds.size} Selezionati",
                            style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                            color = Color.White,
                            modifier = Modifier.weight(1f).padding(start = 8.dp)
                        )

                        IconButton(onClick = { targetChangeAccountTxIds = selectedTxIds.toList() }, modifier = Modifier.size(36.dp)) {
                            Icon(Icons.Rounded.AccountBalance, "Sposta Conto", tint = Color(0xFF60A5FA))
                        }

                        IconButton(onClick = { showMultiHideConfirm = true }, modifier = Modifier.size(36.dp)) {
                            Icon(Icons.Outlined.VisibilityOff, "Nascondi", tint = Color(0xFF60A5FA))
                        }
                        if (fileExporter != null) {
                            IconButton(onClick = { showMultiExportDialog = true }, modifier = Modifier.size(36.dp)) {
                                Icon(Icons.Default.Share, "Condividi/Esporta", tint = Color.White)
                            }
                        }
                        IconButton(onClick = { showMultiDeleteConfirm = true }, modifier = Modifier.size(36.dp)) {
                            Icon(Icons.Outlined.Delete, "Elimina", tint = Color(0xFFEF4444))
                        }
                        IconButton(onClick = { showMultiVaporizeConfirm = true }, modifier = Modifier.size(36.dp)) {
                            Text("💨", fontSize = 18.sp)
                        }
                    }
                }
            }
        }
    }

    // ==========================================
    // 🚀 BOTTOM SHEETS PER ARCHIVIO RISPARMI/PAC
    // ==========================================
    if (showSavingsSheet) {
        var savingsFilter by remember { mutableStateOf("ALL") }

        // 🚀 FILTRI DINAMICI SEPARATI
        val allSavingsTx = remember(savingsFilteredPast, savingsFilteredFuture, savingsFilter) {
            (savingsFilteredPast + savingsFilteredFuture).filter { tx ->
                val key = (tx.merchantKey ?: "").lowercase()
                val desc = (tx.description ?: "").lowercase()
                when (savingsFilter) {
                    "PAC" -> key.contains("[pac_sav:") || desc.contains("[pac_sav:") || key.contains("pac")
                    "GOAL" -> (key.contains("[sav:") || desc.contains("[sav:") || key.contains("[goal:") || desc.contains("[goal:")) && !key.contains("[pac_sav:") && !desc.contains("[pac_sav:")
                    "PB" -> key.contains("[pb:") || desc.contains("[pb:") || key.contains("salvadanaio") || desc.contains("salvadanaio") || key.contains("arrotondamento") || desc.contains("arrotondamento")
                    else -> true
                }
            }
        }
        
        val todayEpochDay = Clock.System.todayIn(TimeZone.currentSystemDefault()).toEpochDays().toLong()
        var selectedEpochDay by remember { mutableStateOf(todayEpochDay) }
        
        val allAvailableEpochs = remember(allSavingsTx) {
            allSavingsTx.map { it.dateEpochDay }.distinct().sorted()
        }
        
        val savingsDisplayedForDay = remember(allSavingsTx, selectedEpochDay) {
            allSavingsTx.filter { it.dateEpochDay == selectedEpochDay }
                .sortedWith(compareByDescending<TransactionEntity> { tx ->
                    val key = (tx.merchantKey ?: "").lowercase()
                    val desc = (tx.description ?: "").lowercase()
                    key.contains("arrotondamento") || desc.contains("arrotondamento")
                }.thenByDescending { it.createdAtEpochMs })
        }

        val savingsSheetBlur by animateDpAsState(
            targetValue = if (detailsTransaction != null || showMultiDeleteConfirm) 12.dp else 0.dp,
            animationSpec = tween(durationMillis = 300),
            label = "savingsSheetBlur"
        )

        ModalBottomSheet(
            onDismissRequest = { showSavingsSheet = false },
            containerColor = Color.White.copy(alpha = 0.12f),
            shape = RoundedCornerShape(topStart = 28.dp, topEnd = 28.dp)
        ) {
            Column(modifier = Modifier.fillMaxWidth().padding(horizontal = 24.dp, vertical = 16.dp).blur(savingsSheetBlur)) {

                // Calcoliamo i selezionati
                val selectedSavingsCount = selectedTxIds.count { id -> savingsDisplayedForDay.any { it.id == id } }

                if (selectionMode) {
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(bottom = 8.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        IconButton(onClick = { clearSelection() }, modifier = Modifier.size(36.dp)) {
                            Icon(Icons.Default.Close, contentDescription = "Annulla")
                        }
                        Text(
                            "$selectedSavingsCount Sel.",
                            style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                            color = brandPrimary,
                            modifier = Modifier.weight(1f).padding(start = 4.dp)
                        )

                        val totalSize = savingsDisplayedForDay.size
                        val isAllSelected = selectedSavingsCount == totalSize && totalSize > 0
                        TextButton(onClick = {
                            if (isAllSelected) {
                                savingsDisplayedForDay.forEach { selectedTxIds.remove(it.id) }
                                if (selectedTxIds.isEmpty()) selectionMode = false
                            } else {
                                savingsDisplayedForDay.forEach { if (!selectedTxIds.contains(it.id)) selectedTxIds.add(it.id) }
                            }
                        }) {
                            Text(if (isAllSelected) "Deseleziona" else "Seleziona Tutti", fontWeight = FontWeight.Bold, color = brandPrimary)
                        }

                        IconButton(onClick = { 
                            showSavingsSheet = false
                            showMultiDeleteConfirm = true 
                        }, modifier = Modifier.size(36.dp)) {
                            Icon(Icons.Outlined.Delete, contentDescription = "Elimina", tint = MaterialTheme.colorScheme.error)
                        }
                        IconButton(onClick = { 
                            showSavingsSheet = false
                            showMultiVaporizeConfirm = true 
                        }, modifier = Modifier.size(36.dp)) {
                            Text("💨", fontSize = 18.sp)
                        }
                    }
                } else {
                    Text("Archivio Risparmi", style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Black), color = Color(0xFF60A5FA))

                    LazyRow(
                        modifier = Modifier.fillMaxWidth().padding(top = 12.dp, bottom = 8.dp),
                        horizontalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        item { FilterChip(selected = savingsFilter == "ALL", onClick = { savingsFilter = "ALL" }, label = { Text("Tutti", fontWeight = FontWeight.Bold) }, colors = FilterChipDefaults.filterChipColors(selectedContainerColor = Color.White, selectedLabelColor = Color.Black, containerColor = Color.White.copy(alpha = 0.10f), labelColor = Color.White), border = null, shape = RoundedCornerShape(50)) }
                        item { FilterChip(selected = savingsFilter == "PAC", onClick = { savingsFilter = "PAC" }, label = { Text("PAC", fontWeight = FontWeight.Bold) }, colors = FilterChipDefaults.filterChipColors(selectedContainerColor = Color.White, selectedLabelColor = Color.Black, containerColor = Color.White.copy(alpha = 0.10f), labelColor = Color.White), border = null, shape = RoundedCornerShape(50)) }
                        item { FilterChip(selected = savingsFilter == "GOAL", onClick = { savingsFilter = "GOAL" }, label = { Text("Sogni", fontWeight = FontWeight.Bold) }, colors = FilterChipDefaults.filterChipColors(selectedContainerColor = Color.White, selectedLabelColor = Color.Black, containerColor = Color.White.copy(alpha = 0.10f), labelColor = Color.White), border = null, shape = RoundedCornerShape(50)) }
                        item { FilterChip(selected = savingsFilter == "PB", onClick = { savingsFilter = "PB" }, label = { Text("Salvadanai", fontWeight = FontWeight.Bold) }, colors = FilterChipDefaults.filterChipColors(selectedContainerColor = Color.White, selectedLabelColor = Color.Black, containerColor = Color.White.copy(alpha = 0.10f), labelColor = Color.White), border = null, shape = RoundedCornerShape(50)) }
                    }
                }

                Spacer(Modifier.height(8.dp))
                
                // 🚀 NAVIGATORE DATE
                val prevEpoch = allAvailableEpochs.lastOrNull { it < selectedEpochDay }
                val nextEpoch = allAvailableEpochs.firstOrNull { it > selectedEpochDay }

                Row(
                    verticalAlignment = Alignment.CenterVertically, 
                    horizontalArrangement = Arrangement.SpaceBetween, 
                    modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp, horizontal = 12.dp)
                ) {
                    IconButton(onClick = { selectedEpochDay = prevEpoch ?: (selectedEpochDay - 1) }) { 
                        Icon(Icons.Rounded.ChevronLeft, "Precedente", tint = if (prevEpoch != null) Color(0xFF60A5FA) else Color.White.copy(alpha = 0.3f)) 
                    }
                    
                    val dateStrUI = when (selectedEpochDay) {
                        todayEpochDay -> "Oggi"
                        todayEpochDay - 1 -> "Ieri"
                        else -> formatFullDate(LocalDate.fromEpochDays(selectedEpochDay.toInt()))
                    }
                    
                    Column(
                        horizontalAlignment = Alignment.CenterHorizontally, 
                        modifier = Modifier.clickable(
                            interactionSource = remember { MutableInteractionSource() }, 
                            indication = null
                        ) { selectedEpochDay = todayEpochDay }.padding(horizontal = 16.dp)
                    ) {
                        Text(dateStrUI, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = Color.White)
                        if (selectedEpochDay != todayEpochDay) {
                            Text("Torna a Oggi", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                        }
                    }
                    
                    IconButton(onClick = { selectedEpochDay = nextEpoch ?: (selectedEpochDay + 1) }) { 
                        Icon(Icons.Rounded.ChevronRight, "Successivo", tint = if (nextEpoch != null) Color(0xFF60A5FA) else Color.White.copy(alpha = 0.3f)) 
                    }
                }
                
                Spacer(Modifier.height(8.dp))
                LazyColumn(modifier = Modifier.fillMaxWidth()) {

                    if (savingsDisplayedForDay.isNotEmpty()) {
                        items(savingsDisplayedForDay, key = { "sav_day_${it.id}" }) { rawTx ->
                            val tx = enhanceTransaction(rawTx)
                            val displayName = tx.merchantKey ?: "Risparmio"
                            val destText = tx.description ?: ""

                            val isWithdrawalUI = tx.type == "EXPENSE" && tx.amountCents < 0
                            val isTransferOutUI = tx.type == "TRANSFER" && tx.fromAccountId == "salvadanaio_virtuale"
                            val isTransferInUI = tx.type == "TRANSFER" && tx.toAccountId == "salvadanaio_virtuale"
                            val signUI = if (isWithdrawalUI || isTransferOutUI) "-" else if(isTransferInUI) "" else "+"
                            val colorUI = if (isWithdrawalUI || isTransferOutUI) Color(0xFFF87171) else if(isTransferInUI) Color(0xFF60A5FA) else Color(0xFF10B981)

                            val isSelected = selectedTxIds.contains(tx.id)
                            val rowBgColor by animateColorAsState(if (isSelected) Color(0xFF60A5FA).copy(alpha = 0.15f) else Color.Transparent)

                            Row(
                                Modifier.fillMaxWidth().clip(RoundedCornerShape(8.dp)).background(rowBgColor).combinedClickable(
                                    interactionSource = remember { MutableInteractionSource() }, indication = null,
                                    onClick = { haptic.performHapticFeedback(HapticFeedbackType.TextHandleMove); if (selectionMode) toggleSelection(tx.id) else { detailsTransaction = tx } },
                                    onLongClick = { haptic.performHapticFeedback(HapticFeedbackType.LongPress); if (!selectionMode) { selectionMode = true; selectedTxIds.add(tx.id) } else toggleSelection(tx.id) }
                                ).padding(vertical = 12.dp, horizontal = 4.dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Box(contentAlignment = Alignment.Center, modifier = Modifier.size(40.dp)) {
                                    if (isSelected) Icon(Icons.Rounded.CheckCircle, "Selezionato", tint = Color(0xFF60A5FA), modifier = Modifier.size(32.dp))
                                    else TxLogo(tx.logoEmoji ?: "🐷", tx.logoUri, displayName, Modifier.fillMaxSize())
                                }
                                Spacer(Modifier.width(12.dp))
                                Column(modifier = Modifier.weight(1f)) {
                                    Text(displayName, style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold), color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                    if (destText.isNotBlank()) Text(destText, style = MaterialTheme.typography.labelSmall, color = Color(0xFF60A5FA))
                                }
                                ModernMoneyText(cents = tx.amountCents, hideBalances = hideBalances, sign = signUI, color = colorUI, integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp)
                            }
                            HorizontalDivider(color = Color.White.copy(alpha = 0.1f))
                        }
                    } else {
                        item { Box(Modifier.fillMaxWidth().padding(32.dp), contentAlignment = Alignment.Center) { Text("Nessun movimento in questa data", color = Color(0xFFA0A0A0)) } }
                    }
                }
                Spacer(Modifier.height(24.dp))
            }
        }
    }

    // ==========================================
    // 🚀 BOTTOM SHEETS PER CONTANTI ISOLATI
    // ==========================================
    if (showCashSheet) {
        val todayEpochDayCash = Clock.System.todayIn(TimeZone.currentSystemDefault()).toEpochDays().toLong()
        var selectedEpochDayCash by remember { mutableStateOf(todayEpochDayCash) }
        
        val allAvailableEpochsCash = remember(allCashTxs) {
            allCashTxs.map { it.dateEpochDay }.distinct().sorted()
        }
        
        val cashDisplayedForDay = remember(allCashTxs, selectedEpochDayCash) {
            allCashTxs.filter { it.dateEpochDay == selectedEpochDayCash }
                .sortedByDescending { it.createdAtEpochMs }
        }

        val cashSheetBlur by animateDpAsState(
            targetValue = if (detailsTransaction != null || targetCashTxId != null || showMultiDeleteConfirm || showMultiVaporizeConfirm || showAddGenericCash) 12.dp else 0.dp,
            animationSpec = tween(durationMillis = 300),
            label = "cashSheetBlur"
        )

        ModalBottomSheet(
            onDismissRequest = { showCashSheet = false },
            containerColor = Color.White.copy(alpha = 0.12f),
            shape = RoundedCornerShape(topStart = 28.dp, topEnd = 28.dp)
        ) {
            Column(modifier = Modifier.fillMaxWidth().padding(horizontal = 24.dp, vertical = 16.dp).blur(cashSheetBlur)) {

                val selectedCashCount = selectedTxIds.count { id -> cashDisplayedForDay.any { it.id == id } }

                if (selectionMode && selectedCashCount > 0) {
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(bottom = 8.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        IconButton(onClick = { clearSelection() }, modifier = Modifier.size(36.dp)) {
                            Icon(Icons.Default.Close, contentDescription = "Annulla")
                        }
                        Text(
                            "$selectedCashCount Selezionati",
                            style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                            color = Color(0xFF10B981),
                            modifier = Modifier.weight(1f).padding(start = 8.dp)
                        )
                        
                        val totalSize = cashDisplayedForDay.size
                        val isAllSelected = selectedCashCount == totalSize && totalSize > 0
                        TextButton(onClick = {
                            if (isAllSelected) {
                                cashDisplayedForDay.forEach { selectedTxIds.remove(it.id) }
                                if (selectedTxIds.isEmpty()) selectionMode = false
                            } else {
                                cashDisplayedForDay.forEach { if (!selectedTxIds.contains(it.id)) selectedTxIds.add(it.id) }
                            }
                        }) {
                            Text(if (isAllSelected) "Deseleziona" else "Seleziona Tutti", fontWeight = FontWeight.Bold, color = Color(0xFF10B981))
                        }

                        IconButton(onClick = { 
                            showCashSheet = false
                            showMultiDeleteConfirm = true 
                        }, modifier = Modifier.size(36.dp)) {
                            Icon(Icons.Outlined.Delete, contentDescription = "Elimina", tint = MaterialTheme.colorScheme.error)
                        }
                        IconButton(onClick = { 
                            showCashSheet = false
                            showMultiVaporizeConfirm = true 
                        }, modifier = Modifier.size(36.dp)) {
                            Text("💨", fontSize = 18.sp)
                        }
                    }
                } else {
                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                        Column {
                            Text("Contanti in Tasca", style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Black), color = Color(0xFF10B981))
                            Text("Saldo contanti disponibile in tasca.", style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0))
                        }
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            ModernMoneyText(
                                cents = netCashInPocket,
                                hideBalances = hideBalances,
                                color = Color(0xFF10B981),
                                integerFontSize = 20.sp,
                                decimalFontSize = 14.sp,
                                symbolFontSize = 14.sp
                            )
                            Spacer(Modifier.width(8.dp))
                            IconButton(
                                onClick = { showAddGenericCash = true },
                                modifier = Modifier.background(Color(0xFF10B981).copy(alpha = 0.15f), CircleShape)
                            ) {
                                Icon(Icons.Rounded.Add, contentDescription = "Aggiungi Contanti", tint = Color(0xFF10B981))
                            }
                        }
                    }
                }

                Spacer(Modifier.height(8.dp))
                
                // 🚀 NAVIGATORE DATE
                val prevEpoch = allAvailableEpochsCash.lastOrNull { it < selectedEpochDayCash }
                val nextEpoch = allAvailableEpochsCash.firstOrNull { it > selectedEpochDayCash }

                Row(
                    verticalAlignment = Alignment.CenterVertically, 
                    horizontalArrangement = Arrangement.SpaceBetween, 
                    modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp, horizontal = 12.dp)
                ) {
                    IconButton(onClick = { selectedEpochDayCash = prevEpoch ?: (selectedEpochDayCash - 1) }) { 
                        Icon(Icons.Rounded.ChevronLeft, "Precedente", tint = if (prevEpoch != null) Color(0xFF10B981) else Color.White.copy(alpha = 0.3f)) 
                    }
                    
                    val dateStrUI = when (selectedEpochDayCash) {
                        todayEpochDayCash -> "Oggi"
                        todayEpochDayCash - 1 -> "Ieri"
                        else -> formatFullDate(LocalDate.fromEpochDays(selectedEpochDayCash.toInt()))
                    }
                    
                    Column(
                        horizontalAlignment = Alignment.CenterHorizontally, 
                        modifier = Modifier.clickable(
                            interactionSource = remember { MutableInteractionSource() }, 
                            indication = null
                        ) { selectedEpochDayCash = todayEpochDayCash }.padding(horizontal = 16.dp)
                    ) {
                        Text(dateStrUI, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = Color(0xFF10B981))
                        if (selectedEpochDayCash != todayEpochDayCash) {
                            Text("Torna a Oggi", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                        }
                    }
                    
                    IconButton(onClick = { selectedEpochDayCash = nextEpoch ?: (selectedEpochDayCash + 1) }) { 
                        Icon(Icons.Rounded.ChevronRight, "Successivo", tint = if (nextEpoch != null) Color(0xFF10B981) else Color.White.copy(alpha = 0.3f)) 
                    }
                }

                Spacer(Modifier.height(8.dp))

                if (cashDisplayedForDay.isEmpty()) {
                    Box(modifier = Modifier.fillMaxWidth().padding(32.dp), contentAlignment = Alignment.Center) {
                        Text("Nessun movimento in questa data", color = Color(0xFFA0A0A0))
                    }
                } else {
                    LazyColumn(modifier = Modifier.fillMaxWidth().weight(1f, fill = false)) {
                        items(cashDisplayedForDay, key = { "cash_${it.id}" }) { tx ->
                            val displayName = tx.merchantKey?.replace(Regex("\\[.*?\\]"), "")?.trim()?.takeIf { it.isNotBlank() } ?: "Contanti"
                            val dateStr = formatDayMonth(LocalDate.fromEpochDays(tx.dateEpochDay.toInt()))

                            val isIncome = tx.type == "INCOME"
                            val isTransfer = tx.type == "TRANSFER"
                            val signUI = if (isIncome) "+" else if (isTransfer) "" else "-"
                            val colorUI = if (isIncome) Color(0xFF10B981) else if (isTransfer) Color(0xFF60A5FA) else Color.White

                            val isSelected = selectedTxIds.contains(tx.id)
                            val rowBgColor by animateColorAsState(
                                if (isSelected) Color(0xFF10B981).copy(alpha = 0.15f) else Color.Transparent
                            )

                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .clip(RoundedCornerShape(8.dp))
                                    .background(rowBgColor)
                                    .combinedClickable(
                                        interactionSource = remember { MutableInteractionSource() },
                                        indication = null,
                                        onClick = {
                                            haptic.performHapticFeedback(HapticFeedbackType.TextHandleMove)
                                            if (selectionMode) toggleSelection(tx.id)
                                            else { detailsTransaction = tx }
                                        },
                                        onLongClick = {
                                            haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                                            if (!selectionMode) { selectionMode = true; selectedTxIds.add(tx.id) }
                                            else toggleSelection(tx.id)
                                        }
                                    )
                                    .padding(vertical = 12.dp, horizontal = 4.dp),
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.SpaceBetween
                            ) {
                                Box(contentAlignment = Alignment.Center, modifier = Modifier.size(40.dp)) {
                                    if (isSelected) {
                                        Icon(
                                            imageVector = Icons.Rounded.CheckCircle,
                                            contentDescription = "Selezionato",
                                            tint = Color(0xFF10B981),
                                            modifier = Modifier.size(32.dp)
                                        )
                                    } else {
                                        TxLogo(tx.logoEmoji ?: "💶", tx.logoUri, displayName, Modifier.fillMaxSize())
                                    }
                                }

                                Spacer(Modifier.width(12.dp))
                                Column(modifier = Modifier.weight(1f)) {
                                    Text(displayName, style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold), color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                    Text(dateStr, style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                                }
                                ModernMoneyText(
                                    cents = tx.amountCents,
                                    hideBalances = hideBalances,
                                    color = colorUI,
                                    sign = signUI,
                                    integerFontSize = 16.sp, decimalFontSize = 12.sp, symbolFontSize = 12.sp
                                )
                            }
                            HorizontalDivider(color = MaterialTheme.colorScheme.outline.copy(alpha = 0.05f))
                        }
                    }
                }
                Spacer(Modifier.height(24.dp))
            }
        }
    }

    if (showAddGenericCash) {
        var subAmountText by remember { mutableStateOf("") }
        var subMerchant by remember { mutableStateOf("") }
        var isExpense by remember { mutableStateOf(true) }

        val initialDateStr = "${today.dayOfMonth.toString().padStart(2, '0')}/${today.monthNumber.toString().padStart(2, '0')}/${today.year}"
        var dateTFV by remember { mutableStateOf(TextFieldValue(initialDateStr, TextRange(initialDateStr.length))) }

        var logoEmoji by remember { mutableStateOf("💶") }
        var logoUri by remember { mutableStateOf<String?>(null) }
        var showEmojiInput by remember { mutableStateOf(false) }
        var showWebSearch by remember { mutableStateOf(false) }

        val themeColor = if (isExpense) Color(0xFFEF4444) else Color(0xFF10B981)

        AlertDialog(
            onDismissRequest = { showAddGenericCash = false },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color(0xFF1E1B4B),
            title = {
                Text(
                    text = if (isExpense) "Nuova Spesa in Contanti" else "Nuova Entrata in Contanti",
                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                    color = themeColor
                )
            },
            text = {
                Column(verticalArrangement = Arrangement.spacedBy(14.dp)) {
                    Text(
                        "Questo movimento modificherà solo il totale dei contanti in tasca.",
                        style = MaterialTheme.typography.bodySmall,
                        color = Color(0xFFA0A0A0)
                    )

                    Row(modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(12.dp)).background(Color.White.copy(alpha = 0.10f))) {
                        Surface(
                            onClick = { isExpense = true },
                            shape = RoundedCornerShape(12.dp),
                            color = if (isExpense) Color(0xFFEF4444).copy(alpha = 0.25f) else Color.Transparent,
                            modifier = Modifier.weight(1f).height(40.dp)
                        ) { Box(contentAlignment = Alignment.Center) { Text("Spesa (-)", color = if(isExpense) Color(0xFFEF4444) else Color(0xFFA0A0A0), fontWeight = FontWeight.Bold) } }

                        Surface(
                            onClick = { isExpense = false },
                            shape = RoundedCornerShape(12.dp),
                            color = if (!isExpense) Color(0xFF10B981).copy(alpha = 0.25f) else Color.Transparent,
                            modifier = Modifier.weight(1f).height(40.dp)
                        ) { Box(contentAlignment = Alignment.Center) { Text("Entrata (+)", color = if(!isExpense) Color(0xFF10B981) else Color(0xFFA0A0A0), fontWeight = FontWeight.Bold) } }
                    }

                    OutlinedTextField(
                        value = subAmountText,
                        onValueChange = { if (it.all { c -> c.isDigit() || c == ',' || c == '.' }) subAmountText = it },
                        label = { Text("Importo (€)", color = Color(0xFFA0A0A0)) },
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                        singleLine = true,
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(12.dp),
                        colors = OutlinedTextFieldDefaults.colors(
                            focusedTextColor = Color.White, unfocusedTextColor = Color.White,
                            focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                            focusedBorderColor = themeColor, unfocusedBorderColor = Color.White.copy(alpha = 0.20f)
                        )
                    )

                    OutlinedTextField(
                        value = dateTFV,
                        onValueChange = { newVal ->
                            val oldText = dateTFV.text
                            val newText = newVal.text
                            if (newText.length < oldText.length) {
                                dateTFV = newVal
                            } else {
                                val clean = newText.replace("/", "").filter { it.isDigit() }
                                val formatted = buildString {
                                    for (i in clean.indices) {
                                        append(clean[i])
                                        if ((i == 1 || i == 3) && i < 7) append("/")
                                    }
                                }.take(10)
                                dateTFV = TextFieldValue(formatted, TextRange(formatted.length))
                            }
                        },
                        label = { Text("Data (GG/MM/AAAA)", color = Color(0xFFA0A0A0)) },
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                        singleLine = true,
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(12.dp),
                        colors = OutlinedTextFieldDefaults.colors(
                            focusedTextColor = Color.White, unfocusedTextColor = Color.White,
                            focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                            focusedBorderColor = themeColor, unfocusedBorderColor = Color.White.copy(alpha = 0.20f)
                        )
                    )

                    OutlinedTextField(
                        value = subMerchant,
                        onValueChange = { subMerchant = it },
                        label = { Text("Descrizione o Negozio", color = Color(0xFFA0A0A0)) },
                        singleLine = true,
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(12.dp),
                        colors = OutlinedTextFieldDefaults.colors(
                            focusedTextColor = Color.White, unfocusedTextColor = Color.White,
                            focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                            focusedBorderColor = themeColor, unfocusedBorderColor = Color.White.copy(alpha = 0.20f)
                        )
                    )

                    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                        TxLogo(
                            logoEmoji = logoEmoji,
                            logoUri = logoUri,
                            name = subMerchant,
                            modifier = Modifier.size(44.dp).border(1.dp, themeColor.copy(alpha = 0.3f), CircleShape)
                        )
                        Row(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                            OutlinedButton(
                                onClick = { showEmojiInput = !showEmojiInput; showWebSearch = false },
                                shape = RoundedCornerShape(10.dp),
                                contentPadding = PaddingValues(horizontal = 10.dp),
                                modifier = Modifier.height(36.dp)
                            ) { Text("EMOJI", style = MaterialTheme.typography.labelSmall, color = Color.White) }

                            OutlinedButton(
                                onClick = { showWebSearch = true; showEmojiInput = false },
                                shape = RoundedCornerShape(10.dp),
                                contentPadding = PaddingValues(horizontal = 10.dp),
                                modifier = Modifier.height(36.dp)
                            ) { Text("WEB", style = MaterialTheme.typography.labelSmall, color = Color.White) }
                        }
                    }

                    AnimatedVisibility(visible = showEmojiInput) {
                        OutlinedTextField(
                            value = logoEmoji,
                            onValueChange = { if (it.length <= 3) { logoEmoji = it; logoUri = null } },
                            label = { Text("Inserisci Emoji", color = Color(0xFFA0A0A0)) },
                            singleLine = true,
                            modifier = Modifier.fillMaxWidth(),
                            shape = RoundedCornerShape(12.dp),
                            colors = OutlinedTextFieldDefaults.colors(
                                focusedTextColor = Color.White, unfocusedTextColor = Color.White,
                                focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                                focusedBorderColor = themeColor, unfocusedBorderColor = Color.White.copy(alpha = 0.20f)
                            )
                        )
                    }
                }
            },
            confirmButton = {
                Button(
                    onClick = {
                        val cents = (subAmountText.replace(",", ".").toDoubleOrNull()?.times(100))?.toLong() ?: 0L
                        val txEpochDay = parseDayMonthYearSafe(dateTFV.text) ?: todayEpoch
                        if (cents > 0) {
                            val nowMs = Clock.System.now().toEpochMilliseconds()
                            val subTx = TransactionEntity(
                                id = "tx_cash_gen_${nowMs}_${Random.nextInt(1000)}",
                                accountId = "sys_cash_generic",
                                toAccountId = null,
                                fromAccountId = null,
                                amountCents = cents,
                                type = if (isExpense) "EXPENSE" else "INCOME",
                                dateEpochDay = txEpochDay,
                                categoryId = "default",
                                description = "Contanti liberi [cash:generic]",
                                merchantKey = subMerchant.trim().ifBlank { "Contanti" },
                                subcategoryText = "Gestione Cash",
                                logoEmoji = logoEmoji.ifBlank { "💶" },
                                logoUri = logoUri,
                                isHidden = false,
                                isDeleted = false,
                                reminderDays = null,
                                createdAtEpochMs = nowMs,
                                updatedAtEpochMs = nowMs
                            )
                            onSaveTransaction(subTx)
                            showAddGenericCash = false
                        }
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = themeColor, contentColor = Color.White)
                ) {
                    Text("AGGIUNGI", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = {
                TextButton(onClick = { showAddGenericCash = false }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) }
            }
        )

        if (showWebSearch) {
            WebLogoSearchDialog(
                onDismiss = { showWebSearch = false },
                onLogoSelected = { uri ->
                    logoUri = uri
                    logoEmoji = "💶"
                    showWebSearch = false
                }
            )
        }
    }

    // ==========================================
    // 🚀 MINI-POPUP: GESTIONE RISPARMI RAPIDA E PULITA (Versa/Preleva Avanzato)
    // ==========================================
    if (showAddGenericSavings) {
        var subAmountText by remember { mutableStateOf("") }
        var isDeposit by remember { mutableStateOf(true) }

        // 🚀 FILTRIAMO I NOMI: Via tutti i brutti tag [PAC:], [ACC:] ecc.
        val allTargets = remember(piggyBanks, savingsGoals) {
            val pbs = piggyBanks.map { Triple("pb", it.id, it) to "${it.emoji.takeIf { e -> e.isNotBlank() } ?: "🪙"} ${it.name.replace(Regex("\\[.*?\\]"), "").trim()}" }
            val pacs = savingsGoals.filter { it.name.contains("[PAC:") }.map { Triple("pac_sav", it.id, it) to "${it.emoji?.takeIf { e -> e.isNotBlank() } ?: "🤖"} ${it.name.replace(Regex("\\[.*?\\]"), "").trim()}" }
            val savs = savingsGoals.filter { !it.name.contains("[PAC:") }.map { Triple("sav", it.id, it) to "${it.emoji?.takeIf { e -> e.isNotBlank() } ?: "🎯"} ${it.name.replace(Regex("\\[.*?\\]"), "").trim()}" }
            pbs + pacs + savs
        }

        var selectedTarget by remember { mutableStateOf(allTargets.firstOrNull()) }
        var expanded by remember { mutableStateOf(false) }
        var isFirstTap by remember { mutableStateOf(true) }

        // Ricaviamo in sicurezza il conto attivo e gli altri conti
        val safeAccId = selectedFilterAccountId ?: accounts.firstOrNull { !it.isDeleted && !it.isArchived }?.id ?: ""
        val otherAccs = accounts.filter { it.id != safeAccId && !it.isDeleted && !it.isArchived }

        // 🚀 STATI PER LE 3 OPZIONI DI PRELIEVO AVANZATE
        var selectedAction by remember { mutableStateOf("AVAILABLE") }
        var selectedTransferAccountId by remember { mutableStateOf(otherAccs.firstOrNull()?.id ?: "") }
        var expandedAccountMenu by remember { mutableStateOf(false) }

        val cents = (subAmountText.replace(",", ".").toDoubleOrNull()?.times(100))?.toLong() ?: 0L

        // Calcolo Max Balance per impedire scoperti durante il prelievo
        val targetMaxBalance = remember(selectedTarget, piggyBanks, savingsGoals) {
            when (selectedTarget?.first?.first) {
                "pb" -> piggyBanks.find { it.id == selectedTarget?.first?.second }?.accumulatedCents ?: 0L
                "sav", "pac_sav" -> savingsGoals.find { it.id == selectedTarget?.first?.second }?.savedAmountCents ?: 0L
                else -> 0L
            }
        }

        val isOverdraft = if (isDeposit) cents > displayBalanceCents else cents > targetMaxBalance
        val brandPrimary = MaterialTheme.colorScheme.primary

        Dialog(
            onDismissRequest = { showAddGenericSavings = false },
            properties = DialogProperties(usePlatformDefaultWidth = false)
        ) {
            Surface(
                shape = RoundedCornerShape(28.dp),
                color = Color.White.copy(alpha = 0.10f),
                border = BorderStroke(1.5.dp, Color.White.copy(alpha = 0.25f)),
                shadowElevation = 24.dp,
                modifier = Modifier.padding(horizontal = 16.dp, vertical = 24.dp).fillMaxWidth().widthIn(max = 400.dp)
            ) {
                Column(modifier = Modifier.padding(24.dp), verticalArrangement = Arrangement.spacedBy(16.dp)) {
                    Text("Gestione Risparmi", style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Black, color = Color(0xFF60A5FA)))

                    // INTERRUTTORE VERSA/PRELEVA
                    Row(modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(12.dp)).background(Color.White.copy(alpha = 0.10f))) {
                        Box(modifier = Modifier.weight(1f).clickable { isDeposit = true }.background(if(isDeposit) Color(0xFF60A5FA) else Color.Transparent).padding(vertical = 12.dp), contentAlignment = Alignment.Center) { Text("VERSA (+)", color = if(isDeposit) Color.White else Color(0xFFA0A0A0), fontWeight = FontWeight.Bold, fontSize = 12.sp) }
                        Box(modifier = Modifier.weight(1f).clickable { isDeposit = false }.background(if(!isDeposit) MaterialTheme.colorScheme.error else Color.Transparent).padding(vertical = 12.dp), contentAlignment = Alignment.Center) { Text("PRELEVA (-)", color = if(!isDeposit) Color.White else Color(0xFFA0A0A0), fontWeight = FontWeight.Bold, fontSize = 12.sp) }
                    }

                    // TENDINA CON NOMI PULITI (Senza tag [PAC:] ecc.)
                    if (allTargets.isNotEmpty()) {
                        ExposedDropdownMenuBox(expanded = expanded, onExpandedChange = { expanded = !expanded }) {
                            OutlinedTextField(
                                value = selectedTarget?.second ?: "Seleziona",
                                onValueChange = {}, readOnly = true,
                                label = { Text(if (isDeposit) "Destinazione" else "Origine", color = Color(0xFFA0A0A0)) },
                                modifier = Modifier.fillMaxWidth().menuAnchor(),
                                trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expanded) },
                                shape = RoundedCornerShape(12.dp),
                                colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF60A5FA), unfocusedBorderColor = Color.White.copy(alpha = 0.20f))
                            )
                            ExposedDropdownMenu(expanded = expanded, onDismissRequest = { expanded = false }, modifier = Modifier.background(Color(0xFF1C1C1E))) {
                                allTargets.forEach { target ->
                                    DropdownMenuItem(text = { Text(target.second, color = Color.White) }, onClick = { selectedTarget = target; expanded = false })
                                }
                            }
                        }
                    }

                    // INPUT IMPORTO
                    OutlinedTextField(
                        value = subAmountText,
                        onValueChange = { subAmountText = it.replace(Regex("[^0-9.,]"), "") },
                        label = { Text("Importo (€)", color = Color(0xFFA0A0A0)) },
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                        singleLine = true,
                        modifier = Modifier.fillMaxWidth().onFocusChanged { if (it.isFocused && isFirstTap) { subAmountText = ""; isFirstTap = false } },
                        shape = RoundedCornerShape(12.dp),
                        isError = isOverdraft,
                        colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF60A5FA), unfocusedBorderColor = Color.White.copy(alpha = 0.20f))
                    )

                    if (isOverdraft) {
                        Text(if (isDeposit) "Supera la liquidità disponibile!" else "Supera il saldo del fondo!", color = MaterialTheme.colorScheme.error, fontSize = 12.sp)
                    } else if (!isDeposit && selectedTarget != null) {
                        Text("Disponibili nel fondo: ${formatEuroFromCents(targetMaxBalance, false)}", color = Color(0xFFA0A0A0), fontSize = 12.sp)
                    }

                    // 🚀 LE 3 OPZIONI DI PRELIEVO (Righe cliccabili integrate a prova di errore)
                    AnimatedVisibility(visible = !isDeposit) {
                        Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                            HorizontalDivider(modifier = Modifier.padding(vertical = 8.dp), color = Color.White.copy(alpha = 0.15f))
                            Text("Opzioni di Sblocco", style = MaterialTheme.typography.labelSmall, color = Color.White)

                            val optColor = Color(0xFF60A5FA)

                            // OPZIONE 1: RIMETTI NEL DISPONIBILE
                            val bg1 by animateColorAsState(if (selectedAction == "AVAILABLE") optColor.copy(alpha = 0.25f) else Color.White.copy(alpha = 0.08f))
                            val border1 by animateColorAsState(if (selectedAction == "AVAILABLE") optColor.copy(alpha = 0.6f) else Color.White.copy(alpha = 0.15f))
                            Surface(modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(16.dp)).clickable { selectedAction = "AVAILABLE" }, color = bg1, border = BorderStroke(1.dp, border1)) {
                                Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
                                    Icon(Icons.Default.ArrowBack, null, tint = if(selectedAction == "AVAILABLE") optColor else Color(0xFFA0A0A0))
                                    Spacer(Modifier.width(16.dp))
                                    Column(modifier = Modifier.weight(1f)) {
                                        Text("Rimetti nel Disponibile", fontWeight = FontWeight.Bold, fontSize = 15.sp, color = if(selectedAction == "AVAILABLE") optColor else Color.White)
                                        Text("I soldi tornano nel saldo dell'app.", fontSize = 12.sp, color = Color(0xFFA0A0A0))
                                    }
                                }
                            }

                            // OPZIONE 2: PRELEVA IN CONTANTI
                            val bg2 by animateColorAsState(if (selectedAction == "CASH") optColor.copy(alpha = 0.25f) else Color.White.copy(alpha = 0.08f))
                            val border2 by animateColorAsState(if (selectedAction == "CASH") optColor.copy(alpha = 0.6f) else Color.White.copy(alpha = 0.15f))
                            Surface(modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(16.dp)).clickable { selectedAction = "CASH" }, color = bg2, border = BorderStroke(1.dp, border2)) {
                                Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
                                    Icon(Icons.Default.AccountBalanceWallet, null, tint = if(selectedAction == "CASH") optColor else Color(0xFFA0A0A0))
                                    Spacer(Modifier.width(16.dp))
                                    Column(modifier = Modifier.weight(1f)) {
                                        Text("Preleva in Contanti", fontWeight = FontWeight.Bold, fontSize = 15.sp, color = if(selectedAction == "CASH") optColor else Color.White)
                                        Text("Registra un prelievo fisico in banca.", fontSize = 12.sp, color = Color(0xFFA0A0A0))
                                    }
                                }
                            }

                            if (otherAccs.isNotEmpty()) {
                                // OPZIONE 3: GIROCONTO
                                val bg3 by animateColorAsState(if (selectedAction == "TRANSFER") optColor.copy(alpha = 0.25f) else Color.White.copy(alpha = 0.08f))
                                val border3 by animateColorAsState(if (selectedAction == "TRANSFER") optColor.copy(alpha = 0.6f) else Color.White.copy(alpha = 0.15f))
                                Surface(modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(16.dp)).clickable { selectedAction = "TRANSFER" }, color = bg3, border = BorderStroke(1.dp, border3)) {
                                    Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
                                        Icon(Icons.Default.SwapHoriz, null, tint = if(selectedAction == "TRANSFER") optColor else Color(0xFFA0A0A0))
                                        Spacer(Modifier.width(16.dp))
                                        Column(modifier = Modifier.weight(1f)) {
                                            Text("Sposta su altro Conto", fontWeight = FontWeight.Bold, fontSize = 15.sp, color = if(selectedAction == "TRANSFER") optColor else Color.White)
                                            Text("Esegui un giroconto verso un'altra carta.", fontSize = 12.sp, color = Color(0xFFA0A0A0))
                                        }
                                    }
                                }

                                AnimatedVisibility(visible = selectedAction == "TRANSFER") {
                                    ExposedDropdownMenuBox(expanded = expandedAccountMenu, onExpandedChange = { expandedAccountMenu = !expandedAccountMenu }, modifier = Modifier.padding(top = 8.dp)) {
                                        OutlinedTextField(value = accounts.find { it.id == selectedTransferAccountId }?.name ?: "Seleziona Conto", onValueChange = {}, readOnly = true, modifier = Modifier.fillMaxWidth().menuAnchor(), trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expandedAccountMenu) }, shape = RoundedCornerShape(12.dp), colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF60A5FA), unfocusedBorderColor = Color.White.copy(alpha = 0.20f)))
                                        ExposedDropdownMenu(expanded = expandedAccountMenu, onDismissRequest = { expandedAccountMenu = false }, modifier = Modifier.background(Color(0xFF1C1C1E))) { otherAccs.forEach { account -> DropdownMenuItem(text = { Text(account.name, color = Color.White) }, onClick = { selectedTransferAccountId = account.id; expandedAccountMenu = false }) } }
                                    }
                                }
                            }
                        }
                    }

                    Row(modifier = Modifier.fillMaxWidth().padding(top = 8.dp), horizontalArrangement = Arrangement.End) {
                        TextButton(onClick = { showAddGenericSavings = false }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) }
                        Spacer(Modifier.width(12.dp))

                        val isSaveEnabled = cents > 0L && !isOverdraft && selectedTarget != null && (isDeposit || selectedAction != "TRANSFER" || selectedTransferAccountId.isNotBlank())

                        Button(
                            onClick = {
                                val nowMs = Clock.System.now().toEpochMilliseconds()
                                val typeStr = selectedTarget!!.first.first
                                val idStr = selectedTarget!!.first.second
                                val nameStr = selectedTarget!!.second.substringAfter(" ")
                                val tag = "[$typeStr:$idStr]"

                                val targetEpochDay = detailsTransaction?.dateEpochDay ?: todayEpoch

                                if (isDeposit) {
                                    val subTx = TransactionEntity(
                                        id = "tx_save_${nowMs}_${Random.nextInt(1000)}",
                                        accountId = safeAccId, toAccountId = null, fromAccountId = safeAccId,
                                        amountCents = cents, type = "TRANSFER", dateEpochDay = targetEpochDay, categoryId = "cat_savings_auto",
                                        description = "Versamento: $nameStr", merchantKey = "Fondo: $nameStr $tag",
                                        subcategoryText = "Risparmi", logoEmoji = selectedTarget!!.second.take(1).takeIf { it.isNotBlank() } ?: "💰", logoUri = null,
                                        isHidden = false, isDeleted = false, reminderDays = null,
                                        createdAtEpochMs = nowMs, updatedAtEpochMs = nowMs
                                    )
                                    onSaveTransaction(subTx)
                                } else {
                                    when (selectedAction) {
                                        "AVAILABLE" -> {
                                            val sbloccoTx = TransactionEntity(
                                                id = "tx_ret_${nowMs}", accountId = safeAccId, toAccountId = null, fromAccountId = null,
                                                amountCents = -cents, type = "EXPENSE", dateEpochDay = targetEpochDay, categoryId = "",
                                                description = "Sblocco fondi da: $nameStr", merchantKey = "Fondo: $nameStr $tag",
                                                subcategoryText = "Sblocco Risparmi", logoEmoji = "🔓", logoUri = "",
                                                isHidden = false, isDeleted = false, reminderDays = null, createdAtEpochMs = nowMs, updatedAtEpochMs = nowMs
                                            )
                                            onSaveTransaction(sbloccoTx)
                                        }
                                        "CASH" -> {
                                            val sbloccoCashTx = TransactionEntity(
                                                id = "tx_cash_ret_${nowMs}", accountId = "sys_cash_generic", toAccountId = null, fromAccountId = null,
                                                amountCents = cents, type = "INCOME", dateEpochDay = targetEpochDay, categoryId = "",
                                                description = "Prelievo in Contanti da: $nameStr", merchantKey = "Fondo: $nameStr $tag [cash:generic]",
                                                subcategoryText = "Prelievo Cash", logoEmoji = "💶", logoUri = "",
                                                isHidden = false, isDeleted = false, reminderDays = null, createdAtEpochMs = nowMs, updatedAtEpochMs = nowMs
                                            )
                                            onSaveTransaction(sbloccoCashTx)
                                        }
                                        "TRANSFER" -> {
                                            val sbloccoTx = TransactionEntity(
                                                id = "tx_ret_${nowMs}", accountId = safeAccId, toAccountId = null, fromAccountId = null,
                                                amountCents = -cents, type = "EXPENSE", dateEpochDay = targetEpochDay, categoryId = "",
                                                description = "Sblocco fondi da: $nameStr", merchantKey = "Fondo: $nameStr $tag",
                                                subcategoryText = "Sblocco Risparmi", logoEmoji = "🔓", logoUri = "",
                                                isHidden = false, isDeleted = false, reminderDays = null, createdAtEpochMs = nowMs, updatedAtEpochMs = nowMs
                                            )
                                            onSaveTransaction(sbloccoTx)

                                            val transTx = TransactionEntity(
                                                id = "tx_trans_ret_${nowMs}", accountId = safeAccId, toAccountId = selectedTransferAccountId, fromAccountId = safeAccId,
                                                amountCents = cents, type = "TRANSFER", dateEpochDay = targetEpochDay, categoryId = "",
                                                description = "Giroconto in uscita (da fondo)", merchantKey = "Giroconto",
                                                subcategoryText = "Giroconto", logoEmoji = "🔄", logoUri = "",
                                                isHidden = false, isDeleted = false, reminderDays = null, createdAtEpochMs = nowMs + 1, updatedAtEpochMs = nowMs + 1
                                            )
                                            onSaveTransaction(transTx)
                                        }
                                    }
                                }
                                showAddGenericSavings = false
                            },
                            enabled = isSaveEnabled,
                            shape = RoundedCornerShape(12.dp),
                            colors = ButtonDefaults.buttonColors(containerColor = if(isDeposit) Color(0xFF60A5FA) else MaterialTheme.colorScheme.error)
                        ) { Text("CONFERMA", fontWeight = FontWeight.Bold) }
                    }
                }
            }
        }
    }

    if (txToVaporize != null) {
        AlertDialog(
            onDismissRequest = { txToVaporize = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Text(
                    "Vaporizza Movimento 💨",
                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                    color = Color(0xFFEF4444)
                )
            },
            text = {
                Text(
                    "Questa operazione distruggerà i dati originali di questo movimento (negozio, note, categoria) e lo renderà invisibile, mantenendo il saldo intatto.\n\nIrreversibile.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = Color(0xFFA0A0A0)
                )
            },
            confirmButton = {
                Button(
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFEF4444), contentColor = Color.White),
                    onClick = {
                        txToVaporize?.let { tx ->
                            val tagRegex = Regex("\\[(pb|goal|pac_sav|sav|ACC|PAC|rec|fin|p|cash):[^\\]]+\\]", RegexOption.IGNORE_CASE)
                            val tagsInMerchant = tagRegex.findAll(tx.merchantKey ?: "").map { it.value }.joinToString(" ")
                            val tagsInDesc = tagRegex.findAll(tx.description ?: "").map { it.value }.joinToString(" ")
                            val preservedTags = "$tagsInMerchant $tagsInDesc".split(" ").filter { it.isNotBlank() }.distinct().joinToString(" ")

                            val newMerchantKey = if (preservedTags.isNotBlank()) "Conguaglio $preservedTags" else "Conguaglio"

                            val vaporizedTx = tx.copy(
                                description = "Allineamento di sistema",
                                merchantKey = newMerchantKey,
                                categoryId = "sys_vaporized",
                                subcategoryText = "Vaporizzato",
                                logoEmoji = "💨",
                                logoUri = null,
                                isHidden = true,
                                updatedAtEpochMs = Clock.System.now().toEpochMilliseconds()
                            )
                            onSaveTransaction(vaporizedTx)
                            scope.launch { snackbarHostState.showSnackbar("Vaporizzato. 💨", duration = SnackbarDuration.Short) }
                        }
                        txToVaporize = null
                    }
                ) {
                    Text("VAPORIZZA", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = {
                TextButton(onClick = { txToVaporize = null }) {
                    Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }
        )
    }

    // ==========================================
    // 🚀 BOTTOM SHEETS PER NASCOSTI
    // ==========================================
    if (showHiddenSheet) {
        ModalBottomSheet(
            onDismissRequest = { showHiddenSheet = false },
            containerColor = Color.White.copy(alpha = 0.12f),
            shape = RoundedCornerShape(topStart = 28.dp, topEnd = 28.dp)
        ) {
            Column(modifier = Modifier.fillMaxWidth().padding(horizontal = 24.dp, vertical = 16.dp)) {

                val selectedHiddenCount = selectedTxIds.count { id -> hiddenFiltered.any { it.id == id } }

                if (selectionMode && selectedHiddenCount > 0) {
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(bottom = 8.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        IconButton(onClick = { clearSelection() }, modifier = Modifier.size(36.dp)) {
                            Icon(Icons.Default.Close, contentDescription = "Annulla")
                        }
                        Text(
                            "$selectedHiddenCount Selezionati",
                            style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                            color = brandPrimary,
                            modifier = Modifier.weight(1f).padding(start = 8.dp)
                        )

                        IconButton(
                            onClick = {
                                selectedTxIds.forEach { id ->
                                    val tx = allTransactions.find { it.id == id }
                                    if (tx != null) onUnhide(tx.copy(isHidden = false))
                                }
                                clearSelection()
                            },
                            modifier = Modifier.size(36.dp)
                        ) {
                            Icon(Icons.Outlined.Visibility, contentDescription = "Scopri", tint = MaterialTheme.colorScheme.primary)
                        }

                        Spacer(Modifier.width(12.dp))

                        IconButton(onClick = { 
                            showHiddenSheet = false
                            showMultiVaporizeConfirm = true 
                        }, modifier = Modifier.size(36.dp)) {
                            Text("💨", fontSize = 20.sp)
                        }
                        IconButton(onClick = { 
                            showHiddenSheet = false
                            showMultiDeleteConfirm = true 
                        }, modifier = Modifier.size(36.dp)) {
                            Icon(Icons.Outlined.Delete, contentDescription = "Elimina", tint = MaterialTheme.colorScheme.error)
                        }
                    }
                } else {
                    Text("Movimenti Nascosti", style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Black), color = brandPrimary)
                    Text("Transazioni escluse dal calcolo dei saldi.", style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                }

                Spacer(Modifier.height(16.dp))
                LazyColumn(modifier = Modifier.fillMaxWidth()) {
                    items(hiddenFiltered, key = { "hid_${it.id}" }) { tx ->
                        val displayName = tx.merchantKey?.replace(Regex("\\[.*?\\]"), "")?.trim()?.takeIf { it.isNotBlank() } ?: tx.description ?: "Movimento"
                        val dateStr = formatDayMonth(LocalDate.fromEpochDays(tx.dateEpochDay.toInt()))

                        val isIncome = tx.type == "INCOME"
                        val isTransfer = tx.type == "TRANSFER"
                        val signUI = if (isIncome) "+" else if (isTransfer) "" else "-"
                        val colorUI = if (isIncome) Color(0xFF10B981) else if (isTransfer) Color(0xFF60A5FA) else Color.White

                        val isSelected = selectedTxIds.contains(tx.id)
                        val rowBgColor by animateColorAsState(
                            if (isSelected) MaterialTheme.colorScheme.primary.copy(alpha = 0.15f) else Color.Transparent
                        )

                        Row(
                            Modifier
                                .fillMaxWidth()
                                .clip(RoundedCornerShape(8.dp))
                                .background(rowBgColor)
                                .combinedClickable(
                                    interactionSource = remember { MutableInteractionSource() },
                                    indication = null,
                                    onClick = {
                                        haptic.performHapticFeedback(HapticFeedbackType.TextHandleMove)
                                        if (selectionMode) toggleSelection(tx.id)
                                        else { detailsTransaction = tx }
                                    },
                                    onLongClick = {
                                        haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                                        if (!selectionMode) { selectionMode = true; selectedTxIds.add(tx.id) }
                                        else toggleSelection(tx.id)
                                    }
                                )
                                .padding(vertical = 12.dp, horizontal = 4.dp),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Box(contentAlignment = Alignment.Center, modifier = Modifier.size(40.dp)) {
                                if (isSelected) {
                                    Icon(
                                        imageVector = Icons.Rounded.CheckCircle,
                                        contentDescription = "Selezionato",
                                        tint = MaterialTheme.colorScheme.primary,
                                        modifier = Modifier.size(32.dp)
                                    )
                                } else {
                                    TxLogo(tx.logoEmoji ?: "👻", tx.logoUri, displayName, Modifier.fillMaxSize())
                                }
                            }

                            Spacer(Modifier.width(12.dp))
                            Column(modifier = Modifier.weight(1f)) {
                                Text(displayName, style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold), color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                Text(dateStr, style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                            }

                            // 🚀 DECIMAL FORMATTER
                            ModernMoneyText(
                                cents = tx.amountCents,
                                hideBalances = hideBalances,
                                sign = signUI,
                                color = colorUI,
                                integerFontSize = 16.sp,
                                decimalFontSize = 12.sp,
                                symbolFontSize = 12.sp
                            )
                        }
                        HorizontalDivider(color = MaterialTheme.colorScheme.outline.copy(alpha = 0.05f))
                    }
                }
                Spacer(Modifier.height(24.dp))
            }
        }
    }

    // ==========================================
    // 🚀 POPUP RAPIDO "DI CUI IN CONTANTI"
    // ==========================================
    quickSubTransactionsTx?.let { parentTx ->
        val subs = subExpensesMap[parentTx.id] ?: emptyList()
        val totalSubSpent = subs.fold(0L) { acc, it -> acc + if(it.amountCents < 0L) -it.amountCents else it.amountCents }
        val parentCents = if(parentTx.amountCents < 0L) -parentTx.amountCents else parentTx.amountCents
        val remainingCash = parentCents - totalSubSpent
        val cashProgress = if (parentCents > 0L) (totalSubSpent.toFloat() / parentCents.toFloat()).coerceIn(0f, 1f) else 0f

        Dialog(
            onDismissRequest = { quickSubTransactionsTx = null },
            properties = DialogProperties(usePlatformDefaultWidth = false)
        ) {
            Surface(
                modifier = Modifier.padding(horizontal = 16.dp, vertical = 24.dp).fillMaxWidth().fillMaxHeight(0.6f),
                shape = RoundedCornerShape(28.dp),
                color = Color.White.copy(alpha = 0.12f),
                border = BorderStroke(1.5.dp, Color.White.copy(alpha = 0.40f)),
                shadowElevation = 0.dp
            ) {
                Column(Modifier.fillMaxSize().padding(24.dp)) {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Icon(Icons.Default.AccountBalanceWallet, contentDescription = null, tint = Color(0xFF60A5FA), modifier = Modifier.size(24.dp))
                        Spacer(Modifier.width(8.dp))
                        Text("Di cui in contanti", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                    }
                    Spacer(Modifier.height(16.dp))

                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                        Text("Speso: ${formatEuroFromCents(totalSubSpent, false)}", style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0))
                        Text("Rimanenza: ${formatEuroFromCents(remainingCash, false)}", style = MaterialTheme.typography.bodySmall.copy(fontWeight = FontWeight.Bold), color = if (remainingCash >= 0L) Color(0xFF10B981) else MaterialTheme.colorScheme.error)
                    }
                    Spacer(Modifier.height(8.dp))
                    LinearProgressIndicator(
                        progress = { cashProgress },
                        modifier = Modifier.fillMaxWidth().height(8.dp).clip(CircleShape),
                        color = Color(0xFF60A5FA),
                        trackColor = Color.White.copy(alpha = 0.1f)
                    )

                    Spacer(Modifier.height(16.dp))
                    HorizontalDivider(color = Color.White.copy(alpha = 0.15f))
                    Spacer(Modifier.height(8.dp))

                    LazyColumn(modifier = Modifier.weight(1f)) {
                        items(subs, key = { it.id }) { sub ->
                            val subDate = LocalDate.fromEpochDays(sub.dateEpochDay.toInt())
                            val dStr = "${subDate.dayOfMonth.toString().padStart(2, '0')}/${subDate.monthNumber.toString().padStart(2, '0')}"
                            Row(modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.SpaceBetween) {
                                Column(modifier = Modifier.weight(1f)) {
                                    val cleanName = sub.merchantKey?.replace(Regex("\\[cash:[^\\]]+\\]"), "")?.replace(" \uD83D\uDC7B (Promemoria)", "")?.trim()?.takeIf { it.isNotBlank() } ?: "Spesa Cash"
                                    Text(cleanName, style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold), color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                    Text(dStr, style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                                }

                                ModernMoneyText(
                                    cents = sub.amountCents,
                                    hideBalances = hideBalances,
                                    color = Color.White,
                                    integerFontSize = 14.sp,
                                    decimalFontSize = 10.sp,
                                    symbolFontSize = 10.sp
                                )

                                IconButton(
                                    onClick = { onDelete(allTransactions.find { it.id == sub.id } ?: sub) },
                                    modifier = Modifier.size(32.dp)
                                ){
                                    Icon(Icons.Outlined.Delete, null, tint = MaterialTheme.colorScheme.error, modifier = Modifier.size(18.dp))
                                }
                            }
                            HorizontalDivider(color = Color.White.copy(alpha = 0.1f))
                        }
                    }

                    Spacer(Modifier.height(16.dp))
                    Button(
                        onClick = { quickSubTransactionsTx = null },
                        modifier = Modifier.fillMaxWidth().height(48.dp),
                        shape = RoundedCornerShape(14.dp),
                        colors = ButtonDefaults.buttonColors(containerColor = Color.White.copy(alpha = 0.12f), contentColor = Color.White)
                    ) {
                        Text("CHIUDI", fontWeight = FontWeight.Bold, color = Color.White)
                    }
                }
            }
        }
    }

    // ==========================================
    // 🚀 POPUP MOVIMENTI ACCORPATI
    // ==========================================
    groupDetailsTransactions?.let { groupList ->
        val firstTx = groupList.first()
        val cleanM = firstTx.merchantKey?.let { stripSystemMarker(it) }
        val cleanD = firstTx.description?.let { stripSystemMarker(it) }
        val displayName = (cleanM ?: cleanD ?: "MOVIMENTO").uppercase()
        val totalAmount = groupList.fold(0L) { acc, it -> acc + it.amountCents }

        val txDate = LocalDate.fromEpochDays(firstTx.dateEpochDay.toInt())
        val dateStr = "${txDate.dayOfMonth.toString().padStart(2, '0')}/${txDate.monthNumber.toString().padStart(2, '0')}/${txDate.year}"

        val totalAmountAbs = if(totalAmount < 0L) -totalAmount else totalAmount

        Dialog(
            onDismissRequest = { groupDetailsTransactions = null },
            properties = DialogProperties(usePlatformDefaultWidth = false)
        ) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.5f))
                    .blur(24.dp)
                    .clickable(
                        interactionSource = remember { MutableInteractionSource() },
                        indication = null,
                        onClick = { groupDetailsTransactions = null }
                    )
            )

            Surface(
                modifier = Modifier.padding(horizontal = 16.dp, vertical = 24.dp).fillMaxWidth().fillMaxHeight(0.75f),
                shape = RoundedCornerShape(28.dp),
                color = Color.White.copy(alpha = 0.12f),
                border = BorderStroke(1.5.dp, Color.White.copy(alpha = 0.40f)),
                shadowElevation = 0.dp
            ) {
                Column(modifier = Modifier.fillMaxSize().padding(24.dp)) {
                    Text("GRUPPO MOVIMENTI", style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.ExtraBold), color = Color(0xFF60A5FA))
                    Spacer(Modifier.height(4.dp))
                    Text(
                        "$displayName (${groupList.size})", 
                        style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Black), 
                        color = Color.White
                    )
                    Spacer(Modifier.height(2.dp))
                    Text(
                        "Data: $dateStr • Totale: ${formatEuroFromCents(totalAmountAbs, false)}", 
                        style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.SemiBold), 
                        color = Color.White.copy(alpha = 0.8f)
                    )

                    Spacer(Modifier.height(16.dp))
                    HorizontalDivider(color = Color.White.copy(alpha = 0.15f))
                    Spacer(Modifier.height(8.dp))

                    LazyColumn(
                        modifier = Modifier.weight(1f),
                        verticalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        items(groupList, key = { it.id }) { tx ->
                            Surface(
                                modifier = Modifier.fillMaxWidth(),
                                shape = RoundedCornerShape(16.dp),
                                color = Color(0xFF18181B).copy(alpha = 0.88f),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.12f))
                            ) {
                                // Riscriviamo i colori per i figli della surface scura per renderli bianchi
                                CompositionLocalProvider(LocalContentColor provides Color.White) {
                                    TransactionItemFlat(
                                        tx = tx, categoryNameById = categoryNameById, accountNameById = accountNameById, hideBalances = hideBalances, hiddenAccountIds = hiddenAccountIds,
                                        onAddFavorite = onAddFavorite,
                                        onOpenDetails = { detailsTransaction = it },
                                        selectionMode = selectionMode, isSelected = selectedTxIds.contains(tx.id), onToggleSelect = { toggleSelection(tx.id) }, onStartSelection = { selectionMode = true; selectedTxIds.add(tx.id) },
                                        subExpenses = subExpensesMap[tx.id], onOpenSubExpenses = { quickSubTransactionsTx = tx }
                                    )
                                }
                            }
                        }
                    }

                    Spacer(Modifier.height(16.dp))
                    Button(
                        onClick = { groupDetailsTransactions = null },
                        modifier = Modifier.fillMaxWidth().height(48.dp),
                        shape = RoundedCornerShape(14.dp),
                        colors = ButtonDefaults.buttonColors(containerColor = Color.White.copy(alpha = 0.15f), contentColor = Color.White)
                    ) {
                        Text("CHIUDI", fontWeight = FontWeight.Bold, color = Color.White)
                    }
                }
            }
        }
    }

// 🚀 PULIZIA MEMORIA: Se chiudiamo tutto, azzera la memoria per evitare strani loop
    if (detailsTransaction == null) {
        previousDetailsTransaction = null
    }

    // ==========================================
    // 🚀 POPUP DETTAGLI MOVIMENTO (FULL)
    // ==========================================
    detailsTransaction?.let { tx ->
        val isIncome = tx.type == "INCOME"
        val isExpense = tx.type == "EXPENSE"
        val isTransfer = tx.type == "TRANSFER"

        // 🚀 1. CERCHIAMO LA TRANSAZIONE PADRE
        val parentTx = remember(tx.id, allTransactions) {
            // 🚀 FIX: Andiamo a pescare il movimento ORIGINALE (crudo) per potergli leggere i tag nascosti come [p:ID]!
            val rawTx = allTransactions.find { it.id == tx.id } ?: tx

            val pId = when {
                rawTx.id.startsWith("tx_save_") -> rawTx.id.removePrefix("tx_save_")
                rawTx.id.startsWith("tx_refill_") -> rawTx.id.removePrefix("tx_refill_")
                rawTx.id.startsWith("tx_drain_") -> rawTx.id.removePrefix("tx_drain_")
                rawTx.id.startsWith("fee_") -> rawTx.id.removePrefix("fee_")
                else -> Regex("\\[p:([^\\]]+)\\]").find(rawTx.description ?: "")?.groupValues?.get(1)
                    ?: Regex("\\[p:([^\\]]+)\\]").find(rawTx.merchantKey ?: "")?.groupValues?.get(1)
            }
            pId?.let { pid -> allTransactions.find { it.id == pid } }
        }

        val accName = accountNameById[tx.accountId] ?: "CONTO"
        val toAccName = tx.toAccountId?.let { accountNameById[it] } ?: "CONTO"
        val catName = categoryNameById[tx.categoryId] ?: "ALTRO"

        val txDate = LocalDate.fromEpochDays(tx.dateEpochDay.toInt())
        val dateStr = "${txDate.dayOfMonth.toString().padStart(2, '0')}/${txDate.monthNumber.toString().padStart(2, '0')}/${txDate.year}"

        val amountColor = if (isTransfer) Color(0xFF60A5FA) else if (isIncome) Color(0xFF10B981) else Color.White
        val sign = if (isIncome) "+" else if (isTransfer) "" else "-"

        val cleanM = tx.merchantKey?.let { stripSystemMarker(it) }
        val cleanD = tx.description?.let { stripSystemMarker(it) }
        val displayName = (cleanM ?: cleanD ?: "MOVIMENTO").uppercase()
        val noteText = (tx.description ?: "").replace(Regex("\\[.*?\\]"), "").trim()
        val hasNotes = noteText.isNotBlank() && noteText != tx.merchantKey

        Dialog(
            onDismissRequest = {
                // 🚀 FIX: Torna al figlio se esiste, altrimenti chiudi tutto
                if (previousDetailsTransaction != null) {
                    detailsTransaction = previousDetailsTransaction
                    previousDetailsTransaction = null
                } else {
                    detailsTransaction = null
                }
            },
            properties = DialogProperties(usePlatformDefaultWidth = false)
        ) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.5f))
                    .blur(24.dp)
                    .clickable(
                        interactionSource = remember { MutableInteractionSource() },
                        indication = null,
                        onClick = { 
                            if (previousDetailsTransaction != null) {
                                detailsTransaction = previousDetailsTransaction
                                previousDetailsTransaction = null
                            } else {
                                detailsTransaction = null
                            }
                        }
                    )
            )

            Surface(
                modifier = Modifier
                    .padding(horizontal = 16.dp, vertical = 24.dp)
                    .fillMaxWidth()
                    .widthIn(max = 400.dp),
                shape = RoundedCornerShape(28.dp),
                color = Color.White.copy(alpha = 0.12f),
                border = BorderStroke(1.5.dp, Color.White.copy(alpha = 0.40f)),
                shadowElevation = 0.dp
            ) {
                Column(modifier = Modifier.fillMaxWidth().padding(24.dp)) {

                    Column(modifier = Modifier.fillMaxWidth().weight(1f, fill = false).verticalScroll(rememberScrollState())) {

                        Row(verticalAlignment = Alignment.CenterVertically) {
                            TxLogo(tx.logoEmoji, tx.logoUri, displayName, Modifier.size(54.dp))
                            Spacer(Modifier.width(16.dp))
                            Column(modifier = Modifier.weight(1f)) {
                                Text(text = displayName.uppercase(), style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Black, letterSpacing = 0.5.sp), color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                Text(text = if(isTransfer) "GIROCONTO" else catName.uppercase(), style = MaterialTheme.typography.bodySmall, color = Color(0xFF60A5FA), fontWeight = FontWeight.Bold)
                            }
                        }

                        Spacer(Modifier.height(24.dp))

                        Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                            ModernMoneyText(
                                cents = tx.amountCents,
                                hideBalances = false,
                                sign = sign,
                                color = amountColor,
                                integerFontSize = 38.sp,
                                decimalFontSize = 20.sp,
                                symbolFontSize = 20.sp
                            )
                        }

                        Spacer(Modifier.height(24.dp))

                        @Composable
                        fun InfoRow(label: String, value: String, isBold: Boolean = false, color: Color = Color.White) {
                            Row(modifier = Modifier.fillMaxWidth().padding(vertical = 5.dp), horizontalArrangement = Arrangement.SpaceBetween) {
                                Text(label, style = MaterialTheme.typography.bodyMedium, color = Color(0xFFA0A0A0))
                                Text(value, style = MaterialTheme.typography.bodyMedium.copy(fontWeight = if(isBold) FontWeight.ExtraBold else FontWeight.Medium), color = color)
                            }
                        }

                        Surface(
                            modifier = Modifier.fillMaxWidth(),
                            color = Color(0xFF2C2C2E),
                            shape = RoundedCornerShape(16.dp),
                            border = BorderStroke(1.dp, Color.White.copy(alpha = 0.05f))
                        ) {
                            Column(Modifier.padding(16.dp)) {
                                InfoRow("Data", dateStr, isBold = true)
                                if (isTransfer) {
                                    InfoRow("Da", accName)
                                    InfoRow("A", toAccName)
                                } else {
                                    InfoRow("Conto", accName)
                                }
                                InfoRow("Stato", if (tx.isHidden) "Nascosto" else "Visibile", color = if(tx.isHidden) MaterialTheme.colorScheme.error else Color(0xFF10B981))
                            }
                        }

                        if (hasNotes) {
                            Spacer(Modifier.height(16.dp))
                            Column(modifier = Modifier.fillMaxWidth().background(Color.White.copy(alpha = 0.05f), RoundedCornerShape(12.dp)).padding(16.dp)) {
                                Text("Note aggiuntive", style = MaterialTheme.typography.labelSmall, color = Color(0xFF60A5FA))
                                Spacer(Modifier.height(4.dp))
                                Text(noteText, style = MaterialTheme.typography.bodyMedium, color = Color.White)
                            }
                        }

                        // 🚀 FIX 4: SE ESISTE IL PADRE E NON È STATO VAPORIZZATO, MOSTRIAMO LA CARD CLICCABILE
                        if (parentTx != null && parentTx.categoryId != "sys_vaporized" && !parentTx.isHidden) {
                            Spacer(Modifier.height(16.dp))
                            Surface(
                                modifier = Modifier.fillMaxWidth().clickable {
                                    // 🚀 FIX: Memorizza l'arrotondamento attuale prima di viaggiare al padre!
                                    previousDetailsTransaction = tx
                                    detailsTransaction = parentTx
                                },
                                color = Color.White.copy(alpha = 0.08f),
                                shape = RoundedCornerShape(16.dp),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f))
                            ) {
                                Column(Modifier.padding(16.dp)) {
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        Icon(Icons.Outlined.Info, contentDescription = null, tint = Color(0xFF60A5FA), modifier = Modifier.size(18.dp))
                                        Spacer(Modifier.width(8.dp))
                                        Text("GENERATO DA:", style = MaterialTheme.typography.labelSmall, color = Color(0xFF60A5FA), fontWeight = FontWeight.Bold)
                                    }
                                    Spacer(Modifier.height(12.dp))
                                    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.SpaceBetween, modifier = Modifier.fillMaxWidth()) {
                                        val parentName = parentTx.merchantKey?.replace(Regex("\\[.*?\\]"), "")?.trim()?.takeIf { it.isNotBlank() } ?: parentTx.description?.replace(Regex("\\[.*?\\]"), "")?.trim() ?: "Spesa Principale"
                                        Column(modifier = Modifier.weight(1f)) {
                                            Text(parentName, style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold), color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                            Text("Tocca per i dettagli completi", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                                        }
                                        ModernMoneyText(
                                            cents = parentTx.amountCents,
                                            hideBalances = false,
                                            sign = if (parentTx.type == "INCOME") "+" else "-",
                                            color = if (parentTx.type == "INCOME") Color(0xFF10B981) else Color.White,
                                            integerFontSize = 14.sp, decimalFontSize = 10.sp, symbolFontSize = 10.sp
                                        )
                                    }
                                }
                            }
                        }

                        val rawTx = allTransactions.find { it.id == tx.id } ?: tx
                        val isLinkedToSavings = rawTx.merchantKey?.contains("[pb:", ignoreCase = true) == true ||
                                rawTx.description?.contains("[pb:", ignoreCase = true) == true

                        if (isLinkedToSavings) {
                            Button(
                                onClick = {
                                    detailsTransaction = null
                                    showSavingsSheet = true
                                },
                                modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp),
                                colors = ButtonDefaults.buttonColors(
                                    containerColor = Color.White.copy(alpha = 0.12f),
                                    contentColor = Color.White
                                ),
                                shape = RoundedCornerShape(12.dp)
                            ) {
                                Icon(Icons.Rounded.Savings, contentDescription = null, modifier = Modifier.size(18.dp), tint = Color.White)
                                Spacer(Modifier.width(8.dp))
                                Text("Gestisci Movimenti Salvadanaio", color = Color.White, fontWeight = FontWeight.Bold)
                            }
                        }

                        if (isExpense && !isCashSubTx(tx)) {
                            val subExpenses = subExpensesMap[tx.id] ?: emptyList()
                            val totalSubSpent = subExpenses.fold(0L) { acc, it -> acc + if(it.amountCents < 0L) -it.amountCents else it.amountCents }
                            val txCentsAbs = if(tx.amountCents < 0L) -tx.amountCents else tx.amountCents
                            val remainingCash = txCentsAbs - totalSubSpent
                            val cashProgress = if (txCentsAbs > 0L) (totalSubSpent.toFloat() / txCentsAbs.toFloat()).coerceIn(0f, 1f) else 0f

                            Spacer(Modifier.height(16.dp))
                            Surface(
                                modifier = Modifier.fillMaxWidth(),
                                color = Color.White.copy(alpha = 0.08f),
                                shape = RoundedCornerShape(16.dp),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f))
                            ) {
                                Column(Modifier.padding(16.dp)) {
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        Icon(Icons.Default.AccountBalanceWallet, contentDescription = null, tint = Color(0xFF60A5FA), modifier = Modifier.size(20.dp))
                                        Spacer(Modifier.width(8.dp))
                                        Text("SCOMPOSIZIONE / GESTIONE CONTANTE", style = MaterialTheme.typography.labelSmall, color = Color(0xFF60A5FA), fontWeight = FontWeight.Bold)
                                    }
                                    Spacer(Modifier.height(12.dp))

                                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                                        Text("Speso: ${formatEuroFromCents(totalSubSpent, false)}", style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0))
                                        Text("Rimanenza: ${formatEuroFromCents(remainingCash, false)}", style = MaterialTheme.typography.bodySmall.copy(fontWeight = FontWeight.Bold), color = if (remainingCash >= 0L) Color(0xFF10B981) else MaterialTheme.colorScheme.error)
                                    }
                                    Spacer(Modifier.height(6.dp))
                                    LinearProgressIndicator(
                                        progress = { cashProgress },
                                        modifier = Modifier.fillMaxWidth().height(6.dp).clip(CircleShape),
                                        color = Color(0xFF60A5FA),
                                        trackColor = Color.White.copy(alpha = 0.1f)
                                    )

                                    if (subExpenses.isNotEmpty()) {
                                        Spacer(Modifier.height(12.dp))
                                        Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                                            subExpenses.forEach { sub ->
                                                val subDate = LocalDate.fromEpochDays(sub.dateEpochDay.toInt())
                                                val dStr = "${subDate.dayOfMonth.toString().padStart(2, '0')}/${subDate.monthNumber.toString().padStart(2, '0')}"
                                                Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.SpaceBetween) {
                                                    Column(modifier = Modifier.weight(1f)) {
                                                        Text(sub.merchantKey?.replace(" 👻 (Promemoria)", "") ?: "Spesa", style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold), color = Color.White, maxLines = 1, overflow = TextOverflow.Ellipsis)
                                                        Text(dStr, style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                                                    }

                                                    // 🚀 DECIMAL FORMATTER
                                                    ModernMoneyText(
                                                        cents = sub.amountCents,
                                                        hideBalances = hideBalances,
                                                        color = Color.White,
                                                        integerFontSize = 14.sp,
                                                        decimalFontSize = 10.sp,
                                                        symbolFontSize = 10.sp
                                                    )

                                                    IconButton(
                                                        onClick = {
                                                            onDelete(allTransactions.find { it.id == sub.id } ?: sub)
                                                        },
                                                        modifier = Modifier.size(24.dp)
                                                    ) {
                                                        Icon(Icons.Outlined.Delete, null, tint = MaterialTheme.colorScheme.error, modifier = Modifier.size(16.dp))
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    Spacer(Modifier.height(16.dp))
                                    OutlinedButton(
                                        onClick = { targetCashTxId = tx.id },
                                        modifier = Modifier.fillMaxWidth().height(36.dp),
                                        shape = RoundedCornerShape(12.dp),
                                        colors = ButtonDefaults.outlinedButtonColors(contentColor = Color.White),
                                        border = BorderStroke(1.dp, Color.White.copy(alpha = 0.2f))
                                    ) {
                                        Icon(Icons.Default.Add, null, modifier = Modifier.size(16.dp))
                                        Spacer(Modifier.width(8.dp))
                                        Text("Aggiungi spesa in contanti", style = MaterialTheme.typography.labelMedium)
                                    }
                                }
                            }
                        }

                        Spacer(Modifier.height(24.dp))

                        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceEvenly) {
                            val rawTxForAction = allTransactions.find { it.id == tx.id } ?: tx

                            val isGhostTx = rawTxForAction.accountId?.startsWith("sys_ghost_") == true || rawTxForAction.accountId == "sys_ghost_tracker_account"
                            val ghostIcon = if (isGhostTx) Icons.Rounded.CheckCircle else Icons.Rounded.PendingActions
                            val ghostText = if (isGhostTx) "Fai Reale" else "Fantasma"

                            PopupActionIcon(ghostIcon, ghostText, Color(0xFF60A5FA), Modifier.weight(1f)) {
                                detailsTransaction = null
                                val newAccountId = if (isGhostTx) rawTxForAction.accountId?.removePrefix("sys_ghost_")?.takeIf { it != "tracker_account" } ?: accounts.firstOrNull { !it.isDeleted && !it.isArchived }?.id else "sys_ghost_${rawTxForAction.accountId}"
                                val newFromAcc = if (isGhostTx) rawTxForAction.fromAccountId?.removePrefix("sys_ghost_") else rawTxForAction.fromAccountId?.let { "sys_ghost_$it" }
                                val newToAcc = if (isGhostTx) rawTxForAction.toAccountId?.removePrefix("sys_ghost_") else rawTxForAction.toAccountId?.let { "sys_ghost_$it" }

                                onSaveTransaction(rawTxForAction.copy(
                                    accountId = newAccountId,
                                    fromAccountId = newFromAcc,
                                    toAccountId = newToAcc,
                                    updatedAtEpochMs = Clock.System.now().toEpochMilliseconds()
                                ))
                            }

                            PopupActionIcon(Icons.Rounded.AccountBalance, "Sposta", Color(0xFF60A5FA), Modifier.weight(1f)) {
                                detailsTransaction = null
                                targetChangeAccountTxIds = listOf(tx.id)
                            }

                            PopupActionIcon(Icons.Outlined.Edit, "Modifica", Color.White, Modifier.weight(1f)) {
                                detailsTransaction = null
                                onEdit(rawTxForAction)
                            }

                            val hideIcon = if (tx.isHidden) Icons.Outlined.Visibility else Icons.Outlined.VisibilityOff
                            PopupActionIcon(hideIcon, if (tx.isHidden) "Mostra" else "Nascondi", Color.White, Modifier.weight(1f)) {
                                detailsTransaction = null
                                if (tx.isHidden) {
                                    txToShow = tx
                                } else {
                                    txToHide = tx
                                }
                            }

                            PopupActionIcon(Icons.Outlined.Delete, "Elimina", MaterialTheme.colorScheme.error, Modifier.weight(1f)) {
                                detailsTransaction = null
                                transactionToDelete = rawTxForAction
                            }

                            // Sotto al tasto Elimina, aggiungi:
                            Column(
                                horizontalAlignment = Alignment.CenterHorizontally,
                                modifier = Modifier.weight(1f).clickable {
                                    detailsTransaction = null
                                    txToVaporize = rawTxForAction
                                }.padding(vertical = 8.dp, horizontal = 2.dp)
                            ) {
                                Box(contentAlignment = Alignment.Center, modifier = Modifier.size(24.dp)) {
                                    Text("💨", fontSize = 18.sp)
                                }
                                Spacer(Modifier.height(4.dp))
                                Text(
                                    text = "Vaporizza",
                                    style = MaterialTheme.typography.labelSmall.copy(fontSize = 10.sp),
                                    color = Color(0xFFA0A0A0),
                                    maxLines = 1,
                                    modifier = Modifier.basicMarquee() // 🚀 LA MAGIA ANCHE QUI!
                                )
                            }
                        }
                    }

                    Spacer(Modifier.height(16.dp))
                    Button(
                        onClick = {
                            // 🚀 FIX: Comportamento intelligente per il pulsante
                            if (previousDetailsTransaction != null) {
                                detailsTransaction = previousDetailsTransaction
                                previousDetailsTransaction = null
                            } else {
                                detailsTransaction = null
                            }
                        },
                        modifier = Modifier.fillMaxWidth().height(48.dp),
                        shape = RoundedCornerShape(14.dp),
                        colors = ButtonDefaults.buttonColors(containerColor = Color.White.copy(alpha = 0.12f), contentColor = Color.White)
                    ) {
                        Text(if (previousDetailsTransaction != null) "TORNA AL SALVADANAIO" else "CHIUDI", fontWeight = FontWeight.Bold, color = Color.White)
                    }
                }
            }
        }
    }

    // ==========================================
    // 🚀 MINI-POPUP: AGGIUNGI SPESA IN CONTANTI
    // ==========================================
    targetCashTxId?.let { parentTxId ->
        val parentTx = allTransactions.find { it.id == parentTxId }
        var subAmountText by remember { mutableStateOf("") }
        var subMerchant by remember { mutableStateOf("") }

        AlertDialog(
            onDismissRequest = { targetCashTxId = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = { Text("Spesa in Contanti", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color(0xFF60A5FA)) },
            text = {
                Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                    Text("I soldi verranno scalati dalla rimanenza di questa uscita, senza intaccare il saldo reale in banca.", style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0))

                    OutlinedTextField(
                        value = subMerchant,
                        onValueChange = { subMerchant = it },
                        label = { Text("Cosa hai comprato?", color = Color(0xFFA0A0A0)) },
                        singleLine = true,
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(12.dp),
                        colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF60A5FA), unfocusedBorderColor = Color.White.copy(alpha = 0.20f))
                    )
                    OutlinedTextField(
                        value = subAmountText,
                        onValueChange = { if (it.all { c -> c.isDigit() || c == ',' || c == '.' }) subAmountText = it },
                        label = { Text("Importo (€)", color = Color(0xFFA0A0A0)) },
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                        singleLine = true,
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(12.dp),
                        colors = OutlinedTextFieldDefaults.colors(focusedTextColor = Color.White, unfocusedTextColor = Color.White, focusedContainerColor = Color.Black.copy(alpha = 0.35f), unfocusedContainerColor = Color.Black.copy(alpha = 0.25f), focusedBorderColor = Color(0xFF60A5FA), unfocusedBorderColor = Color.White.copy(alpha = 0.20f))
                    )
                }
            },
            confirmButton = {
                Button(onClick = {
                    val cents = (subAmountText.replace(",", ".").toDoubleOrNull()?.times(100))?.toLong() ?: 0L

                    if (cents > 0L && parentTx != null) {
                        val cashRegex = Regex("\\[cash:${parentTx.id}\\]")
                        val existingSubs = allTransactions.filter {
                            !it.isDeleted && (cashRegex.containsMatchIn(it.description ?: "") || cashRegex.containsMatchIn(it.merchantKey ?: ""))
                        }

                        val totalMainCents = if(parentTx.amountCents < 0L) -parentTx.amountCents else parentTx.amountCents
                        val totalPendingCash = existingSubs.fold(0L) { acc, it -> acc + if(it.amountCents < 0L) -it.amountCents else it.amountCents }

                        if ((totalPendingCash + cents) > totalMainCents) {
                            haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                            showCashExceededWarning = true
                        } else {
                            val nowMs = Clock.System.now().toEpochMilliseconds()
                            val cashAccId = "sys_cash_${parentTx.accountId?.removePrefix("sys_ghost_") ?: "tracker_account"}"

                            val subTx = TransactionEntity(
                                id = "tx_cash_${nowMs}_${Random.nextInt(1000)}",
                                accountId = cashAccId,
                                toAccountId = null,
                                fromAccountId = null,
                                amountCents = cents,
                                type = "EXPENSE",
                                dateEpochDay = todayEpoch,
                                categoryId = "default",
                                description = "Spesa contanti [cash:${parentTx.id}]",
                                merchantKey = subMerchant.trim().ifBlank { "Contanti" },
                                subcategoryText = "Spesa Cash",
                                logoEmoji = "💶",
                                logoUri = null,
                                isHidden = false,
                                isDeleted = false,
                                reminderDays = null,
                                createdAtEpochMs = nowMs,
                                updatedAtEpochMs = nowMs
                            )
                            onSaveTransaction(subTx)
                            targetCashTxId = null
                        }
                    }
                }, shape = RoundedCornerShape(14.dp), colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF60A5FA), contentColor = Color.White)) {
                    Text("AGGIUNGI", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = {
                TextButton(onClick = { targetCashTxId = null }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) }
            }
        )
    }

    if (showExportDialog && fileExporter != null) {
        ExportPdfDialog(
            transactions = allTransactions.filter { !it.isDeleted },
            categories = categories,
            accounts = accounts,
            includeHidden = includeHiddenInExport,
            availableBalanceCents = availableBalanceCents,
            exporter = fileExporter,
            onDismiss = { showExportDialog = false }
        )
    }

    transactionToDelete?.let { tx ->
        AlertDialog(
            onDismissRequest = { transactionToDelete = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        Icons.Outlined.Delete,
                        contentDescription = null,
                        tint = MaterialTheme.colorScheme.error,
                        modifier = Modifier.size(24.dp)
                    )
                    Spacer(Modifier.width(8.dp))
                    Text(
                        "Elimina Movimento",
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                        color = MaterialTheme.colorScheme.error
                    )
                }
            },
            text = {
                Text(
                    "Vuoi davvero eliminare questo movimento?\nL'operazione è irreversibile e ricalcolerà il saldo.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = Color(0xFFA0A0A0)
                )
            },
            confirmButton = {
                Button(
                    onClick = { onDelete(tx); transactionToDelete = null },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(
                        containerColor = MaterialTheme.colorScheme.error,
                        contentColor = Color.White
                    )
                ) {
                    Text("ELIMINA", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = {
                TextButton(onClick = { transactionToDelete = null }) {
                    Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }
        )
    }

    dayTransactionsToDelete?.let { txs ->
        val dateStr = dayDateToDelete?.let { d -> when(d) { today -> "di oggi"; today.minus(DatePeriod(days = 1)) -> "di ieri"; else -> "del ${formatFullDate(d)}" } } ?: ""
        AlertDialog(
            onDismissRequest = { dayTransactionsToDelete = null; dayDateToDelete = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        Icons.Default.Delete,
                        contentDescription = null,
                        tint = MaterialTheme.colorScheme.error,
                        modifier = Modifier.size(24.dp)
                    )
                    Spacer(Modifier.width(8.dp))
                    Text(
                        "Svuota Intero Giorno",
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                        color = MaterialTheme.colorScheme.error
                    )
                }
            },
            text = {
                Text(
                    "Vuoi davvero eliminare TUTTI i ${txs.size} movimenti $dateStr?\nL'operazione è irreversibile e cancellerà in blocco questi dati.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = Color(0xFFA0A0A0)
                )
            },
            confirmButton = {
                Button(
                    onClick = { onDeleteMultiple(txs); dayTransactionsToDelete = null; dayDateToDelete = null },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(
                        containerColor = MaterialTheme.colorScheme.error,
                        contentColor = Color.White
                    )
                ) {
                    Text("ELIMINA TUTTO", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = {
                TextButton(onClick = { dayTransactionsToDelete = null; dayDateToDelete = null }) {
                    Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }
        )
    }

    if (showMultiDeleteConfirm) {
        AlertDialog(
            onDismissRequest = { showMultiDeleteConfirm = false },
            shape = RoundedCornerShape(24.dp), containerColor = MaterialTheme.colorScheme.surface,
            title = { Text("ELIMINA ${selectedTxIds.size} MOVIMENTI", style = MaterialTheme.typography.titleMedium) },
            text = { Text("Vuoi davvero eliminare i movimenti selezionati? L'operazione è irreversibile.", style = MaterialTheme.typography.bodyMedium) },
            confirmButton = {
                TextButton(onClick = {
                    val txsToDelete = latest.filter { it.id in selectedTxIds }
                    onDeleteMultiple(txsToDelete)
                    clearSelection()
                    showMultiDeleteConfirm = false
                }) { Text("ELIMINA TUTTO", color = MaterialTheme.colorScheme.error, fontWeight = FontWeight.Bold) }
            },
            dismissButton = { TextButton(onClick = { showMultiDeleteConfirm = false }) { Text("ANNULLA", color = MaterialTheme.colorScheme.onSurfaceVariant) } }
        )
    }

    if (showMultiVaporizeConfirm) {
        AlertDialog(
            onDismissRequest = { showMultiVaporizeConfirm = false },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Text(
                    "Vaporizza ${selectedTxIds.size} Movimenti 💨",
                    style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                    color = Color(0xFFEF4444)
                )
            },
            text = {
                Text(
                    "Vuoi davvero vaporizzare tutti i movimenti selezionati? Questa operazione distruggerà i dati originali (negozio, note, categoria) e li renderà invisibili, mantenendo i saldi intatti.\n\nIrreversibile.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = Color(0xFFA0A0A0)
                )
            },
            confirmButton = {
                Button(
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFEF4444), contentColor = Color.White),
                    onClick = {
                        val txsToVaporize = latest.filter { it.id in selectedTxIds }

                        // Cicla tutti i movimenti selezionati e li vaporizza uno per uno
                        txsToVaporize.forEach { tx ->
                            val tagRegex = Regex("\\[(pb|goal|pac_sav|sav|ACC|PAC|rec|fin|p|cash):[^\\]]+\\]", RegexOption.IGNORE_CASE)
                            val tagsInMerchant = tagRegex.findAll(tx.merchantKey ?: "").map { it.value }.joinToString(" ")
                            val tagsInDesc = tagRegex.findAll(tx.description ?: "").map { it.value }.joinToString(" ")
                            val preservedTags = "$tagsInMerchant $tagsInDesc".split(" ").filter { it.isNotBlank() }.distinct().joinToString(" ")

                            val newMerchantKey = if (preservedTags.isNotBlank()) "Conguaglio $preservedTags" else "Conguaglio"

                            val vaporizedTx = tx.copy(
                                description = "Allineamento di sistema",
                                merchantKey = newMerchantKey,
                                categoryId = "sys_vaporized",
                                subcategoryText = "Vaporizzato",
                                logoEmoji = "💨",
                                logoUri = null,
                                isHidden = true, // Sparisce alla vista
                                updatedAtEpochMs = Clock.System.now().toEpochMilliseconds()
                            )
                            onSaveTransaction(vaporizedTx)
                        }

                        scope.launch { snackbarHostState.showSnackbar("${txsToVaporize.size} movimenti vaporizzati. 💨", duration = SnackbarDuration.Short) }
                        clearSelection()
                        showMultiVaporizeConfirm = false
                    }
                ) {
                    Text("VAPORIZZA TUTTO", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = {
                TextButton(onClick = { showMultiVaporizeConfirm = false }) {
                    Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }
        )
    }

    if (showMultiHideConfirm) {
        AlertDialog(
            onDismissRequest = { showMultiHideConfirm = false },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        Icons.Outlined.VisibilityOff,
                        contentDescription = null,
                        tint = Color(0xFF60A5FA),
                        modifier = Modifier.size(24.dp)
                    )
                    Spacer(Modifier.width(8.dp))
                    Text(
                        "Nascondi ${selectedTxIds.size} Movimenti",
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                        color = Color.White
                    )
                }
            },
            text = {
                Text(
                    "Vuoi nascondere i movimenti selezionati?\nNon appariranno più nel saldo principale, ma potrai ritrovarli nel menu dei movimenti nascosti.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = Color(0xFFA0A0A0)
                )
            },
            confirmButton = {
                Button(
                    onClick = {
                        val txsToHide = latest.filter { it.id in selectedTxIds }
                        txsToHide.forEach { handleHideToggle(it, true) }
                        clearSelection()
                        showMultiHideConfirm = false
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF60A5FA), contentColor = Color.White)
                ) {
                    Text("NASCONDI", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = {
                TextButton(onClick = { showMultiHideConfirm = false }) {
                    Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }
        )
    }

    if (showMultiExportDialog && fileExporter != null) {
        ExportPdfDialog(
            transactions = allTransactions.filter { it.id in selectedTxIds && !it.isDeleted },
            categories = categories,
            accounts = accounts,
            includeHidden = true,
            availableBalanceCents = availableBalanceCents,
            exporter = fileExporter,
            onDismiss = {
                showMultiExportDialog = false
                clearSelection()
            }
        )
    }

    // ==========================================
    // 🚀 DIALOG PER CAMBIO CONTO RAPIDO
    // ==========================================
    targetChangeAccountTxIds?.let { txIds ->
        AlertDialog(
            onDismissRequest = { targetChangeAccountTxIds = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = { Text("Sposta su un altro conto", style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold), color = Color.White) },
            text = {
                LazyColumn(modifier = Modifier.fillMaxWidth().heightIn(max = 300.dp)) {
                    items(accounts.filter { !it.isDeleted && !it.isArchived }) { acc ->
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clip(RoundedCornerShape(12.dp))
                                .clickable {
                                    val txsToUpdate = latest.filter { it.id in txIds }
                                    txsToUpdate.forEach { tx ->
                                        val updatedTx = when (tx.type) {
                                            "TRANSFER" -> tx.copy(fromAccountId = acc.id, updatedAtEpochMs = Clock.System.now().toEpochMilliseconds())
                                            else -> tx.copy(accountId = acc.id, updatedAtEpochMs = Clock.System.now().toEpochMilliseconds())
                                        }
                                        onSaveTransaction(updatedTx)
                                    }
                                    clearSelection()
                                    targetChangeAccountTxIds = null
                                }
                                .padding(vertical = 12.dp, horizontal = 8.dp),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            TxLogo(acc.logoEmoji, acc.logoUri, acc.name, Modifier.size(32.dp))
                            Spacer(Modifier.width(12.dp))
                            Text(acc.name, style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold), color = Color.White)
                        }
                    }
                }
            },
            confirmButton = {
                TextButton(onClick = { targetChangeAccountTxIds = null }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) }
            }
        )
    }

    // ==========================================
    // 🚀 BOTTOM SHEET PER MOVIMENTI PROGRAMMATI
    // ==========================================
    if (showGhostSheet) {
        ModalBottomSheet(
            onDismissRequest = { showGhostSheet = false },
            containerColor = Color.White.copy(alpha = 0.12f),
            shape = RoundedCornerShape(topStart = 28.dp, topEnd = 28.dp)
        ) {
            Column(modifier = Modifier.fillMaxWidth().padding(horizontal = 24.dp, vertical = 16.dp)) {
                Text("Movimenti Programmati", style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Black), color = Color(0xFFF59E0B))

                Spacer(Modifier.height(16.dp))
                LazyColumn(modifier = Modifier.fillMaxWidth()) {
                    items(allProgrammati, key = { it.id }) { tx ->
                        TransactionItemFlat(
                            tx = tx, categoryNameById = categoryNameById, accountNameById = accountNameById, hideBalances = hideBalances, hiddenAccountIds = hiddenAccountIds,
                            onAddFavorite = onAddFavorite,
                            onOpenDetails = {
                                showGhostSheet = false
                                detailsTransaction = tx
                            },
                            selectionMode = selectionMode, isSelected = selectedTxIds.contains(tx.id), onToggleSelect = { toggleSelection(tx.id) }, onStartSelection = { selectionMode = true; selectedTxIds.add(tx.id) },
                            subExpenses = subExpensesMap[tx.id], onOpenSubExpenses = { quickSubTransactionsTx = tx }
                        )
                        HorizontalDivider(color = MaterialTheme.colorScheme.outline.copy(alpha = 0.05f))
                    }
                }
                Spacer(Modifier.height(24.dp))
            }
        }
    }
    if (showCashExceededWarning) {
        AlertDialog(
            onDismissRequest = { showCashExceededWarning = false },
            title = { Text("Importo Superato ⚠️", fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.error) },
            text = { Text("L'importo inserito supera il totale della spesa principale. Non puoi aggiungere più contanti di quanto speso originariamente.") },
            confirmButton = {
                TextButton(onClick = { showCashExceededWarning = false }) { Text("HO CAPITO") }
            }
        )
    }
    if (txToHide != null) {
        AlertDialog(
            onDismissRequest = { txToHide = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        Icons.Outlined.VisibilityOff,
                        contentDescription = null,
                        tint = Color(0xFF60A5FA),
                        modifier = Modifier.size(24.dp)
                    )
                    Spacer(Modifier.width(8.dp))
                    Text(
                        "Nascondi Movimento",
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                        color = Color.White
                    )
                }
            },
            text = {
                Text(
                    "Vuoi nascondere questo movimento?\nNon apparirà più nel saldo principale, ma potrai ritrovarlo nell'archivio dei movimenti nascosti.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = Color(0xFFA0A0A0)
                )
            },
            confirmButton = {
                Button(
                    onClick = {
                        txToHide?.let { tx ->
                            handleHideToggle(tx, true)
                        }
                        txToHide = null
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF60A5FA), contentColor = Color.White)
                ) {
                    Text("NASCONDI", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = {
                TextButton(onClick = { txToHide = null }) {
                    Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }
        )
    }

    if (txToShow != null) {
        AlertDialog(
            onDismissRequest = { txToShow = null },
            shape = RoundedCornerShape(28.dp),
            containerColor = Color.White.copy(alpha = 0.12f),
            title = {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        Icons.Outlined.Visibility,
                        contentDescription = null,
                        tint = Color(0xFF10B981),
                        modifier = Modifier.size(24.dp)
                    )
                    Spacer(Modifier.width(8.dp))
                    Text(
                        "Ripristina Movimento",
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                        color = Color.White
                    )
                }
            },
            text = {
                Text(
                    "Vuoi mostrare nuovamente questo movimento nel saldo principale?",
                    style = MaterialTheme.typography.bodyMedium,
                    color = Color(0xFFA0A0A0)
                )
            },
            confirmButton = {
                Button(
                    onClick = {
                        txToShow?.let { tx ->
                            handleHideToggle(tx, false)
                        }
                        txToShow = null
                    },
                    shape = RoundedCornerShape(14.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF10B981), contentColor = Color.White)
                ) {
                    Text("MOSTRA", fontWeight = FontWeight.Bold)
                }
            },
            dismissButton = {
                TextButton(onClick = { txToShow = null }) {
                    Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }
        )
    }

    // ==========================================
    // 🚀 POPUP RIEPILOGO GIORNALIERO
    // ==========================================
    if (daySummaryDate != null && daySummaryItems != null) {
        val dateStr = when (daySummaryDate) {
            today -> "di oggi"
            today.minus(DatePeriod(days = 1)) -> "di ieri"
            else -> "del ${formatFullDate(daySummaryDate!!)}"
        }

        // 🚀 FIX: Calcoliamo i totali escludendo matematicamente i "di cui" grazie all'ID e al Conto fantasma Cash
        val entrate = daySummaryItems!!.filter {
            it.type == "INCOME" && !it.id.startsWith("tx_cash_") && it.accountId?.startsWith("sys_cash_") != true && !(it.description?.contains("[cash:", ignoreCase = true) == true)
        }.fold(0L) { acc, it -> acc + it.amountCents }

        val uscite = daySummaryItems!!.filter {
            it.type == "EXPENSE" && !it.id.startsWith("tx_cash_") && it.accountId?.startsWith("sys_cash_") != true && !(it.description?.contains("[cash:", ignoreCase = true) == true)
        }.fold(0L) { acc, it -> acc + if(it.amountCents < 0L) -it.amountCents else it.amountCents }

        val trasferimenti = daySummaryItems!!.filter {
            it.type == "TRANSFER" && !it.id.startsWith("tx_cash_") && it.accountId?.startsWith("sys_cash_") != true && !(it.description?.contains("[cash:", ignoreCase = true) == true)
        }.fold(0L) { acc, it -> acc + if(it.amountCents < 0L) -it.amountCents else it.amountCents }

        AlertDialog(
            onDismissRequest = { daySummaryDate = null; daySummaryItems = null },
            shape = RoundedCornerShape(24.dp),
            containerColor = MaterialTheme.colorScheme.surface,
            title = { Text("Bilancio $dateStr", fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.primary) },
            text = {
                Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                    // Card Entrate
                    Surface(shape = RoundedCornerShape(12.dp), color = Color(0xFF10B981).copy(alpha = 0.1f), modifier = Modifier.fillMaxWidth()) {
                        Row(modifier = Modifier.padding(12.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                            Text("🟢 Entrate", fontWeight = FontWeight.Bold, color = Color(0xFF10B981))
                            Text("+ ${formatEuroFromCents(entrate, false)}", fontWeight = FontWeight.Bold, color = Color(0xFF10B981))
                        }
                    }
                    // Card Uscite
                    Surface(shape = RoundedCornerShape(12.dp), color = MaterialTheme.colorScheme.error.copy(alpha = 0.1f), modifier = Modifier.fillMaxWidth()) {
                        Row(modifier = Modifier.padding(12.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                            Text("🔴 Uscite", fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.error)
                            Text("- ${formatEuroFromCents(uscite, false)}", fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.error)
                        }
                    }
                    // Card Trasferimenti (opzionale, si mostra solo se ce ne sono stati)
                    if (trasferimenti > 0L) {
                        Surface(shape = RoundedCornerShape(12.dp), color = MaterialTheme.colorScheme.primary.copy(alpha = 0.1f), modifier = Modifier.fillMaxWidth()) {
                            Row(modifier = Modifier.padding(12.dp), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                                Text("🔄 Trasf.", fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.primary)
                                Text(formatEuroFromCents(trasferimenti, false), fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.primary)
                            }
                        }
                    }
                }
            },
            confirmButton = {
                Button(onClick = { daySummaryDate = null; daySummaryItems = null }) {
                    Text("CHIUDI", fontWeight = FontWeight.Bold)
                }
            }
        )
    }

}


@Composable
fun TransactionItemFlat(
    tx: TransactionEntity, categoryNameById: Map<String, String>, accountNameById: Map<String, String>, hideBalances: Boolean, hiddenAccountIds: Set<String>,
    onAddFavorite: (TransactionEntity) -> Unit, onOpenDetails: (TransactionEntity) -> Unit,
    selectionMode: Boolean, isSelected: Boolean, onToggleSelect: () -> Unit, onStartSelection: () -> Unit,
    subExpenses: List<TransactionEntity>? = null, // 🚀 NUOVO: LISTA DEI "DI CUI"
    onOpenSubExpenses: () -> Unit = {}            // 🚀 NUOVO: AZIONE PER APRIRE IL MINI-POPUP
) {
    val displayTx = if (tx.type == "EXPENSE" && tx.amountCents < 0) {
        tx.copy(amountCents = kotlin.math.abs(tx.amountCents), type = "INCOME")
    } else tx

    val rowBgColor by animateColorAsState(
        if (isSelected) MaterialTheme.colorScheme.primaryContainer.copy(alpha = 0.5f) else Color.Transparent
    )

    // 🚀 Feedback Aptico
    val haptic = LocalHapticFeedback.current

    val actualOnTap = {
        haptic.performHapticFeedback(HapticFeedbackType.TextHandleMove)
        if (selectionMode) onToggleSelect() else onOpenDetails(tx)
    }

    val actualOnLongPress = {
        haptic.performHapticFeedback(HapticFeedbackType.LongPress)
        if (selectionMode) onToggleSelect() else onStartSelection()
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(8.dp))
            .background(rowBgColor)
            .clickable(onClick = actualOnTap, indication = null, interactionSource = remember { MutableInteractionSource() })
            .padding(vertical = 4.dp)
    ) {
        Box(contentAlignment = Alignment.CenterStart) {

            TransactionRow(
                tx = displayTx, onTap = actualOnTap, onLongPressAddFavorite = actualOnLongPress,
                categoryNameById = categoryNameById, accountNameById = accountNameById, hideAmounts = (hideBalances || (tx.accountId?.let { hiddenAccountIds.contains(it) } == true))
            )

            Crossfade(
                targetState = isSelected,
                label = "animazione_spunta"
            ) { selected ->
                if (selected) {
                    Box(
                        modifier = Modifier
                            .padding(start = 16.dp)
                            .size(40.dp)
                            .background(MaterialTheme.colorScheme.surface, CircleShape),
                        contentAlignment = Alignment.Center
                    ) {
                        Icon(
                            imageVector = Icons.Rounded.CheckCircle,
                            contentDescription = "Selezionato",
                            tint = MaterialTheme.colorScheme.primary,
                            modifier = Modifier.size(32.dp)
                        )
                    }
                }
            }
        }

        if (!subExpenses.isNullOrEmpty()) {
            val totalSub = subExpenses.fold(0L) { acc, it -> acc + if(it.amountCents < 0L) -it.amountCents else it.amountCents }
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable { onOpenSubExpenses() }
                    .padding(start = 54.dp, end = 16.dp, top = 2.dp, bottom = 4.dp),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Text("↳", style = MaterialTheme.typography.bodyMedium, color = Color(0xFFF59E0B))
                    Spacer(Modifier.width(8.dp))
                    Text("${subExpenses.size} di cui in contanti", style = MaterialTheme.typography.labelSmall, color = Color(0xFFF59E0B))
                }
                // 🚀 DECIMAL FORMATTER PER I "DI CUI"
                ModernMoneyText(
                    cents = totalSub,
                    hideBalances = hideBalances,
                    sign = "-",
                    color = Color(0xFFF59E0B),
                    integerFontSize = 14.sp,
                    decimalFontSize = 10.sp,
                    symbolFontSize = 10.sp
                )
            }
        }

    }

}

@Composable
fun TransactionAccountFilter(accounts: List<AccountEntity>, selectedId: String?, onSelect: (String?) -> Unit) {
    LazyRow(modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp), horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
        item {
            val isSelected = selectedId == null
            Surface(
                onClick = { onSelect(null) },
                shape = RoundedCornerShape(20.dp),
                color = if (isSelected) Color.White.copy(alpha = 0.22f) else Color.White.copy(alpha = 0.08f),
                border = BorderStroke(1.dp, if (isSelected) Color.White.copy(alpha = 0.35f) else Color.White.copy(alpha = 0.12f))
            ) {
                Text(
                    text = "TUTTI I CONTI",
                    modifier = Modifier.padding(horizontal = 14.dp, vertical = 6.dp),
                    style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.Bold),
                    color = Color.White
                )
            }
        }
        items(accounts.filter { !it.isArchived && it.isVisible && !it.isDeleted }) { acc ->
            val isSelected = selectedId == acc.id
            Surface(
                onClick = { onSelect(acc.id) },
                shape = RoundedCornerShape(20.dp),
                color = if (isSelected) Color.White.copy(alpha = 0.22f) else Color.White.copy(alpha = 0.08f),
                border = BorderStroke(1.dp, if (isSelected) Color.White.copy(alpha = 0.35f) else Color.White.copy(alpha = 0.12f))
            ) {
                Text(
                    text = (stripSystemMarker(acc.name) ?: acc.name).uppercase(),
                    modifier = Modifier.padding(horizontal = 14.dp, vertical = 6.dp),
                    style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.Bold),
                    color = Color.White
                )
            }
        }
    }
}

@Composable
fun PopupActionIcon(icon: ImageVector, text: String, color: Color, modifier: Modifier = Modifier, onClick: () -> Unit) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = modifier.clickable { onClick() }.padding(vertical = 8.dp, horizontal = 2.dp)
    ) {
        Icon(icon, contentDescription = null, tint = color, modifier = Modifier.size(24.dp))
        Spacer(Modifier.height(4.dp))
        Text(
            text = text,
            style = MaterialTheme.typography.labelSmall.copy(fontSize = 10.sp),
            color = color,
            maxLines = 1, // 🚀 Fondamentale: impedisce di andare a capo
            modifier = Modifier.basicMarquee() // 🚀 LA MAGIA: fa scorrere morbidamente il testo lungo!
        )
    }
}

@Composable
fun ActionText(icon: ImageVector, text: String, onClick: () -> Unit) {
    Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.clickable { onClick() }.padding(8.dp)) {
        Icon(icon, contentDescription = null, tint = MaterialTheme.colorScheme.primary, modifier = Modifier.size(28.dp))
        Spacer(Modifier.height(4.dp))
        Text(text, style = MaterialTheme.typography.labelSmall, color = MaterialTheme.colorScheme.onBackground)
    }
}

// 🚀 Riconosce INFALLIBILMENTE PAC, Sogni, Salvadanai, Arrotondamenti e Sblocchi
fun isSavingsTx(tx: TransactionEntity): Boolean {
    val key = (tx.merchantKey ?: "").lowercase()
    val desc = (tx.description ?: "").lowercase()

    return key.contains("[pb:") ||
            key.contains("[sav:") ||
            key.contains("[pac_sav:") ||
            key.contains("[goal:") ||
            key.contains("salvadanaio") ||
            key.contains("arrotondamento") ||
            desc.contains("arrotondamento") ||
            desc.contains("versamento:") ||
            desc.contains("sblocco") ||
            desc.contains("pac") ||
            desc.contains("[pb:") ||
            desc.contains("[sav:") ||
            desc.contains("[pac_sav:") ||
            desc.contains("[goal:")
}